/*! jQuery v1.12.4 | (c) jQuery Foundation | jquery.org/license */
(function(a, b) {
    typeof module == "object" && typeof module.exports == "object" ? module.exports = a.document ? b(a, !0) : function(a2) {
        if (!a2.document) throw new Error("jQuery requires a window with a document");
        return b(a2)
    } : b(a)
})(typeof window < "u" ? window : this, function(a, b) {
    var c = [],
        d = a.document,
        e = c.slice,
        f = c.concat,
        g = c.push,
        h = c.indexOf,
        i = {},
        j = i.toString,
        k = i.hasOwnProperty,
        l = {},
        m = "1.12.4",
        n = function(a2, b2) {
            return new n.fn.init(a2, b2)
        },
        o = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
        p = /^-ms-/,
        q = /-([\da-z])/gi,
        r = function(a2, b2) {
            return b2.toUpperCase()
        };
    n.fn = n.prototype = {
        jquery: m,
        constructor: n,
        selector: "",
        length: 0,
        toArray: function() {
            return e.call(this)
        },
        get: function(a2) {
            return a2 != null ? 0 > a2 ? this[a2 + this.length] : this[a2] : e.call(this)
        },
        pushStack: function(a2) {
            var b2 = n.merge(this.constructor(), a2);
            return b2.prevObject = this, b2.context = this.context, b2
        },
        each: function(a2) {
            return n.each(this, a2)
        },
        map: function(a2) {
            return this.pushStack(n.map(this, function(b2, c2) {
                return a2.call(b2, c2, b2)
            }))
        },
        slice: function() {
            return this.pushStack(e.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        eq: function(a2) {
            var b2 = this.length,
                c2 = +a2 + (0 > a2 ? b2 : 0);
            return this.pushStack(c2 >= 0 && b2 > c2 ? [this[c2]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor()
        },
        push: g,
        sort: c.sort,
        splice: c.splice
    }, n.extend = n.fn.extend = function() {
        var a2, b2, c2, d2, e2, f2, g2 = arguments[0] || {},
            h2 = 1,
            i2 = arguments.length,
            j2 = !1;
        for (typeof g2 == "boolean" && (j2 = g2, g2 = arguments[h2] || {}, h2++), typeof g2 == "object" || n.isFunction(g2) || (g2 = {}), h2 === i2 && (g2 = this, h2--); i2 > h2; h2++)
            if ((e2 = arguments[h2]) != null)
                for (d2 in e2) a2 = g2[d2], c2 = e2[d2], g2 !== c2 && (j2 && c2 && (n.isPlainObject(c2) || (b2 = n.isArray(c2))) ? (b2 ? (b2 = !1, f2 = a2 && n.isArray(a2) ? a2 : []) : f2 = a2 && n.isPlainObject(a2) ? a2 : {}, g2[d2] = n.extend(j2, f2, c2)) : c2 !== void 0 && (g2[d2] = c2));
        return g2
    }, n.extend({
        expando: "jQuery" + (m + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(a2) {
            throw new Error(a2)
        },
        noop: function() {},
        isFunction: function(a2) {
            return n.type(a2) === "function"
        },
        isArray: Array.isArray || function(a2) {
            return n.type(a2) === "array"
        },
        isWindow: function(a2) {
            return a2 != null && a2 == a2.window
        },
        isNumeric: function(a2) {
            var b2 = a2 && a2.toString();
            return !n.isArray(a2) && b2 - parseFloat(b2) + 1 >= 0
        },
        isEmptyObject: function(a2) {
            var b2;
            for (b2 in a2) return !1;
            return !0
        },
        isPlainObject: function(a2) {
            var b2;
            if (!a2 || n.type(a2) !== "object" || a2.nodeType || n.isWindow(a2)) return !1;
            try {
                if (a2.constructor && !k.call(a2, "constructor") && !k.call(a2.constructor.prototype, "isPrototypeOf")) return !1
            } catch {
                return !1
            }
            if (!l.ownFirst)
                for (b2 in a2) return k.call(a2, b2);
            for (b2 in a2);
            return b2 === void 0 || k.call(a2, b2)
        },
        type: function(a2) {
            return a2 == null ? a2 + "" : typeof a2 == "object" || typeof a2 == "function" ? i[j.call(a2)] || "object" : typeof a2
        },
        globalEval: function(b2) {
            b2 && n.trim(b2) && (a.execScript || function(b3) {
                a.eval.call(a, b3)
            })(b2)
        },
        camelCase: function(a2) {
            return a2.replace(p, "ms-").replace(q, r)
        },
        nodeName: function(a2, b2) {
            return a2.nodeName && a2.nodeName.toLowerCase() === b2.toLowerCase()
        },
        each: function(a2, b2) {
            var c2, d2 = 0;
            if (s(a2))
                for (c2 = a2.length; c2 > d2 && b2.call(a2[d2], d2, a2[d2]) !== !1; d2++);
            else
                for (d2 in a2)
                    if (b2.call(a2[d2], d2, a2[d2]) === !1) break;
            return a2
        },
        trim: function(a2) {
            return a2 == null ? "" : (a2 + "").replace(o, "")
        },
        makeArray: function(a2, b2) {
            var c2 = b2 || [];
            return a2 != null && (s(Object(a2)) ? n.merge(c2, typeof a2 == "string" ? [a2] : a2) : g.call(c2, a2)), c2
        },
        inArray: function(a2, b2, c2) {
            var d2;
            if (b2) {
                if (h) return h.call(b2, a2, c2);
                for (d2 = b2.length, c2 = c2 ? 0 > c2 ? Math.max(0, d2 + c2) : c2 : 0; d2 > c2; c2++)
                    if (c2 in b2 && b2[c2] === a2) return c2
            }
            return -1
        },
        merge: function(a2, b2) {
            for (var c2 = +b2.length, d2 = 0, e2 = a2.length; c2 > d2;) a2[e2++] = b2[d2++];
            if (c2 !== c2)
                for (; b2[d2] !== void 0;) a2[e2++] = b2[d2++];
            return a2.length = e2, a2
        },
        grep: function(a2, b2, c2) {
            for (var d2, e2 = [], f2 = 0, g2 = a2.length, h2 = !c2; g2 > f2; f2++) d2 = !b2(a2[f2], f2), d2 !== h2 && e2.push(a2[f2]);
            return e2
        },
        map: function(a2, b2, c2) {
            var d2, e2, g2 = 0,
                h2 = [];
            if (s(a2))
                for (d2 = a2.length; d2 > g2; g2++) e2 = b2(a2[g2], g2, c2), e2 != null && h2.push(e2);
            else
                for (g2 in a2) e2 = b2(a2[g2], g2, c2), e2 != null && h2.push(e2);
            return f.apply([], h2)
        },
        guid: 1,
        proxy: function(a2, b2) {
            var c2, d2, f2;
            return typeof b2 == "string" && (f2 = a2[b2], b2 = a2, a2 = f2), n.isFunction(a2) ? (c2 = e.call(arguments, 2), d2 = function() {
                return a2.apply(b2 || this, c2.concat(e.call(arguments)))
            }, d2.guid = a2.guid = a2.guid || n.guid++, d2) : void 0
        },
        now: function() {
            return +new Date
        },
        support: l
    }), typeof Symbol == "function" && (n.fn[Symbol.iterator] = c[Symbol.iterator]), n.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(a2, b2) {
        i["[object " + b2 + "]"] = b2.toLowerCase()
    });

    function s(a2) {
        var b2 = !!a2 && "length" in a2 && a2.length,
            c2 = n.type(a2);
        return c2 === "function" || n.isWindow(a2) ? !1 : c2 === "array" || b2 === 0 || typeof b2 == "number" && b2 > 0 && b2 - 1 in a2
    }
    var t = function(a2) {
        var b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2, q2, r2, s2, t2, u2 = "sizzle" + 1 * new Date,
            v2 = a2.document,
            w2 = 0,
            x2 = 0,
            y2 = ga2(),
            z2 = ga2(),
            A2 = ga2(),
            B2 = function(a3, b3) {
                return a3 === b3 && (l2 = !0), 0
            },
            C2 = 1 << 31,
            D2 = {}.hasOwnProperty,
            E2 = [],
            F2 = E2.pop,
            G2 = E2.push,
            H2 = E2.push,
            I2 = E2.slice,
            J2 = function(a3, b3) {
                for (var c3 = 0, d3 = a3.length; d3 > c3; c3++)
                    if (a3[c3] === b3) return c3;
                return -1
            },
            K2 = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            L2 = "[\\x20\\t\\r\\n\\f]",
            M2 = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
            N2 = "\\[" + L2 + "*(" + M2 + ")(?:" + L2 + "*([*^$|!~]?=)" + L2 + `*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` + M2 + "))|)" + L2 + "*\\]",
            O2 = ":(" + M2 + `)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` + N2 + ")*)|.*)\\)|)",
            P2 = new RegExp(L2 + "+", "g"),
            Q2 = new RegExp("^" + L2 + "+|((?:^|[^\\\\])(?:\\\\.)*)" + L2 + "+$", "g"),
            R2 = new RegExp("^" + L2 + "*," + L2 + "*"),
            S2 = new RegExp("^" + L2 + "*([>+~]|" + L2 + ")" + L2 + "*"),
            T2 = new RegExp("=" + L2 + `*([^\\]'"]*?)` + L2 + "*\\]", "g"),
            U2 = new RegExp(O2),
            V2 = new RegExp("^" + M2 + "$"),
            W2 = {
                ID: new RegExp("^#(" + M2 + ")"),
                CLASS: new RegExp("^\\.(" + M2 + ")"),
                TAG: new RegExp("^(" + M2 + "|[*])"),
                ATTR: new RegExp("^" + N2),
                PSEUDO: new RegExp("^" + O2),
                CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + L2 + "*(even|odd|(([+-]|)(\\d*)n|)" + L2 + "*(?:([+-]|)" + L2 + "*(\\d+)|))" + L2 + "*\\)|)", "i"),
                bool: new RegExp("^(?:" + K2 + ")$", "i"),
                needsContext: new RegExp("^" + L2 + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + L2 + "*((?:-\\d)?\\d*)" + L2 + "*\\)|)(?=[^-]|$)", "i")
            },
            X2 = /^(?:input|select|textarea|button)$/i,
            Y2 = /^h\d$/i,
            Z2 = /^[^{]+\{\s*\[native \w/,
            $3 = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            _2 = /[+~]/,
            aa2 = /'|\\/g,
            ba2 = new RegExp("\\\\([\\da-f]{1,6}" + L2 + "?|(" + L2 + ")|.)", "ig"),
            ca2 = function(a3, b3, c3) {
                var d3 = "0x" + b3 - 65536;
                return d3 !== d3 || c3 ? b3 : 0 > d3 ? String.fromCharCode(d3 + 65536) : String.fromCharCode(d3 >> 10 | 55296, 1023 & d3 | 56320)
            },
            da2 = function() {
                m2()
            };
        try {
            H2.apply(E2 = I2.call(v2.childNodes), v2.childNodes), E2[v2.childNodes.length].nodeType
        } catch {
            H2 = {
                apply: E2.length ? function(a3, b3) {
                    G2.apply(a3, I2.call(b3))
                } : function(a3, b3) {
                    for (var c3 = a3.length, d3 = 0; a3[c3++] = b3[d3++];);
                    a3.length = c3 - 1
                }
            }
        }

        function fa2(a3, b3, d3, e3) {
            var f3, h3, j3, k3, l3, o3, r3, s3, w3 = b3 && b3.ownerDocument,
                x3 = b3 ? b3.nodeType : 9;
            if (d3 = d3 || [], typeof a3 != "string" || !a3 || x3 !== 1 && x3 !== 9 && x3 !== 11) return d3;
            if (!e3 && ((b3 ? b3.ownerDocument || b3 : v2) !== n2 && m2(b3), b3 = b3 || n2, p2)) {
                if (x3 !== 11 && (o3 = $3.exec(a3)))
                    if (f3 = o3[1]) {
                        if (x3 === 9) {
                            if (!(j3 = b3.getElementById(f3))) return d3;
                            if (j3.id === f3) return d3.push(j3), d3
                        } else if (w3 && (j3 = w3.getElementById(f3)) && t2(b3, j3) && j3.id === f3) return d3.push(j3), d3
                    } else {
                        if (o3[2]) return H2.apply(d3, b3.getElementsByTagName(a3)), d3;
                        if ((f3 = o3[3]) && c2.getElementsByClassName && b3.getElementsByClassName) return H2.apply(d3, b3.getElementsByClassName(f3)), d3
                    } if (c2.qsa && !A2[a3 + " "] && (!q2 || !q2.test(a3))) {
                    if (x3 !== 1) w3 = b3, s3 = a3;
                    else if (b3.nodeName.toLowerCase() !== "object") {
                        for ((k3 = b3.getAttribute("id")) ? k3 = k3.replace(aa2, "\\$&") : b3.setAttribute("id", k3 = u2), r3 = g2(a3), h3 = r3.length, l3 = V2.test(k3) ? "#" + k3 : "[id='" + k3 + "']"; h3--;) r3[h3] = l3 + " " + qa2(r3[h3]);
                        s3 = r3.join(","), w3 = _2.test(a3) && oa2(b3.parentNode) || b3
                    }
                    if (s3) try {
                        return H2.apply(d3, w3.querySelectorAll(s3)), d3
                    } catch {} finally {
                        k3 === u2 && b3.removeAttribute("id")
                    }
                }
            }
            return i2(a3.replace(Q2, "$1"), b3, d3, e3)
        }

        function ga2() {
            var a3 = [];

            function b3(c3, e3) {
                return a3.push(c3 + " ") > d2.cacheLength && delete b3[a3.shift()], b3[c3 + " "] = e3
            }
            return b3
        }

        function ha2(a3) {
            return a3[u2] = !0, a3
        }

        function ia2(a3) {
            var b3 = n2.createElement("div");
            try {
                return !!a3(b3)
            } catch {
                return !1
            } finally {
                b3.parentNode && b3.parentNode.removeChild(b3), b3 = null
            }
        }

        function ja2(a3, b3) {
            for (var c3 = a3.split("|"), e3 = c3.length; e3--;) d2.attrHandle[c3[e3]] = b3
        }

        function ka2(a3, b3) {
            var c3 = b3 && a3,
                d3 = c3 && a3.nodeType === 1 && b3.nodeType === 1 && (~b3.sourceIndex || C2) - (~a3.sourceIndex || C2);
            if (d3) return d3;
            if (c3) {
                for (; c3 = c3.nextSibling;)
                    if (c3 === b3) return -1
            }
            return a3 ? 1 : -1
        }

        function la2(a3) {
            return function(b3) {
                var c3 = b3.nodeName.toLowerCase();
                return c3 === "input" && b3.type === a3
            }
        }

        function ma2(a3) {
            return function(b3) {
                var c3 = b3.nodeName.toLowerCase();
                return (c3 === "input" || c3 === "button") && b3.type === a3
            }
        }

        function na2(a3) {
            return ha2(function(b3) {
                return b3 = +b3, ha2(function(c3, d3) {
                    for (var e3, f3 = a3([], c3.length, b3), g3 = f3.length; g3--;) c3[e3 = f3[g3]] && (c3[e3] = !(d3[e3] = c3[e3]))
                })
            })
        }

        function oa2(a3) {
            return a3 && typeof a3.getElementsByTagName < "u" && a3
        }
        c2 = fa2.support = {}, f2 = fa2.isXML = function(a3) {
            var b3 = a3 && (a3.ownerDocument || a3).documentElement;
            return b3 ? b3.nodeName !== "HTML" : !1
        }, m2 = fa2.setDocument = function(a3) {
            var b3, e3, g3 = a3 ? a3.ownerDocument || a3 : v2;
            return g3 !== n2 && g3.nodeType === 9 && g3.documentElement && (n2 = g3, o2 = n2.documentElement, p2 = !f2(n2), (e3 = n2.defaultView) && e3.top !== e3 && (e3.addEventListener ? e3.addEventListener("unload", da2, !1) : e3.attachEvent && e3.attachEvent("onunload", da2)), c2.attributes = ia2(function(a4) {
                return a4.className = "i", !a4.getAttribute("className")
            }), c2.getElementsByTagName = ia2(function(a4) {
                return a4.appendChild(n2.createComment("")), !a4.getElementsByTagName("*").length
            }), c2.getElementsByClassName = Z2.test(n2.getElementsByClassName), c2.getById = ia2(function(a4) {
                return o2.appendChild(a4).id = u2, !n2.getElementsByName || !n2.getElementsByName(u2).length
            }), c2.getById ? (d2.find.ID = function(a4, b4) {
                if (typeof b4.getElementById < "u" && p2) {
                    var c3 = b4.getElementById(a4);
                    return c3 ? [c3] : []
                }
            }, d2.filter.ID = function(a4) {
                var b4 = a4.replace(ba2, ca2);
                return function(a5) {
                    return a5.getAttribute("id") === b4
                }
            }) : (delete d2.find.ID, d2.filter.ID = function(a4) {
                var b4 = a4.replace(ba2, ca2);
                return function(a5) {
                    var c3 = typeof a5.getAttributeNode < "u" && a5.getAttributeNode("id");
                    return c3 && c3.value === b4
                }
            }), d2.find.TAG = c2.getElementsByTagName ? function(a4, b4) {
                return typeof b4.getElementsByTagName < "u" ? b4.getElementsByTagName(a4) : c2.qsa ? b4.querySelectorAll(a4) : void 0
            } : function(a4, b4) {
                var c3, d3 = [],
                    e4 = 0,
                    f3 = b4.getElementsByTagName(a4);
                if (a4 === "*") {
                    for (; c3 = f3[e4++];) c3.nodeType === 1 && d3.push(c3);
                    return d3
                }
                return f3
            }, d2.find.CLASS = c2.getElementsByClassName && function(a4, b4) {
                return typeof b4.getElementsByClassName < "u" && p2 ? b4.getElementsByClassName(a4) : void 0
            }, r2 = [], q2 = [], (c2.qsa = Z2.test(n2.querySelectorAll)) && (ia2(function(a4) {
                o2.appendChild(a4).innerHTML = "<a id='" + u2 + "'></a><select id='" + u2 + "-\r\\' msallowcapture=''><option selected=''></option></select>", a4.querySelectorAll("[msallowcapture^='']").length && q2.push("[*^$]=" + L2 + `*(?:''|"")`), a4.querySelectorAll("[selected]").length || q2.push("\\[" + L2 + "*(?:value|" + K2 + ")"), a4.querySelectorAll("[id~=" + u2 + "-]").length || q2.push("~="), a4.querySelectorAll(":checked").length || q2.push(":checked"), a4.querySelectorAll("a#" + u2 + "+*").length || q2.push(".#.+[+~]")
            }), ia2(function(a4) {
                var b4 = n2.createElement("input");
                b4.setAttribute("type", "hidden"), a4.appendChild(b4).setAttribute("name", "D"), a4.querySelectorAll("[name=d]").length && q2.push("name" + L2 + "*[*^$|!~]?="), a4.querySelectorAll(":enabled").length || q2.push(":enabled", ":disabled"), a4.querySelectorAll("*,:x"), q2.push(",.*:")
            })), (c2.matchesSelector = Z2.test(s2 = o2.matches || o2.webkitMatchesSelector || o2.mozMatchesSelector || o2.oMatchesSelector || o2.msMatchesSelector)) && ia2(function(a4) {
                c2.disconnectedMatch = s2.call(a4, "div"), s2.call(a4, "[s!='']:x"), r2.push("!=", O2)
            }), q2 = q2.length && new RegExp(q2.join("|")), r2 = r2.length && new RegExp(r2.join("|")), b3 = Z2.test(o2.compareDocumentPosition), t2 = b3 || Z2.test(o2.contains) ? function(a4, b4) {
                var c3 = a4.nodeType === 9 ? a4.documentElement : a4,
                    d3 = b4 && b4.parentNode;
                return a4 === d3 || !(!d3 || d3.nodeType !== 1 || !(c3.contains ? c3.contains(d3) : a4.compareDocumentPosition && 16 & a4.compareDocumentPosition(d3)))
            } : function(a4, b4) {
                if (b4) {
                    for (; b4 = b4.parentNode;)
                        if (b4 === a4) return !0
                }
                return !1
            }, B2 = b3 ? function(a4, b4) {
                if (a4 === b4) return l2 = !0, 0;
                var d3 = !a4.compareDocumentPosition - !b4.compareDocumentPosition;
                return d3 || (d3 = (a4.ownerDocument || a4) === (b4.ownerDocument || b4) ? a4.compareDocumentPosition(b4) : 1, 1 & d3 || !c2.sortDetached && b4.compareDocumentPosition(a4) === d3 ? a4 === n2 || a4.ownerDocument === v2 && t2(v2, a4) ? -1 : b4 === n2 || b4.ownerDocument === v2 && t2(v2, b4) ? 1 : k2 ? J2(k2, a4) - J2(k2, b4) : 0 : 4 & d3 ? -1 : 1)
            } : function(a4, b4) {
                if (a4 === b4) return l2 = !0, 0;
                var c3, d3 = 0,
                    e4 = a4.parentNode,
                    f3 = b4.parentNode,
                    g4 = [a4],
                    h3 = [b4];
                if (!e4 || !f3) return a4 === n2 ? -1 : b4 === n2 ? 1 : e4 ? -1 : f3 ? 1 : k2 ? J2(k2, a4) - J2(k2, b4) : 0;
                if (e4 === f3) return ka2(a4, b4);
                for (c3 = a4; c3 = c3.parentNode;) g4.unshift(c3);
                for (c3 = b4; c3 = c3.parentNode;) h3.unshift(c3);
                for (; g4[d3] === h3[d3];) d3++;
                return d3 ? ka2(g4[d3], h3[d3]) : g4[d3] === v2 ? -1 : h3[d3] === v2 ? 1 : 0
            }), n2
        }, fa2.matches = function(a3, b3) {
            return fa2(a3, null, null, b3)
        }, fa2.matchesSelector = function(a3, b3) {
            if ((a3.ownerDocument || a3) !== n2 && m2(a3), b3 = b3.replace(T2, "='$1']"), c2.matchesSelector && p2 && !A2[b3 + " "] && (!r2 || !r2.test(b3)) && (!q2 || !q2.test(b3))) try {
                var d3 = s2.call(a3, b3);
                if (d3 || c2.disconnectedMatch || a3.document && a3.document.nodeType !== 11) return d3
            } catch {}
            return fa2(b3, n2, null, [a3]).length > 0
        }, fa2.contains = function(a3, b3) {
            return (a3.ownerDocument || a3) !== n2 && m2(a3), t2(a3, b3)
        }, fa2.attr = function(a3, b3) {
            (a3.ownerDocument || a3) !== n2 && m2(a3);
            var e3 = d2.attrHandle[b3.toLowerCase()],
                f3 = e3 && D2.call(d2.attrHandle, b3.toLowerCase()) ? e3(a3, b3, !p2) : void 0;
            return f3 !== void 0 ? f3 : c2.attributes || !p2 ? a3.getAttribute(b3) : (f3 = a3.getAttributeNode(b3)) && f3.specified ? f3.value : null
        }, fa2.error = function(a3) {
            throw new Error("Syntax error, unrecognized expression: " + a3)
        }, fa2.uniqueSort = function(a3) {
            var b3, d3 = [],
                e3 = 0,
                f3 = 0;
            if (l2 = !c2.detectDuplicates, k2 = !c2.sortStable && a3.slice(0), a3.sort(B2), l2) {
                for (; b3 = a3[f3++];) b3 === a3[f3] && (e3 = d3.push(f3));
                for (; e3--;) a3.splice(d3[e3], 1)
            }
            return k2 = null, a3
        }, e2 = fa2.getText = function(a3) {
            var b3, c3 = "",
                d3 = 0,
                f3 = a3.nodeType;
            if (f3) {
                if (f3 === 1 || f3 === 9 || f3 === 11) {
                    if (typeof a3.textContent == "string") return a3.textContent;
                    for (a3 = a3.firstChild; a3; a3 = a3.nextSibling) c3 += e2(a3)
                } else if (f3 === 3 || f3 === 4) return a3.nodeValue
            } else
                for (; b3 = a3[d3++];) c3 += e2(b3);
            return c3
        }, d2 = fa2.selectors = {
            cacheLength: 50,
            createPseudo: ha2,
            match: W2,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: !0
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: !0
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(a3) {
                    return a3[1] = a3[1].replace(ba2, ca2), a3[3] = (a3[3] || a3[4] || a3[5] || "").replace(ba2, ca2), a3[2] === "~=" && (a3[3] = " " + a3[3] + " "), a3.slice(0, 4)
                },
                CHILD: function(a3) {
                    return a3[1] = a3[1].toLowerCase(), a3[1].slice(0, 3) === "nth" ? (a3[3] || fa2.error(a3[0]), a3[4] = +(a3[4] ? a3[5] + (a3[6] || 1) : 2 * (a3[3] === "even" || a3[3] === "odd")), a3[5] = +(a3[7] + a3[8] || a3[3] === "odd")) : a3[3] && fa2.error(a3[0]), a3
                },
                PSEUDO: function(a3) {
                    var b3, c3 = !a3[6] && a3[2];
                    return W2.CHILD.test(a3[0]) ? null : (a3[3] ? a3[2] = a3[4] || a3[5] || "" : c3 && U2.test(c3) && (b3 = g2(c3, !0)) && (b3 = c3.indexOf(")", c3.length - b3) - c3.length) && (a3[0] = a3[0].slice(0, b3), a3[2] = c3.slice(0, b3)), a3.slice(0, 3))
                }
            },
            filter: {
                TAG: function(a3) {
                    var b3 = a3.replace(ba2, ca2).toLowerCase();
                    return a3 === "*" ? function() {
                        return !0
                    } : function(a4) {
                        return a4.nodeName && a4.nodeName.toLowerCase() === b3
                    }
                },
                CLASS: function(a3) {
                    var b3 = y2[a3 + " "];
                    return b3 || (b3 = new RegExp("(^|" + L2 + ")" + a3 + "(" + L2 + "|$)")) && y2(a3, function(a4) {
                        return b3.test(typeof a4.className == "string" && a4.className || typeof a4.getAttribute < "u" && a4.getAttribute("class") || "")
                    })
                },
                ATTR: function(a3, b3, c3) {
                    return function(d3) {
                        var e3 = fa2.attr(d3, a3);
                        return e3 == null ? b3 === "!=" : b3 ? (e3 += "", b3 === "=" ? e3 === c3 : b3 === "!=" ? e3 !== c3 : b3 === "^=" ? c3 && e3.indexOf(c3) === 0 : b3 === "*=" ? c3 && e3.indexOf(c3) > -1 : b3 === "$=" ? c3 && e3.slice(-c3.length) === c3 : b3 === "~=" ? (" " + e3.replace(P2, " ") + " ").indexOf(c3) > -1 : b3 === "|=" ? e3 === c3 || e3.slice(0, c3.length + 1) === c3 + "-" : !1) : !0
                    }
                },
                CHILD: function(a3, b3, c3, d3, e3) {
                    var f3 = a3.slice(0, 3) !== "nth",
                        g3 = a3.slice(-4) !== "last",
                        h3 = b3 === "of-type";
                    return d3 === 1 && e3 === 0 ? function(a4) {
                        return !!a4.parentNode
                    } : function(b4, c4, i3) {
                        var j3, k3, l3, m3, n3, o3, p3 = f3 !== g3 ? "nextSibling" : "previousSibling",
                            q3 = b4.parentNode,
                            r3 = h3 && b4.nodeName.toLowerCase(),
                            s3 = !i3 && !h3,
                            t3 = !1;
                        if (q3) {
                            if (f3) {
                                for (; p3;) {
                                    for (m3 = b4; m3 = m3[p3];)
                                        if (h3 ? m3.nodeName.toLowerCase() === r3 : m3.nodeType === 1) return !1;
                                    o3 = p3 = a3 === "only" && !o3 && "nextSibling"
                                }
                                return !0
                            }
                            if (o3 = [g3 ? q3.firstChild : q3.lastChild], g3 && s3) {
                                for (m3 = q3, l3 = m3[u2] || (m3[u2] = {}), k3 = l3[m3.uniqueID] || (l3[m3.uniqueID] = {}), j3 = k3[a3] || [], n3 = j3[0] === w2 && j3[1], t3 = n3 && j3[2], m3 = n3 && q3.childNodes[n3]; m3 = ++n3 && m3 && m3[p3] || (t3 = n3 = 0) || o3.pop();)
                                    if (m3.nodeType === 1 && ++t3 && m3 === b4) {
                                        k3[a3] = [w2, n3, t3];
                                        break
                                    }
                            } else if (s3 && (m3 = b4, l3 = m3[u2] || (m3[u2] = {}), k3 = l3[m3.uniqueID] || (l3[m3.uniqueID] = {}), j3 = k3[a3] || [], n3 = j3[0] === w2 && j3[1], t3 = n3), t3 === !1)
                                for (;
                                    (m3 = ++n3 && m3 && m3[p3] || (t3 = n3 = 0) || o3.pop()) && !((h3 ? m3.nodeName.toLowerCase() === r3 : m3.nodeType === 1) && ++t3 && (s3 && (l3 = m3[u2] || (m3[u2] = {}), k3 = l3[m3.uniqueID] || (l3[m3.uniqueID] = {}), k3[a3] = [w2, t3]), m3 === b4)););
                            return t3 -= e3, t3 === d3 || t3 % d3 === 0 && t3 / d3 >= 0
                        }
                    }
                },
                PSEUDO: function(a3, b3) {
                    var c3, e3 = d2.pseudos[a3] || d2.setFilters[a3.toLowerCase()] || fa2.error("unsupported pseudo: " + a3);
                    return e3[u2] ? e3(b3) : e3.length > 1 ? (c3 = [a3, a3, "", b3], d2.setFilters.hasOwnProperty(a3.toLowerCase()) ? ha2(function(a4, c4) {
                        for (var d3, f3 = e3(a4, b3), g3 = f3.length; g3--;) d3 = J2(a4, f3[g3]), a4[d3] = !(c4[d3] = f3[g3])
                    }) : function(a4) {
                        return e3(a4, 0, c3)
                    }) : e3
                }
            },
            pseudos: {
                not: ha2(function(a3) {
                    var b3 = [],
                        c3 = [],
                        d3 = h2(a3.replace(Q2, "$1"));
                    return d3[u2] ? ha2(function(a4, b4, c4, e3) {
                        for (var f3, g3 = d3(a4, null, e3, []), h3 = a4.length; h3--;)(f3 = g3[h3]) && (a4[h3] = !(b4[h3] = f3))
                    }) : function(a4, e3, f3) {
                        return b3[0] = a4, d3(b3, null, f3, c3), b3[0] = null, !c3.pop()
                    }
                }),
                has: ha2(function(a3) {
                    return function(b3) {
                        return fa2(a3, b3).length > 0
                    }
                }),
                contains: ha2(function(a3) {
                    return a3 = a3.replace(ba2, ca2),
                        function(b3) {
                            return (b3.textContent || b3.innerText || e2(b3)).indexOf(a3) > -1
                        }
                }),
                lang: ha2(function(a3) {
                    return V2.test(a3 || "") || fa2.error("unsupported lang: " + a3), a3 = a3.replace(ba2, ca2).toLowerCase(),
                        function(b3) {
                            var c3;
                            do
                                if (c3 = p2 ? b3.lang : b3.getAttribute("xml:lang") || b3.getAttribute("lang")) return c3 = c3.toLowerCase(), c3 === a3 || c3.indexOf(a3 + "-") === 0; while ((b3 = b3.parentNode) && b3.nodeType === 1);
                            return !1
                        }
                }),
                target: function(b3) {
                    var c3 = a2.location && a2.location.hash;
                    return c3 && c3.slice(1) === b3.id
                },
                root: function(a3) {
                    return a3 === o2
                },
                focus: function(a3) {
                    return a3 === n2.activeElement && (!n2.hasFocus || n2.hasFocus()) && !!(a3.type || a3.href || ~a3.tabIndex)
                },
                enabled: function(a3) {
                    return a3.disabled === !1
                },
                disabled: function(a3) {
                    return a3.disabled === !0
                },
                checked: function(a3) {
                    var b3 = a3.nodeName.toLowerCase();
                    return b3 === "input" && !!a3.checked || b3 === "option" && !!a3.selected
                },
                selected: function(a3) {
                    return a3.parentNode && a3.parentNode.selectedIndex, a3.selected === !0
                },
                empty: function(a3) {
                    for (a3 = a3.firstChild; a3; a3 = a3.nextSibling)
                        if (a3.nodeType < 6) return !1;
                    return !0
                },
                parent: function(a3) {
                    return !d2.pseudos.empty(a3)
                },
                header: function(a3) {
                    return Y2.test(a3.nodeName)
                },
                input: function(a3) {
                    return X2.test(a3.nodeName)
                },
                button: function(a3) {
                    var b3 = a3.nodeName.toLowerCase();
                    return b3 === "input" && a3.type === "button" || b3 === "button"
                },
                text: function(a3) {
                    var b3;
                    return a3.nodeName.toLowerCase() === "input" && a3.type === "text" && ((b3 = a3.getAttribute("type")) == null || b3.toLowerCase() === "text")
                },
                first: na2(function() {
                    return [0]
                }),
                last: na2(function(a3, b3) {
                    return [b3 - 1]
                }),
                eq: na2(function(a3, b3, c3) {
                    return [0 > c3 ? c3 + b3 : c3]
                }),
                even: na2(function(a3, b3) {
                    for (var c3 = 0; b3 > c3; c3 += 2) a3.push(c3);
                    return a3
                }),
                odd: na2(function(a3, b3) {
                    for (var c3 = 1; b3 > c3; c3 += 2) a3.push(c3);
                    return a3
                }),
                lt: na2(function(a3, b3, c3) {
                    for (var d3 = 0 > c3 ? c3 + b3 : c3; --d3 >= 0;) a3.push(d3);
                    return a3
                }),
                gt: na2(function(a3, b3, c3) {
                    for (var d3 = 0 > c3 ? c3 + b3 : c3; ++d3 < b3;) a3.push(d3);
                    return a3
                })
            }
        }, d2.pseudos.nth = d2.pseudos.eq;
        for (b2 in {
                radio: !0,
                checkbox: !0,
                file: !0,
                password: !0,
                image: !0
            }) d2.pseudos[b2] = la2(b2);
        for (b2 in {
                submit: !0,
                reset: !0
            }) d2.pseudos[b2] = ma2(b2);

        function pa2() {}
        pa2.prototype = d2.filters = d2.pseudos, d2.setFilters = new pa2, g2 = fa2.tokenize = function(a3, b3) {
            var c3, e3, f3, g3, h3, i3, j3, k3 = z2[a3 + " "];
            if (k3) return b3 ? 0 : k3.slice(0);
            for (h3 = a3, i3 = [], j3 = d2.preFilter; h3;) {
                c3 && !(e3 = R2.exec(h3)) || (e3 && (h3 = h3.slice(e3[0].length) || h3), i3.push(f3 = [])), c3 = !1, (e3 = S2.exec(h3)) && (c3 = e3.shift(), f3.push({
                    value: c3,
                    type: e3[0].replace(Q2, " ")
                }), h3 = h3.slice(c3.length));
                for (g3 in d2.filter) !(e3 = W2[g3].exec(h3)) || j3[g3] && !(e3 = j3[g3](e3)) || (c3 = e3.shift(), f3.push({
                    value: c3,
                    type: g3,
                    matches: e3
                }), h3 = h3.slice(c3.length));
                if (!c3) break
            }
            return b3 ? h3.length : h3 ? fa2.error(a3) : z2(a3, i3).slice(0)
        };

        function qa2(a3) {
            for (var b3 = 0, c3 = a3.length, d3 = ""; c3 > b3; b3++) d3 += a3[b3].value;
            return d3
        }

        function ra2(a3, b3, c3) {
            var d3 = b3.dir,
                e3 = c3 && d3 === "parentNode",
                f3 = x2++;
            return b3.first ? function(b4, c4, f4) {
                for (; b4 = b4[d3];)
                    if (b4.nodeType === 1 || e3) return a3(b4, c4, f4)
            } : function(b4, c4, g3) {
                var h3, i3, j3, k3 = [w2, f3];
                if (g3) {
                    for (; b4 = b4[d3];)
                        if ((b4.nodeType === 1 || e3) && a3(b4, c4, g3)) return !0
                } else
                    for (; b4 = b4[d3];)
                        if (b4.nodeType === 1 || e3) {
                            if (j3 = b4[u2] || (b4[u2] = {}), i3 = j3[b4.uniqueID] || (j3[b4.uniqueID] = {}), (h3 = i3[d3]) && h3[0] === w2 && h3[1] === f3) return k3[2] = h3[2];
                            if (i3[d3] = k3, k3[2] = a3(b4, c4, g3)) return !0
                        }
            }
        }

        function sa2(a3) {
            return a3.length > 1 ? function(b3, c3, d3) {
                for (var e3 = a3.length; e3--;)
                    if (!a3[e3](b3, c3, d3)) return !1;
                return !0
            } : a3[0]
        }

        function ta2(a3, b3, c3) {
            for (var d3 = 0, e3 = b3.length; e3 > d3; d3++) fa2(a3, b3[d3], c3);
            return c3
        }

        function ua2(a3, b3, c3, d3, e3) {
            for (var f3, g3 = [], h3 = 0, i3 = a3.length, j3 = b3 != null; i3 > h3; h3++)(f3 = a3[h3]) && (c3 && !c3(f3, d3, e3) || (g3.push(f3), j3 && b3.push(h3)));
            return g3
        }

        function va2(a3, b3, c3, d3, e3, f3) {
            return d3 && !d3[u2] && (d3 = va2(d3)), e3 && !e3[u2] && (e3 = va2(e3, f3)), ha2(function(f4, g3, h3, i3) {
                var j3, k3, l3, m3 = [],
                    n3 = [],
                    o3 = g3.length,
                    p3 = f4 || ta2(b3 || "*", h3.nodeType ? [h3] : h3, []),
                    q3 = !a3 || !f4 && b3 ? p3 : ua2(p3, m3, a3, h3, i3),
                    r3 = c3 ? e3 || (f4 ? a3 : o3 || d3) ? [] : g3 : q3;
                if (c3 && c3(q3, r3, h3, i3), d3)
                    for (j3 = ua2(r3, n3), d3(j3, [], h3, i3), k3 = j3.length; k3--;)(l3 = j3[k3]) && (r3[n3[k3]] = !(q3[n3[k3]] = l3));
                if (f4) {
                    if (e3 || a3) {
                        if (e3) {
                            for (j3 = [], k3 = r3.length; k3--;)(l3 = r3[k3]) && j3.push(q3[k3] = l3);
                            e3(null, r3 = [], j3, i3)
                        }
                        for (k3 = r3.length; k3--;)(l3 = r3[k3]) && (j3 = e3 ? J2(f4, l3) : m3[k3]) > -1 && (f4[j3] = !(g3[j3] = l3))
                    }
                } else r3 = ua2(r3 === g3 ? r3.splice(o3, r3.length) : r3), e3 ? e3(null, g3, r3, i3) : H2.apply(g3, r3)
            })
        }

        function wa2(a3) {
            for (var b3, c3, e3, f3 = a3.length, g3 = d2.relative[a3[0].type], h3 = g3 || d2.relative[" "], i3 = g3 ? 1 : 0, k3 = ra2(function(a4) {
                    return a4 === b3
                }, h3, !0), l3 = ra2(function(a4) {
                    return J2(b3, a4) > -1
                }, h3, !0), m3 = [function(a4, c4, d3) {
                    var e4 = !g3 && (d3 || c4 !== j2) || ((b3 = c4).nodeType ? k3(a4, c4, d3) : l3(a4, c4, d3));
                    return b3 = null, e4
                }]; f3 > i3; i3++)
                if (c3 = d2.relative[a3[i3].type]) m3 = [ra2(sa2(m3), c3)];
                else {
                    if (c3 = d2.filter[a3[i3].type].apply(null, a3[i3].matches), c3[u2]) {
                        for (e3 = ++i3; f3 > e3 && !d2.relative[a3[e3].type]; e3++);
                        return va2(i3 > 1 && sa2(m3), i3 > 1 && qa2(a3.slice(0, i3 - 1).concat({
                            value: a3[i3 - 2].type === " " ? "*" : ""
                        })).replace(Q2, "$1"), c3, e3 > i3 && wa2(a3.slice(i3, e3)), f3 > e3 && wa2(a3 = a3.slice(e3)), f3 > e3 && qa2(a3))
                    }
                    m3.push(c3)
                } return sa2(m3)
        }

        function xa2(a3, b3) {
            var c3 = b3.length > 0,
                e3 = a3.length > 0,
                f3 = function(f4, g3, h3, i3, k3) {
                    var l3, o3, q3, r3 = 0,
                        s3 = "0",
                        t3 = f4 && [],
                        u3 = [],
                        v3 = j2,
                        x3 = f4 || e3 && d2.find.TAG("*", k3),
                        y3 = w2 += v3 == null ? 1 : Math.random() || .1,
                        z3 = x3.length;
                    for (k3 && (j2 = g3 === n2 || g3 || k3); s3 !== z3 && (l3 = x3[s3]) != null; s3++) {
                        if (e3 && l3) {
                            for (o3 = 0, g3 || l3.ownerDocument === n2 || (m2(l3), h3 = !p2); q3 = a3[o3++];)
                                if (q3(l3, g3 || n2, h3)) {
                                    i3.push(l3);
                                    break
                                } k3 && (w2 = y3)
                        }
                        c3 && ((l3 = !q3 && l3) && r3--, f4 && t3.push(l3))
                    }
                    if (r3 += s3, c3 && s3 !== r3) {
                        for (o3 = 0; q3 = b3[o3++];) q3(t3, u3, g3, h3);
                        if (f4) {
                            if (r3 > 0)
                                for (; s3--;) t3[s3] || u3[s3] || (u3[s3] = F2.call(i3));
                            u3 = ua2(u3)
                        }
                        H2.apply(i3, u3), k3 && !f4 && u3.length > 0 && r3 + b3.length > 1 && fa2.uniqueSort(i3)
                    }
                    return k3 && (w2 = y3, j2 = v3), t3
                };
            return c3 ? ha2(f3) : f3
        }
        return h2 = fa2.compile = function(a3, b3) {
            var c3, d3 = [],
                e3 = [],
                f3 = A2[a3 + " "];
            if (!f3) {
                for (b3 || (b3 = g2(a3)), c3 = b3.length; c3--;) f3 = wa2(b3[c3]), f3[u2] ? d3.push(f3) : e3.push(f3);
                f3 = A2(a3, xa2(e3, d3)), f3.selector = a3
            }
            return f3
        }, i2 = fa2.select = function(a3, b3, e3, f3) {
            var i3, j3, k3, l3, m3, n3 = typeof a3 == "function" && a3,
                o3 = !f3 && g2(a3 = n3.selector || a3);
            if (e3 = e3 || [], o3.length === 1) {
                if (j3 = o3[0] = o3[0].slice(0), j3.length > 2 && (k3 = j3[0]).type === "ID" && c2.getById && b3.nodeType === 9 && p2 && d2.relative[j3[1].type]) {
                    if (b3 = (d2.find.ID(k3.matches[0].replace(ba2, ca2), b3) || [])[0], !b3) return e3;
                    n3 && (b3 = b3.parentNode), a3 = a3.slice(j3.shift().value.length)
                }
                for (i3 = W2.needsContext.test(a3) ? 0 : j3.length; i3-- && (k3 = j3[i3], !d2.relative[l3 = k3.type]);)
                    if ((m3 = d2.find[l3]) && (f3 = m3(k3.matches[0].replace(ba2, ca2), _2.test(j3[0].type) && oa2(b3.parentNode) || b3))) {
                        if (j3.splice(i3, 1), a3 = f3.length && qa2(j3), !a3) return H2.apply(e3, f3), e3;
                        break
                    }
            }
            return (n3 || h2(a3, o3))(f3, b3, !p2, e3, !b3 || _2.test(a3) && oa2(b3.parentNode) || b3), e3
        }, c2.sortStable = u2.split("").sort(B2).join("") === u2, c2.detectDuplicates = !!l2, m2(), c2.sortDetached = ia2(function(a3) {
            return 1 & a3.compareDocumentPosition(n2.createElement("div"))
        }), ia2(function(a3) {
            return a3.innerHTML = "<a href='#'></a>", a3.firstChild.getAttribute("href") === "#"
        }) || ja2("type|href|height|width", function(a3, b3, c3) {
            return c3 ? void 0 : a3.getAttribute(b3, b3.toLowerCase() === "type" ? 1 : 2)
        }), c2.attributes && ia2(function(a3) {
            return a3.innerHTML = "<input/>", a3.firstChild.setAttribute("value", ""), a3.firstChild.getAttribute("value") === ""
        }) || ja2("value", function(a3, b3, c3) {
            return c3 || a3.nodeName.toLowerCase() !== "input" ? void 0 : a3.defaultValue
        }), ia2(function(a3) {
            return a3.getAttribute("disabled") == null
        }) || ja2(K2, function(a3, b3, c3) {
            var d3;
            return c3 ? void 0 : a3[b3] === !0 ? b3.toLowerCase() : (d3 = a3.getAttributeNode(b3)) && d3.specified ? d3.value : null
        }), fa2
    }(a);
    n.find = t, n.expr = t.selectors, n.expr[":"] = n.expr.pseudos, n.uniqueSort = n.unique = t.uniqueSort, n.text = t.getText, n.isXMLDoc = t.isXML, n.contains = t.contains;
    var u = function(a2, b2, c2) {
            for (var d2 = [], e2 = c2 !== void 0;
                (a2 = a2[b2]) && a2.nodeType !== 9;)
                if (a2.nodeType === 1) {
                    if (e2 && n(a2).is(c2)) break;
                    d2.push(a2)
                } return d2
        },
        v = function(a2, b2) {
            for (var c2 = []; a2; a2 = a2.nextSibling) a2.nodeType === 1 && a2 !== b2 && c2.push(a2);
            return c2
        },
        w = n.expr.match.needsContext,
        x = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,
        y = /^.[^:#\[\.,]*$/;

    function z(a2, b2, c2) {
        if (n.isFunction(b2)) return n.grep(a2, function(a3, d2) {
            return !!b2.call(a3, d2, a3) !== c2
        });
        if (b2.nodeType) return n.grep(a2, function(a3) {
            return a3 === b2 !== c2
        });
        if (typeof b2 == "string") {
            if (y.test(b2)) return n.filter(b2, a2, c2);
            b2 = n.filter(b2, a2)
        }
        return n.grep(a2, function(a3) {
            return n.inArray(a3, b2) > -1 !== c2
        })
    }
    n.filter = function(a2, b2, c2) {
        var d2 = b2[0];
        return c2 && (a2 = ":not(" + a2 + ")"), b2.length === 1 && d2.nodeType === 1 ? n.find.matchesSelector(d2, a2) ? [d2] : [] : n.find.matches(a2, n.grep(b2, function(a3) {
            return a3.nodeType === 1
        }))
    }, n.fn.extend({
        find: function(a2) {
            var b2, c2 = [],
                d2 = this,
                e2 = d2.length;
            if (typeof a2 != "string") return this.pushStack(n(a2).filter(function() {
                for (b2 = 0; e2 > b2; b2++)
                    if (n.contains(d2[b2], this)) return !0
            }));
            for (b2 = 0; e2 > b2; b2++) n.find(a2, d2[b2], c2);
            return c2 = this.pushStack(e2 > 1 ? n.unique(c2) : c2), c2.selector = this.selector ? this.selector + " " + a2 : a2, c2
        },
        filter: function(a2) {
            return this.pushStack(z(this, a2 || [], !1))
        },
        not: function(a2) {
            return this.pushStack(z(this, a2 || [], !0))
        },
        is: function(a2) {
            return !!z(this, typeof a2 == "string" && w.test(a2) ? n(a2) : a2 || [], !1).length
        }
    });
    var A, B = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
        C = n.fn.init = function(a2, b2, c2) {
            var e2, f2;
            if (!a2) return this;
            if (c2 = c2 || A, typeof a2 == "string") {
                if (e2 = a2.charAt(0) === "<" && a2.charAt(a2.length - 1) === ">" && a2.length >= 3 ? [null, a2, null] : B.exec(a2), !e2 || !e2[1] && b2) return !b2 || b2.jquery ? (b2 || c2).find(a2) : this.constructor(b2).find(a2);
                if (e2[1]) {
                    if (b2 = b2 instanceof n ? b2[0] : b2, n.merge(this, n.parseHTML(e2[1], b2 && b2.nodeType ? b2.ownerDocument || b2 : d, !0)), x.test(e2[1]) && n.isPlainObject(b2))
                        for (e2 in b2) n.isFunction(this[e2]) ? this[e2](b2[e2]) : this.attr(e2, b2[e2]);
                    return this
                }
                if (f2 = d.getElementById(e2[2]), f2 && f2.parentNode) {
                    if (f2.id !== e2[2]) return A.find(a2);
                    this.length = 1, this[0] = f2
                }
                return this.context = d, this.selector = a2, this
            }
            return a2.nodeType ? (this.context = this[0] = a2, this.length = 1, this) : n.isFunction(a2) ? typeof c2.ready < "u" ? c2.ready(a2) : a2(n) : (a2.selector !== void 0 && (this.selector = a2.selector, this.context = a2.context), n.makeArray(a2, this))
        };
    C.prototype = n.fn, A = n(d);
    var D = /^(?:parents|prev(?:Until|All))/,
        E = {
            children: !0,
            contents: !0,
            next: !0,
            prev: !0
        };
    n.fn.extend({
        has: function(a2) {
            var b2, c2 = n(a2, this),
                d2 = c2.length;
            return this.filter(function() {
                for (b2 = 0; d2 > b2; b2++)
                    if (n.contains(this, c2[b2])) return !0
            })
        },
        closest: function(a2, b2) {
            for (var c2, d2 = 0, e2 = this.length, f2 = [], g2 = w.test(a2) || typeof a2 != "string" ? n(a2, b2 || this.context) : 0; e2 > d2; d2++)
                for (c2 = this[d2]; c2 && c2 !== b2; c2 = c2.parentNode)
                    if (c2.nodeType < 11 && (g2 ? g2.index(c2) > -1 : c2.nodeType === 1 && n.find.matchesSelector(c2, a2))) {
                        f2.push(c2);
                        break
                    } return this.pushStack(f2.length > 1 ? n.uniqueSort(f2) : f2)
        },
        index: function(a2) {
            return a2 ? typeof a2 == "string" ? n.inArray(this[0], n(a2)) : n.inArray(a2.jquery ? a2[0] : a2, this) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(a2, b2) {
            return this.pushStack(n.uniqueSort(n.merge(this.get(), n(a2, b2))))
        },
        addBack: function(a2) {
            return this.add(a2 == null ? this.prevObject : this.prevObject.filter(a2))
        }
    });

    function F(a2, b2) {
        do a2 = a2[b2]; while (a2 && a2.nodeType !== 1);
        return a2
    }
    n.each({
        parent: function(a2) {
            var b2 = a2.parentNode;
            return b2 && b2.nodeType !== 11 ? b2 : null
        },
        parents: function(a2) {
            return u(a2, "parentNode")
        },
        parentsUntil: function(a2, b2, c2) {
            return u(a2, "parentNode", c2)
        },
        next: function(a2) {
            return F(a2, "nextSibling")
        },
        prev: function(a2) {
            return F(a2, "previousSibling")
        },
        nextAll: function(a2) {
            return u(a2, "nextSibling")
        },
        prevAll: function(a2) {
            return u(a2, "previousSibling")
        },
        nextUntil: function(a2, b2, c2) {
            return u(a2, "nextSibling", c2)
        },
        prevUntil: function(a2, b2, c2) {
            return u(a2, "previousSibling", c2)
        },
        siblings: function(a2) {
            return v((a2.parentNode || {}).firstChild, a2)
        },
        children: function(a2) {
            return v(a2.firstChild)
        },
        contents: function(a2) {
            return n.nodeName(a2, "iframe") ? a2.contentDocument || a2.contentWindow.document : n.merge([], a2.childNodes)
        }
    }, function(a2, b2) {
        n.fn[a2] = function(c2, d2) {
            var e2 = n.map(this, b2, c2);
            return a2.slice(-5) !== "Until" && (d2 = c2), d2 && typeof d2 == "string" && (e2 = n.filter(d2, e2)), this.length > 1 && (E[a2] || (e2 = n.uniqueSort(e2)), D.test(a2) && (e2 = e2.reverse())), this.pushStack(e2)
        }
    });
    var G = /\S+/g;

    function H(a2) {
        var b2 = {};
        return n.each(a2.match(G) || [], function(a3, c2) {
            b2[c2] = !0
        }), b2
    }
    n.Callbacks = function(a2) {
        a2 = typeof a2 == "string" ? H(a2) : n.extend({}, a2);
        var b2, c2, d2, e2, f2 = [],
            g2 = [],
            h2 = -1,
            i2 = function() {
                for (e2 = a2.once, d2 = b2 = !0; g2.length; h2 = -1)
                    for (c2 = g2.shift(); ++h2 < f2.length;) f2[h2].apply(c2[0], c2[1]) === !1 && a2.stopOnFalse && (h2 = f2.length, c2 = !1);
                a2.memory || (c2 = !1), b2 = !1, e2 && (f2 = c2 ? [] : "")
            },
            j2 = {
                add: function() {
                    return f2 && (c2 && !b2 && (h2 = f2.length - 1, g2.push(c2)), function d3(b3) {
                        n.each(b3, function(b4, c3) {
                            n.isFunction(c3) ? a2.unique && j2.has(c3) || f2.push(c3) : c3 && c3.length && n.type(c3) !== "string" && d3(c3)
                        })
                    }(arguments), c2 && !b2 && i2()), this
                },
                remove: function() {
                    return n.each(arguments, function(a3, b3) {
                        for (var c3;
                            (c3 = n.inArray(b3, f2, c3)) > -1;) f2.splice(c3, 1), h2 >= c3 && h2--
                    }), this
                },
                has: function(a3) {
                    return a3 ? n.inArray(a3, f2) > -1 : f2.length > 0
                },
                empty: function() {
                    return f2 && (f2 = []), this
                },
                disable: function() {
                    return e2 = g2 = [], f2 = c2 = "", this
                },
                disabled: function() {
                    return !f2
                },
                lock: function() {
                    return e2 = !0, c2 || j2.disable(), this
                },
                locked: function() {
                    return !!e2
                },
                fireWith: function(a3, c3) {
                    return e2 || (c3 = c3 || [], c3 = [a3, c3.slice ? c3.slice() : c3], g2.push(c3), b2 || i2()), this
                },
                fire: function() {
                    return j2.fireWith(this, arguments), this
                },
                fired: function() {
                    return !!d2
                }
            };
        return j2
    }, n.extend({
        Deferred: function(a2) {
            var b2 = [
                    ["resolve", "done", n.Callbacks("once memory"), "resolved"],
                    ["reject", "fail", n.Callbacks("once memory"), "rejected"],
                    ["notify", "progress", n.Callbacks("memory")]
                ],
                c2 = "pending",
                d2 = {
                    state: function() {
                        return c2
                    },
                    always: function() {
                        return e2.done(arguments).fail(arguments), this
                    },
                    then: function() {
                        var a3 = arguments;
                        return n.Deferred(function(c3) {
                            n.each(b2, function(b3, f2) {
                                var g2 = n.isFunction(a3[b3]) && a3[b3];
                                e2[f2[1]](function() {
                                    var a4 = g2 && g2.apply(this, arguments);
                                    a4 && n.isFunction(a4.promise) ? a4.promise().progress(c3.notify).done(c3.resolve).fail(c3.reject) : c3[f2[0] + "With"](this === d2 ? c3.promise() : this, g2 ? [a4] : arguments)
                                })
                            }), a3 = null
                        }).promise()
                    },
                    promise: function(a3) {
                        return a3 != null ? n.extend(a3, d2) : d2
                    }
                },
                e2 = {};
            return d2.pipe = d2.then, n.each(b2, function(a3, f2) {
                var g2 = f2[2],
                    h2 = f2[3];
                d2[f2[1]] = g2.add, h2 && g2.add(function() {
                    c2 = h2
                }, b2[1 ^ a3][2].disable, b2[2][2].lock), e2[f2[0]] = function() {
                    return e2[f2[0] + "With"](this === e2 ? d2 : this, arguments), this
                }, e2[f2[0] + "With"] = g2.fireWith
            }), d2.promise(e2), a2 && a2.call(e2, e2), e2
        },
        when: function(a2) {
            var b2 = 0,
                c2 = e.call(arguments),
                d2 = c2.length,
                f2 = d2 !== 1 || a2 && n.isFunction(a2.promise) ? d2 : 0,
                g2 = f2 === 1 ? a2 : n.Deferred(),
                h2 = function(a3, b3, c3) {
                    return function(d3) {
                        b3[a3] = this, c3[a3] = arguments.length > 1 ? e.call(arguments) : d3, c3 === i2 ? g2.notifyWith(b3, c3) : --f2 || g2.resolveWith(b3, c3)
                    }
                },
                i2, j2, k2;
            if (d2 > 1)
                for (i2 = new Array(d2), j2 = new Array(d2), k2 = new Array(d2); d2 > b2; b2++) c2[b2] && n.isFunction(c2[b2].promise) ? c2[b2].promise().progress(h2(b2, j2, i2)).done(h2(b2, k2, c2)).fail(g2.reject) : --f2;
            return f2 || g2.resolveWith(k2, c2), g2.promise()
        }
    });
    var I;
    n.fn.ready = function(a2) {
        return n.ready.promise().done(a2), this
    }, n.extend({
        isReady: !1,
        readyWait: 1,
        holdReady: function(a2) {
            a2 ? n.readyWait++ : n.ready(!0)
        },
        ready: function(a2) {
            (a2 === !0 ? --n.readyWait : n.isReady) || (n.isReady = !0, a2 !== !0 && --n.readyWait > 0 || (I.resolveWith(d, [n]), n.fn.triggerHandler && (n(d).triggerHandler("ready"), n(d).off("ready"))))
        }
    });

    function J() {
        d.addEventListener ? (d.removeEventListener("DOMContentLoaded", K), a.removeEventListener("load", K)) : (d.detachEvent("onreadystatechange", K), a.detachEvent("onload", K))
    }

    function K() {
        (d.addEventListener || a.event.type === "load" || d.readyState === "complete") && (J(), n.ready())
    }
    n.ready.promise = function(b2) {
        if (!I)
            if (I = n.Deferred(), d.readyState === "complete" || d.readyState !== "loading" && !d.documentElement.doScroll) a.setTimeout(n.ready);
            else if (d.addEventListener) d.addEventListener("DOMContentLoaded", K), a.addEventListener("load", K);
        else {
            d.attachEvent("onreadystatechange", K), a.attachEvent("onload", K);
            var c2 = !1;
            try {
                c2 = a.frameElement == null && d.documentElement
            } catch {}
            c2 && c2.doScroll && function f2() {
                if (!n.isReady) {
                    try {
                        c2.doScroll("left")
                    } catch {
                        return a.setTimeout(f2, 50)
                    }
                    J(), n.ready()
                }
            }()
        }
        return I.promise(b2)
    }, n.ready.promise();
    var L;
    for (L in n(l)) break;
    l.ownFirst = L === "0", l.inlineBlockNeedsLayout = !1, n(function() {
            var a2, b2, c2, e2;
            c2 = d.getElementsByTagName("body")[0], c2 && c2.style && (b2 = d.createElement("div"), e2 = d.createElement("div"), e2.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", c2.appendChild(e2).appendChild(b2), typeof b2.style.zoom < "u" && (b2.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1", l.inlineBlockNeedsLayout = a2 = b2.offsetWidth === 3, a2 && (c2.style.zoom = 1)), c2.removeChild(e2))
        }),
        function() {
            var a2 = d.createElement("div");
            l.deleteExpando = !0;
            try {
                delete a2.test
            } catch {
                l.deleteExpando = !1
            }
            a2 = null
        }();
    var M = function(a2) {
            var b2 = n.noData[(a2.nodeName + " ").toLowerCase()],
                c2 = +a2.nodeType || 1;
            return c2 !== 1 && c2 !== 9 ? !1 : !b2 || b2 !== !0 && a2.getAttribute("classid") === b2
        },
        N = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        O = /([A-Z])/g;

    function P(a2, b2, c2) {
        if (c2 === void 0 && a2.nodeType === 1) {
            var d2 = "data-" + b2.replace(O, "-$1").toLowerCase();
            if (c2 = a2.getAttribute(d2), typeof c2 == "string") {
                try {
                    c2 = c2 === "true" ? !0 : c2 === "false" ? !1 : c2 === "null" ? null : +c2 + "" === c2 ? +c2 : N.test(c2) ? n.parseJSON(c2) : c2
                } catch {}
                n.data(a2, b2, c2)
            } else c2 = void 0
        }
        return c2
    }

    function Q(a2) {
        var b2;
        for (b2 in a2)
            if ((b2 !== "data" || !n.isEmptyObject(a2[b2])) && b2 !== "toJSON") return !1;
        return !0
    }

    function R(a2, b2, d2, e2) {
        if (M(a2)) {
            var f2, g2, h2 = n.expando,
                i2 = a2.nodeType,
                j2 = i2 ? n.cache : a2,
                k2 = i2 ? a2[h2] : a2[h2] && h2;
            if (k2 && j2[k2] && (e2 || j2[k2].data) || d2 !== void 0 || typeof b2 != "string") return k2 || (k2 = i2 ? a2[h2] = c.pop() || n.guid++ : h2), j2[k2] || (j2[k2] = i2 ? {} : {
                toJSON: n.noop
            }), typeof b2 != "object" && typeof b2 != "function" || (e2 ? j2[k2] = n.extend(j2[k2], b2) : j2[k2].data = n.extend(j2[k2].data, b2)), g2 = j2[k2], e2 || (g2.data || (g2.data = {}), g2 = g2.data), d2 !== void 0 && (g2[n.camelCase(b2)] = d2), typeof b2 == "string" ? (f2 = g2[b2], f2 == null && (f2 = g2[n.camelCase(b2)])) : f2 = g2, f2
        }
    }

    function S(a2, b2, c2) {
        if (M(a2)) {
            var d2, e2, f2 = a2.nodeType,
                g2 = f2 ? n.cache : a2,
                h2 = f2 ? a2[n.expando] : n.expando;
            if (g2[h2]) {
                if (b2 && (d2 = c2 ? g2[h2] : g2[h2].data)) {
                    for (n.isArray(b2) ? b2 = b2.concat(n.map(b2, n.camelCase)) : (b2 in d2) ? b2 = [b2] : (b2 = n.camelCase(b2), b2 = b2 in d2 ? [b2] : b2.split(" ")), e2 = b2.length; e2--;) delete d2[b2[e2]];
                    if (c2 ? !Q(d2) : !n.isEmptyObject(d2)) return
                }(c2 || (delete g2[h2].data, Q(g2[h2]))) && (f2 ? n.cleanData([a2], !0) : l.deleteExpando || g2 != g2.window ? delete g2[h2] : g2[h2] = void 0)
            }
        }
    }
    n.extend({
            cache: {},
            noData: {
                "applet ": !0,
                "embed ": !0,
                "object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
            },
            hasData: function(a2) {
                return a2 = a2.nodeType ? n.cache[a2[n.expando]] : a2[n.expando], !!a2 && !Q(a2)
            },
            data: function(a2, b2, c2) {
                return R(a2, b2, c2)
            },
            removeData: function(a2, b2) {
                return S(a2, b2)
            },
            _data: function(a2, b2, c2) {
                return R(a2, b2, c2, !0)
            },
            _removeData: function(a2, b2) {
                return S(a2, b2, !0)
            }
        }), n.fn.extend({
            data: function(a2, b2) {
                var c2, d2, e2, f2 = this[0],
                    g2 = f2 && f2.attributes;
                if (a2 === void 0) {
                    if (this.length && (e2 = n.data(f2), f2.nodeType === 1 && !n._data(f2, "parsedAttrs"))) {
                        for (c2 = g2.length; c2--;) g2[c2] && (d2 = g2[c2].name, d2.indexOf("data-") === 0 && (d2 = n.camelCase(d2.slice(5)), P(f2, d2, e2[d2])));
                        n._data(f2, "parsedAttrs", !0)
                    }
                    return e2
                }
                return typeof a2 == "object" ? this.each(function() {
                    n.data(this, a2)
                }) : arguments.length > 1 ? this.each(function() {
                    n.data(this, a2, b2)
                }) : f2 ? P(f2, a2, n.data(f2, a2)) : void 0
            },
            removeData: function(a2) {
                return this.each(function() {
                    n.removeData(this, a2)
                })
            }
        }), n.extend({
            queue: function(a2, b2, c2) {
                var d2;
                return a2 ? (b2 = (b2 || "fx") + "queue", d2 = n._data(a2, b2), c2 && (!d2 || n.isArray(c2) ? d2 = n._data(a2, b2, n.makeArray(c2)) : d2.push(c2)), d2 || []) : void 0
            },
            dequeue: function(a2, b2) {
                b2 = b2 || "fx";
                var c2 = n.queue(a2, b2),
                    d2 = c2.length,
                    e2 = c2.shift(),
                    f2 = n._queueHooks(a2, b2),
                    g2 = function() {
                        n.dequeue(a2, b2)
                    };
                e2 === "inprogress" && (e2 = c2.shift(), d2--), e2 && (b2 === "fx" && c2.unshift("inprogress"), delete f2.stop, e2.call(a2, g2, f2)), !d2 && f2 && f2.empty.fire()
            },
            _queueHooks: function(a2, b2) {
                var c2 = b2 + "queueHooks";
                return n._data(a2, c2) || n._data(a2, c2, {
                    empty: n.Callbacks("once memory").add(function() {
                        n._removeData(a2, b2 + "queue"), n._removeData(a2, c2)
                    })
                })
            }
        }), n.fn.extend({
            queue: function(a2, b2) {
                var c2 = 2;
                return typeof a2 != "string" && (b2 = a2, a2 = "fx", c2--), arguments.length < c2 ? n.queue(this[0], a2) : b2 === void 0 ? this : this.each(function() {
                    var c3 = n.queue(this, a2, b2);
                    n._queueHooks(this, a2), a2 === "fx" && c3[0] !== "inprogress" && n.dequeue(this, a2)
                })
            },
            dequeue: function(a2) {
                return this.each(function() {
                    n.dequeue(this, a2)
                })
            },
            clearQueue: function(a2) {
                return this.queue(a2 || "fx", [])
            },
            promise: function(a2, b2) {
                var c2, d2 = 1,
                    e2 = n.Deferred(),
                    f2 = this,
                    g2 = this.length,
                    h2 = function() {
                        --d2 || e2.resolveWith(f2, [f2])
                    };
                for (typeof a2 != "string" && (b2 = a2, a2 = void 0), a2 = a2 || "fx"; g2--;) c2 = n._data(f2[g2], a2 + "queueHooks"), c2 && c2.empty && (d2++, c2.empty.add(h2));
                return h2(), e2.promise(b2)
            }
        }),
        function() {
            var a2;
            l.shrinkWrapBlocks = function() {
                if (a2 != null) return a2;
                a2 = !1;
                var b2, c2, e2;
                return c2 = d.getElementsByTagName("body")[0], c2 && c2.style ? (b2 = d.createElement("div"), e2 = d.createElement("div"), e2.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", c2.appendChild(e2).appendChild(b2), typeof b2.style.zoom < "u" && (b2.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:1px;width:1px;zoom:1", b2.appendChild(d.createElement("div")).style.width = "5px", a2 = b2.offsetWidth !== 3), c2.removeChild(e2), a2) : void 0
            }
        }();
    var T = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        U = new RegExp("^(?:([+-])=|)(" + T + ")([a-z%]*)$", "i"),
        V = ["Top", "Right", "Bottom", "Left"],
        W = function(a2, b2) {
            return a2 = b2 || a2, n.css(a2, "display") === "none" || !n.contains(a2.ownerDocument, a2)
        };

    function X(a2, b2, c2, d2) {
        var e2, f2 = 1,
            g2 = 20,
            h2 = d2 ? function() {
                return d2.cur()
            } : function() {
                return n.css(a2, b2, "")
            },
            i2 = h2(),
            j2 = c2 && c2[3] || (n.cssNumber[b2] ? "" : "px"),
            k2 = (n.cssNumber[b2] || j2 !== "px" && +i2) && U.exec(n.css(a2, b2));
        if (k2 && k2[3] !== j2) {
            j2 = j2 || k2[3], c2 = c2 || [], k2 = +i2 || 1;
            do f2 = f2 || ".5", k2 /= f2, n.style(a2, b2, k2 + j2); while (f2 !== (f2 = h2() / i2) && f2 !== 1 && --g2)
        }
        return c2 && (k2 = +k2 || +i2 || 0, e2 = c2[1] ? k2 + (c2[1] + 1) * c2[2] : +c2[2], d2 && (d2.unit = j2, d2.start = k2, d2.end = e2)), e2
    }
    var Y = function(a2, b2, c2, d2, e2, f2, g2) {
            var h2 = 0,
                i2 = a2.length,
                j2 = c2 == null;
            if (n.type(c2) === "object") {
                e2 = !0;
                for (h2 in c2) Y(a2, b2, h2, c2[h2], !0, f2, g2)
            } else if (d2 !== void 0 && (e2 = !0, n.isFunction(d2) || (g2 = !0), j2 && (g2 ? (b2.call(a2, d2), b2 = null) : (j2 = b2, b2 = function(a3, b3, c3) {
                    return j2.call(n(a3), c3)
                })), b2))
                for (; i2 > h2; h2++) b2(a2[h2], c2, g2 ? d2 : d2.call(a2[h2], h2, b2(a2[h2], c2)));
            return e2 ? a2 : j2 ? b2.call(a2) : i2 ? b2(a2[0], c2) : f2
        },
        Z = /^(?:checkbox|radio)$/i,
        $2 = /<([\w:-]+)/,
        _ = /^$|\/(?:java|ecma)script/i,
        aa = /^\s+/,
        ba = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|dialog|figcaption|figure|footer|header|hgroup|main|mark|meter|nav|output|picture|progress|section|summary|template|time|video";

    function ca(a2) {
        var b2 = ba.split("|"),
            c2 = a2.createDocumentFragment();
        if (c2.createElement)
            for (; b2.length;) c2.createElement(b2.pop());
        return c2
    }(function() {
        var a2 = d.createElement("div"),
            b2 = d.createDocumentFragment(),
            c2 = d.createElement("input");
        a2.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", l.leadingWhitespace = a2.firstChild.nodeType === 3, l.tbody = !a2.getElementsByTagName("tbody").length, l.htmlSerialize = !!a2.getElementsByTagName("link").length, l.html5Clone = d.createElement("nav").cloneNode(!0).outerHTML !== "<:nav></:nav>", c2.type = "checkbox", c2.checked = !0, b2.appendChild(c2), l.appendChecked = c2.checked, a2.innerHTML = "<textarea>x</textarea>", l.noCloneChecked = !!a2.cloneNode(!0).lastChild.defaultValue, b2.appendChild(a2), c2 = d.createElement("input"), c2.setAttribute("type", "radio"), c2.setAttribute("checked", "checked"), c2.setAttribute("name", "t"), a2.appendChild(c2), l.checkClone = a2.cloneNode(!0).cloneNode(!0).lastChild.checked, l.noCloneEvent = !!a2.addEventListener, a2[n.expando] = 1, l.attributes = !a2.getAttribute(n.expando)
    })();
    var da = {
        option: [1, "<select multiple='multiple'>", "</select>"],
        legend: [1, "<fieldset>", "</fieldset>"],
        area: [1, "<map>", "</map>"],
        param: [1, "<object>", "</object>"],
        thead: [1, "<table>", "</table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: l.htmlSerialize ? [0, "", ""] : [1, "X<div>", "</div>"]
    };
    da.optgroup = da.option, da.tbody = da.tfoot = da.colgroup = da.caption = da.thead, da.th = da.td;

    function ea(a2, b2) {
        var c2, d2, e2 = 0,
            f2 = typeof a2.getElementsByTagName < "u" ? a2.getElementsByTagName(b2 || "*") : typeof a2.querySelectorAll < "u" ? a2.querySelectorAll(b2 || "*") : void 0;
        if (!f2)
            for (f2 = [], c2 = a2.childNodes || a2;
                (d2 = c2[e2]) != null; e2++) !b2 || n.nodeName(d2, b2) ? f2.push(d2) : n.merge(f2, ea(d2, b2));
        return b2 === void 0 || b2 && n.nodeName(a2, b2) ? n.merge([a2], f2) : f2
    }

    function fa(a2, b2) {
        for (var c2, d2 = 0;
            (c2 = a2[d2]) != null; d2++) n._data(c2, "globalEval", !b2 || n._data(b2[d2], "globalEval"))
    }
    var ga = /<|&#?\w+;/,
        ha = /<tbody/i;

    function ia(a2) {
        Z.test(a2.type) && (a2.defaultChecked = a2.checked)
    }

    function ja(a2, b2, c2, d2, e2) {
        for (var f2, g2, h2, i2, j2, k2, m2, o2 = a2.length, p2 = ca(b2), q2 = [], r2 = 0; o2 > r2; r2++)
            if (g2 = a2[r2], g2 || g2 === 0)
                if (n.type(g2) === "object") n.merge(q2, g2.nodeType ? [g2] : g2);
                else if (ga.test(g2)) {
            for (i2 = i2 || p2.appendChild(b2.createElement("div")), j2 = ($2.exec(g2) || ["", ""])[1].toLowerCase(), m2 = da[j2] || da._default, i2.innerHTML = m2[1] + n.htmlPrefilter(g2) + m2[2], f2 = m2[0]; f2--;) i2 = i2.lastChild;
            if (!l.leadingWhitespace && aa.test(g2) && q2.push(b2.createTextNode(aa.exec(g2)[0])), !l.tbody)
                for (g2 = j2 !== "table" || ha.test(g2) ? m2[1] !== "<table>" || ha.test(g2) ? 0 : i2 : i2.firstChild, f2 = g2 && g2.childNodes.length; f2--;) n.nodeName(k2 = g2.childNodes[f2], "tbody") && !k2.childNodes.length && g2.removeChild(k2);
            for (n.merge(q2, i2.childNodes), i2.textContent = ""; i2.firstChild;) i2.removeChild(i2.firstChild);
            i2 = p2.lastChild
        } else q2.push(b2.createTextNode(g2));
        for (i2 && p2.removeChild(i2), l.appendChecked || n.grep(ea(q2, "input"), ia), r2 = 0; g2 = q2[r2++];)
            if (d2 && n.inArray(g2, d2) > -1) e2 && e2.push(g2);
            else if (h2 = n.contains(g2.ownerDocument, g2), i2 = ea(p2.appendChild(g2), "script"), h2 && fa(i2), c2)
            for (f2 = 0; g2 = i2[f2++];) _.test(g2.type || "") && c2.push(g2);
        return i2 = null, p2
    }(function() {
        var b2, c2, e2 = d.createElement("div");
        for (b2 in {
                submit: !0,
                change: !0,
                focusin: !0
            }) c2 = "on" + b2, (l[b2] = c2 in a) || (e2.setAttribute(c2, "t"), l[b2] = e2.attributes[c2].expando === !1);
        e2 = null
    })();
    var ka = /^(?:input|select|textarea)$/i,
        la = /^key/,
        ma = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
        na = /^(?:focusinfocus|focusoutblur)$/,
        oa = /^([^.]*)(?:\.(.+)|)/;

    function pa() {
        return !0
    }

    function qa() {
        return !1
    }

    function ra() {
        try {
            return d.activeElement
        } catch {}
    }

    function sa(a2, b2, c2, d2, e2, f2) {
        var g2, h2;
        if (typeof b2 == "object") {
            typeof c2 != "string" && (d2 = d2 || c2, c2 = void 0);
            for (h2 in b2) sa(a2, h2, c2, d2, b2[h2], f2);
            return a2
        }
        if (d2 == null && e2 == null ? (e2 = c2, d2 = c2 = void 0) : e2 == null && (typeof c2 == "string" ? (e2 = d2, d2 = void 0) : (e2 = d2, d2 = c2, c2 = void 0)), e2 === !1) e2 = qa;
        else if (!e2) return a2;
        return f2 === 1 && (g2 = e2, e2 = function(a3) {
            return n().off(a3), g2.apply(this, arguments)
        }, e2.guid = g2.guid || (g2.guid = n.guid++)), a2.each(function() {
            n.event.add(this, b2, e2, d2, c2)
        })
    }
    n.event = {
        global: {},
        add: function(a2, b2, c2, d2, e2) {
            var f2, g2, h2, i2, j2, k2, l2, m2, o2, p2, q2, r2 = n._data(a2);
            if (r2) {
                for (c2.handler && (i2 = c2, c2 = i2.handler, e2 = i2.selector), c2.guid || (c2.guid = n.guid++), (g2 = r2.events) || (g2 = r2.events = {}), (k2 = r2.handle) || (k2 = r2.handle = function(a3) {
                        return typeof n > "u" || a3 && n.event.triggered === a3.type ? void 0 : n.event.dispatch.apply(k2.elem, arguments)
                    }, k2.elem = a2), b2 = (b2 || "").match(G) || [""], h2 = b2.length; h2--;) f2 = oa.exec(b2[h2]) || [], o2 = q2 = f2[1], p2 = (f2[2] || "").split(".").sort(), o2 && (j2 = n.event.special[o2] || {}, o2 = (e2 ? j2.delegateType : j2.bindType) || o2, j2 = n.event.special[o2] || {}, l2 = n.extend({
                    type: o2,
                    origType: q2,
                    data: d2,
                    handler: c2,
                    guid: c2.guid,
                    selector: e2,
                    needsContext: e2 && n.expr.match.needsContext.test(e2),
                    namespace: p2.join(".")
                }, i2), (m2 = g2[o2]) || (m2 = g2[o2] = [], m2.delegateCount = 0, j2.setup && j2.setup.call(a2, d2, p2, k2) !== !1 || (a2.addEventListener ? a2.addEventListener(o2, k2, !1) : a2.attachEvent && a2.attachEvent("on" + o2, k2))), j2.add && (j2.add.call(a2, l2), l2.handler.guid || (l2.handler.guid = c2.guid)), e2 ? m2.splice(m2.delegateCount++, 0, l2) : m2.push(l2), n.event.global[o2] = !0);
                a2 = null
            }
        },
        remove: function(a2, b2, c2, d2, e2) {
            var f2, g2, h2, i2, j2, k2, l2, m2, o2, p2, q2, r2 = n.hasData(a2) && n._data(a2);
            if (r2 && (k2 = r2.events)) {
                for (b2 = (b2 || "").match(G) || [""], j2 = b2.length; j2--;)
                    if (h2 = oa.exec(b2[j2]) || [], o2 = q2 = h2[1], p2 = (h2[2] || "").split(".").sort(), o2) {
                        for (l2 = n.event.special[o2] || {}, o2 = (d2 ? l2.delegateType : l2.bindType) || o2, m2 = k2[o2] || [], h2 = h2[2] && new RegExp("(^|\\.)" + p2.join("\\.(?:.*\\.|)") + "(\\.|$)"), i2 = f2 = m2.length; f2--;) g2 = m2[f2], !e2 && q2 !== g2.origType || c2 && c2.guid !== g2.guid || h2 && !h2.test(g2.namespace) || d2 && d2 !== g2.selector && (d2 !== "**" || !g2.selector) || (m2.splice(f2, 1), g2.selector && m2.delegateCount--, l2.remove && l2.remove.call(a2, g2));
                        i2 && !m2.length && (l2.teardown && l2.teardown.call(a2, p2, r2.handle) !== !1 || n.removeEvent(a2, o2, r2.handle), delete k2[o2])
                    } else
                        for (o2 in k2) n.event.remove(a2, o2 + b2[j2], c2, d2, !0);
                n.isEmptyObject(k2) && (delete r2.handle, n._removeData(a2, "events"))
            }
        },
        trigger: function(b2, c2, e2, f2) {
            var g2, h2, i2, j2, l2, m2, o2, p2 = [e2 || d],
                q2 = k.call(b2, "type") ? b2.type : b2,
                r2 = k.call(b2, "namespace") ? b2.namespace.split(".") : [];
            if (i2 = m2 = e2 = e2 || d, e2.nodeType !== 3 && e2.nodeType !== 8 && !na.test(q2 + n.event.triggered) && (q2.indexOf(".") > -1 && (r2 = q2.split("."), q2 = r2.shift(), r2.sort()), h2 = q2.indexOf(":") < 0 && "on" + q2, b2 = b2[n.expando] ? b2 : new n.Event(q2, typeof b2 == "object" && b2), b2.isTrigger = f2 ? 2 : 3, b2.namespace = r2.join("."), b2.rnamespace = b2.namespace ? new RegExp("(^|\\.)" + r2.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, b2.result = void 0, b2.target || (b2.target = e2), c2 = c2 == null ? [b2] : n.makeArray(c2, [b2]), l2 = n.event.special[q2] || {}, f2 || !l2.trigger || l2.trigger.apply(e2, c2) !== !1)) {
                if (!f2 && !l2.noBubble && !n.isWindow(e2)) {
                    for (j2 = l2.delegateType || q2, na.test(j2 + q2) || (i2 = i2.parentNode); i2; i2 = i2.parentNode) p2.push(i2), m2 = i2;
                    m2 === (e2.ownerDocument || d) && p2.push(m2.defaultView || m2.parentWindow || a)
                }
                for (o2 = 0;
                    (i2 = p2[o2++]) && !b2.isPropagationStopped();) b2.type = o2 > 1 ? j2 : l2.bindType || q2, g2 = (n._data(i2, "events") || {})[b2.type] && n._data(i2, "handle"), g2 && g2.apply(i2, c2), g2 = h2 && i2[h2], g2 && g2.apply && M(i2) && (b2.result = g2.apply(i2, c2), b2.result === !1 && b2.preventDefault());
                if (b2.type = q2, !f2 && !b2.isDefaultPrevented() && (!l2._default || l2._default.apply(p2.pop(), c2) === !1) && M(e2) && h2 && e2[q2] && !n.isWindow(e2)) {
                    m2 = e2[h2], m2 && (e2[h2] = null), n.event.triggered = q2;
                    try {
                        e2[q2]()
                    } catch {}
                    n.event.triggered = void 0, m2 && (e2[h2] = m2)
                }
                return b2.result
            }
        },
        dispatch: function(a2) {
            a2 = n.event.fix(a2);
            var b2, c2, d2, f2, g2, h2 = [],
                i2 = e.call(arguments),
                j2 = (n._data(this, "events") || {})[a2.type] || [],
                k2 = n.event.special[a2.type] || {};
            if (i2[0] = a2, a2.delegateTarget = this, !k2.preDispatch || k2.preDispatch.call(this, a2) !== !1) {
                for (h2 = n.event.handlers.call(this, a2, j2), b2 = 0;
                    (f2 = h2[b2++]) && !a2.isPropagationStopped();)
                    for (a2.currentTarget = f2.elem, c2 = 0;
                        (g2 = f2.handlers[c2++]) && !a2.isImmediatePropagationStopped();) a2.rnamespace && !a2.rnamespace.test(g2.namespace) || (a2.handleObj = g2, a2.data = g2.data, d2 = ((n.event.special[g2.origType] || {}).handle || g2.handler).apply(f2.elem, i2), d2 !== void 0 && (a2.result = d2) === !1 && (a2.preventDefault(), a2.stopPropagation()));
                return k2.postDispatch && k2.postDispatch.call(this, a2), a2.result
            }
        },
        handlers: function(a2, b2) {
            var c2, d2, e2, f2, g2 = [],
                h2 = b2.delegateCount,
                i2 = a2.target;
            if (h2 && i2.nodeType && (a2.type !== "click" || isNaN(a2.button) || a2.button < 1)) {
                for (; i2 != this; i2 = i2.parentNode || this)
                    if (i2.nodeType === 1 && (i2.disabled !== !0 || a2.type !== "click")) {
                        for (d2 = [], c2 = 0; h2 > c2; c2++) f2 = b2[c2], e2 = f2.selector + " ", d2[e2] === void 0 && (d2[e2] = f2.needsContext ? n(e2, this).index(i2) > -1 : n.find(e2, this, null, [i2]).length), d2[e2] && d2.push(f2);
                        d2.length && g2.push({
                            elem: i2,
                            handlers: d2
                        })
                    }
            }
            return h2 < b2.length && g2.push({
                elem: this,
                handlers: b2.slice(h2)
            }), g2
        },
        fix: function(a2) {
            if (a2[n.expando]) return a2;
            var b2, c2, e2, f2 = a2.type,
                g2 = a2,
                h2 = this.fixHooks[f2];
            for (h2 || (this.fixHooks[f2] = h2 = ma.test(f2) ? this.mouseHooks : la.test(f2) ? this.keyHooks : {}), e2 = h2.props ? this.props.concat(h2.props) : this.props, a2 = new n.Event(g2), b2 = e2.length; b2--;) c2 = e2[b2], a2[c2] = g2[c2];
            return a2.target || (a2.target = g2.srcElement || d), a2.target.nodeType === 3 && (a2.target = a2.target.parentNode), a2.metaKey = !!a2.metaKey, h2.filter ? h2.filter(a2, g2) : a2
        },
        props: "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
        fixHooks: {},
        keyHooks: {
            props: "char charCode key keyCode".split(" "),
            filter: function(a2, b2) {
                return a2.which == null && (a2.which = b2.charCode != null ? b2.charCode : b2.keyCode), a2
            }
        },
        mouseHooks: {
            props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
            filter: function(a2, b2) {
                var c2, e2, f2, g2 = b2.button,
                    h2 = b2.fromElement;
                return a2.pageX == null && b2.clientX != null && (e2 = a2.target.ownerDocument || d, f2 = e2.documentElement, c2 = e2.body, a2.pageX = b2.clientX + (f2 && f2.scrollLeft || c2 && c2.scrollLeft || 0) - (f2 && f2.clientLeft || c2 && c2.clientLeft || 0), a2.pageY = b2.clientY + (f2 && f2.scrollTop || c2 && c2.scrollTop || 0) - (f2 && f2.clientTop || c2 && c2.clientTop || 0)), !a2.relatedTarget && h2 && (a2.relatedTarget = h2 === a2.target ? b2.toElement : h2), a2.which || g2 === void 0 || (a2.which = 1 & g2 ? 1 : 2 & g2 ? 3 : 4 & g2 ? 2 : 0), a2
            }
        },
        special: {
            load: {
                noBubble: !0
            },
            focus: {
                trigger: function() {
                    if (this !== ra() && this.focus) try {
                        return this.focus(), !1
                    } catch {}
                },
                delegateType: "focusin"
            },
            blur: {
                trigger: function() {
                    return this === ra() && this.blur ? (this.blur(), !1) : void 0
                },
                delegateType: "focusout"
            },
            click: {
                trigger: function() {
                    return n.nodeName(this, "input") && this.type === "checkbox" && this.click ? (this.click(), !1) : void 0
                },
                _default: function(a2) {
                    return n.nodeName(a2.target, "a")
                }
            },
            beforeunload: {
                postDispatch: function(a2) {
                    a2.result !== void 0 && a2.originalEvent && (a2.originalEvent.returnValue = a2.result)
                }
            }
        },
        simulate: function(a2, b2, c2) {
            var d2 = n.extend(new n.Event, c2, {
                type: a2,
                isSimulated: !0
            });
            n.event.trigger(d2, null, b2), d2.isDefaultPrevented() && c2.preventDefault()
        }
    }, n.removeEvent = d.removeEventListener ? function(a2, b2, c2) {
        a2.removeEventListener && a2.removeEventListener(b2, c2)
    } : function(a2, b2, c2) {
        var d2 = "on" + b2;
        a2.detachEvent && (typeof a2[d2] > "u" && (a2[d2] = null), a2.detachEvent(d2, c2))
    }, n.Event = function(a2, b2) {
        return this instanceof n.Event ? (a2 && a2.type ? (this.originalEvent = a2, this.type = a2.type, this.isDefaultPrevented = a2.defaultPrevented || a2.defaultPrevented === void 0 && a2.returnValue === !1 ? pa : qa) : this.type = a2, b2 && n.extend(this, b2), this.timeStamp = a2 && a2.timeStamp || n.now(), void(this[n.expando] = !0)) : new n.Event(a2, b2)
    }, n.Event.prototype = {
        constructor: n.Event,
        isDefaultPrevented: qa,
        isPropagationStopped: qa,
        isImmediatePropagationStopped: qa,
        preventDefault: function() {
            var a2 = this.originalEvent;
            this.isDefaultPrevented = pa, a2 && (a2.preventDefault ? a2.preventDefault() : a2.returnValue = !1)
        },
        stopPropagation: function() {
            var a2 = this.originalEvent;
            this.isPropagationStopped = pa, a2 && !this.isSimulated && (a2.stopPropagation && a2.stopPropagation(), a2.cancelBubble = !0)
        },
        stopImmediatePropagation: function() {
            var a2 = this.originalEvent;
            this.isImmediatePropagationStopped = pa, a2 && a2.stopImmediatePropagation && a2.stopImmediatePropagation(), this.stopPropagation()
        }
    }, n.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(a2, b2) {
        n.event.special[a2] = {
            delegateType: b2,
            bindType: b2,
            handle: function(a3) {
                var c2, d2 = this,
                    e2 = a3.relatedTarget,
                    f2 = a3.handleObj;
                return e2 && (e2 === d2 || n.contains(d2, e2)) || (a3.type = f2.origType, c2 = f2.handler.apply(this, arguments), a3.type = b2), c2
            }
        }
    }), l.submit || (n.event.special.submit = {
        setup: function() {
            return n.nodeName(this, "form") ? !1 : void n.event.add(this, "click._submit keypress._submit", function(a2) {
                var b2 = a2.target,
                    c2 = n.nodeName(b2, "input") || n.nodeName(b2, "button") ? n.prop(b2, "form") : void 0;
                c2 && !n._data(c2, "submit") && (n.event.add(c2, "submit._submit", function(a3) {
                    a3._submitBubble = !0
                }), n._data(c2, "submit", !0))
            })
        },
        postDispatch: function(a2) {
            a2._submitBubble && (delete a2._submitBubble, this.parentNode && !a2.isTrigger && n.event.simulate("submit", this.parentNode, a2))
        },
        teardown: function() {
            return n.nodeName(this, "form") ? !1 : void n.event.remove(this, "._submit")
        }
    }), l.change || (n.event.special.change = {
        setup: function() {
            return ka.test(this.nodeName) ? (this.type !== "checkbox" && this.type !== "radio" || (n.event.add(this, "propertychange._change", function(a2) {
                a2.originalEvent.propertyName === "checked" && (this._justChanged = !0)
            }), n.event.add(this, "click._change", function(a2) {
                this._justChanged && !a2.isTrigger && (this._justChanged = !1), n.event.simulate("change", this, a2)
            })), !1) : void n.event.add(this, "beforeactivate._change", function(a2) {
                var b2 = a2.target;
                ka.test(b2.nodeName) && !n._data(b2, "change") && (n.event.add(b2, "change._change", function(a3) {
                    !this.parentNode || a3.isSimulated || a3.isTrigger || n.event.simulate("change", this.parentNode, a3)
                }), n._data(b2, "change", !0))
            })
        },
        handle: function(a2) {
            var b2 = a2.target;
            return this !== b2 || a2.isSimulated || a2.isTrigger || b2.type !== "radio" && b2.type !== "checkbox" ? a2.handleObj.handler.apply(this, arguments) : void 0
        },
        teardown: function() {
            return n.event.remove(this, "._change"), !ka.test(this.nodeName)
        }
    }), l.focusin || n.each({
        focus: "focusin",
        blur: "focusout"
    }, function(a2, b2) {
        var c2 = function(a3) {
            n.event.simulate(b2, a3.target, n.event.fix(a3))
        };
        n.event.special[b2] = {
            setup: function() {
                var d2 = this.ownerDocument || this,
                    e2 = n._data(d2, b2);
                e2 || d2.addEventListener(a2, c2, !0), n._data(d2, b2, (e2 || 0) + 1)
            },
            teardown: function() {
                var d2 = this.ownerDocument || this,
                    e2 = n._data(d2, b2) - 1;
                e2 ? n._data(d2, b2, e2) : (d2.removeEventListener(a2, c2, !0), n._removeData(d2, b2))
            }
        }
    }), n.fn.extend({
        on: function(a2, b2, c2, d2) {
            return sa(this, a2, b2, c2, d2)
        },
        one: function(a2, b2, c2, d2) {
            return sa(this, a2, b2, c2, d2, 1)
        },
        off: function(a2, b2, c2) {
            var d2, e2;
            if (a2 && a2.preventDefault && a2.handleObj) return d2 = a2.handleObj, n(a2.delegateTarget).off(d2.namespace ? d2.origType + "." + d2.namespace : d2.origType, d2.selector, d2.handler), this;
            if (typeof a2 == "object") {
                for (e2 in a2) this.off(e2, b2, a2[e2]);
                return this
            }
            return b2 !== !1 && typeof b2 != "function" || (c2 = b2, b2 = void 0), c2 === !1 && (c2 = qa), this.each(function() {
                n.event.remove(this, a2, c2, b2)
            })
        },
        trigger: function(a2, b2) {
            return this.each(function() {
                n.event.trigger(a2, b2, this)
            })
        },
        triggerHandler: function(a2, b2) {
            var c2 = this[0];
            return c2 ? n.event.trigger(a2, b2, c2, !0) : void 0
        }
    });
    var ta = / jQuery\d+="(?:null|\d+)"/g,
        ua = new RegExp("<(?:" + ba + ")[\\s/>]", "i"),
        va = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
        wa = /<script|<style|<link/i,
        xa = /checked\s*(?:[^=]|=\s*.checked.)/i,
        ya = /^true\/(.*)/,
        za = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
        Aa = ca(d),
        Ba = Aa.appendChild(d.createElement("div"));

    function Ca(a2, b2) {
        return n.nodeName(a2, "table") && n.nodeName(b2.nodeType !== 11 ? b2 : b2.firstChild, "tr") ? a2.getElementsByTagName("tbody")[0] || a2.appendChild(a2.ownerDocument.createElement("tbody")) : a2
    }

    function Da(a2) {
        return a2.type = (n.find.attr(a2, "type") !== null) + "/" + a2.type, a2
    }

    function Ea(a2) {
        var b2 = ya.exec(a2.type);
        return b2 ? a2.type = b2[1] : a2.removeAttribute("type"), a2
    }

    function Fa(a2, b2) {
        if (b2.nodeType === 1 && n.hasData(a2)) {
            var c2, d2, e2, f2 = n._data(a2),
                g2 = n._data(b2, f2),
                h2 = f2.events;
            if (h2) {
                delete g2.handle, g2.events = {};
                for (c2 in h2)
                    for (d2 = 0, e2 = h2[c2].length; e2 > d2; d2++) n.event.add(b2, c2, h2[c2][d2])
            }
            g2.data && (g2.data = n.extend({}, g2.data))
        }
    }

    function Ga(a2, b2) {
        var c2, d2, e2;
        if (b2.nodeType === 1) {
            if (c2 = b2.nodeName.toLowerCase(), !l.noCloneEvent && b2[n.expando]) {
                e2 = n._data(b2);
                for (d2 in e2.events) n.removeEvent(b2, d2, e2.handle);
                b2.removeAttribute(n.expando)
            }
            c2 === "script" && b2.text !== a2.text ? (Da(b2).text = a2.text, Ea(b2)) : c2 === "object" ? (b2.parentNode && (b2.outerHTML = a2.outerHTML), l.html5Clone && a2.innerHTML && !n.trim(b2.innerHTML) && (b2.innerHTML = a2.innerHTML)) : c2 === "input" && Z.test(a2.type) ? (b2.defaultChecked = b2.checked = a2.checked, b2.value !== a2.value && (b2.value = a2.value)) : c2 === "option" ? b2.defaultSelected = b2.selected = a2.defaultSelected : c2 !== "input" && c2 !== "textarea" || (b2.defaultValue = a2.defaultValue)
        }
    }

    function Ha(a2, b2, c2, d2) {
        b2 = f.apply([], b2);
        var e2, g2, h2, i2, j2, k2, m2 = 0,
            o2 = a2.length,
            p2 = o2 - 1,
            q2 = b2[0],
            r2 = n.isFunction(q2);
        if (r2 || o2 > 1 && typeof q2 == "string" && !l.checkClone && xa.test(q2)) return a2.each(function(e3) {
            var f2 = a2.eq(e3);
            r2 && (b2[0] = q2.call(this, e3, f2.html())), Ha(f2, b2, c2, d2)
        });
        if (o2 && (k2 = ja(b2, a2[0].ownerDocument, !1, a2, d2), e2 = k2.firstChild, k2.childNodes.length === 1 && (k2 = e2), e2 || d2)) {
            for (i2 = n.map(ea(k2, "script"), Da), h2 = i2.length; o2 > m2; m2++) g2 = k2, m2 !== p2 && (g2 = n.clone(g2, !0, !0), h2 && n.merge(i2, ea(g2, "script"))), c2.call(a2[m2], g2, m2);
            if (h2)
                for (j2 = i2[i2.length - 1].ownerDocument, n.map(i2, Ea), m2 = 0; h2 > m2; m2++) g2 = i2[m2], _.test(g2.type || "") && !n._data(g2, "globalEval") && n.contains(j2, g2) && (g2.src ? n._evalUrl && n._evalUrl(g2.src) : n.globalEval((g2.text || g2.textContent || g2.innerHTML || "").replace(za, "")));
            k2 = e2 = null
        }
        return a2
    }

    function Ia(a2, b2, c2) {
        for (var d2, e2 = b2 ? n.filter(b2, a2) : a2, f2 = 0;
            (d2 = e2[f2]) != null; f2++) c2 || d2.nodeType !== 1 || n.cleanData(ea(d2)), d2.parentNode && (c2 && n.contains(d2.ownerDocument, d2) && fa(ea(d2, "script")), d2.parentNode.removeChild(d2));
        return a2
    }
    n.extend({
        htmlPrefilter: function(a2) {
            return a2.replace(va, "<$1></$2>")
        },
        clone: function(a2, b2, c2) {
            var d2, e2, f2, g2, h2, i2 = n.contains(a2.ownerDocument, a2);
            if (l.html5Clone || n.isXMLDoc(a2) || !ua.test("<" + a2.nodeName + ">") ? f2 = a2.cloneNode(!0) : (Ba.innerHTML = a2.outerHTML, Ba.removeChild(f2 = Ba.firstChild)), !(l.noCloneEvent && l.noCloneChecked || a2.nodeType !== 1 && a2.nodeType !== 11 || n.isXMLDoc(a2)))
                for (d2 = ea(f2), h2 = ea(a2), g2 = 0;
                    (e2 = h2[g2]) != null; ++g2) d2[g2] && Ga(e2, d2[g2]);
            if (b2)
                if (c2)
                    for (h2 = h2 || ea(a2), d2 = d2 || ea(f2), g2 = 0;
                        (e2 = h2[g2]) != null; g2++) Fa(e2, d2[g2]);
                else Fa(a2, f2);
            return d2 = ea(f2, "script"), d2.length > 0 && fa(d2, !i2 && ea(a2, "script")), d2 = h2 = e2 = null, f2
        },
        cleanData: function(a2, b2) {
            for (var d2, e2, f2, g2, h2 = 0, i2 = n.expando, j2 = n.cache, k2 = l.attributes, m2 = n.event.special;
                (d2 = a2[h2]) != null; h2++)
                if ((b2 || M(d2)) && (f2 = d2[i2], g2 = f2 && j2[f2])) {
                    if (g2.events)
                        for (e2 in g2.events) m2[e2] ? n.event.remove(d2, e2) : n.removeEvent(d2, e2, g2.handle);
                    j2[f2] && (delete j2[f2], k2 || typeof d2.removeAttribute > "u" ? d2[i2] = void 0 : d2.removeAttribute(i2), c.push(f2))
                }
        }
    }), n.fn.extend({
        domManip: Ha,
        detach: function(a2) {
            return Ia(this, a2, !0)
        },
        remove: function(a2) {
            return Ia(this, a2)
        },
        text: function(a2) {
            return Y(this, function(a3) {
                return a3 === void 0 ? n.text(this) : this.empty().append((this[0] && this[0].ownerDocument || d).createTextNode(a3))
            }, null, a2, arguments.length)
        },
        append: function() {
            return Ha(this, arguments, function(a2) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var b2 = Ca(this, a2);
                    b2.appendChild(a2)
                }
            })
        },
        prepend: function() {
            return Ha(this, arguments, function(a2) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var b2 = Ca(this, a2);
                    b2.insertBefore(a2, b2.firstChild)
                }
            })
        },
        before: function() {
            return Ha(this, arguments, function(a2) {
                this.parentNode && this.parentNode.insertBefore(a2, this)
            })
        },
        after: function() {
            return Ha(this, arguments, function(a2) {
                this.parentNode && this.parentNode.insertBefore(a2, this.nextSibling)
            })
        },
        empty: function() {
            for (var a2, b2 = 0;
                (a2 = this[b2]) != null; b2++) {
                for (a2.nodeType === 1 && n.cleanData(ea(a2, !1)); a2.firstChild;) a2.removeChild(a2.firstChild);
                a2.options && n.nodeName(a2, "select") && (a2.options.length = 0)
            }
            return this
        },
        clone: function(a2, b2) {
            return a2 = a2 ?? !1, b2 = b2 ?? a2, this.map(function() {
                return n.clone(this, a2, b2)
            })
        },
        html: function(a2) {
            return Y(this, function(a3) {
                var b2 = this[0] || {},
                    c2 = 0,
                    d2 = this.length;
                if (a3 === void 0) return b2.nodeType === 1 ? b2.innerHTML.replace(ta, "") : void 0;
                if (typeof a3 == "string" && !wa.test(a3) && (l.htmlSerialize || !ua.test(a3)) && (l.leadingWhitespace || !aa.test(a3)) && !da[($2.exec(a3) || ["", ""])[1].toLowerCase()]) {
                    a3 = n.htmlPrefilter(a3);
                    try {
                        for (; d2 > c2; c2++) b2 = this[c2] || {}, b2.nodeType === 1 && (n.cleanData(ea(b2, !1)), b2.innerHTML = a3);
                        b2 = 0
                    } catch {}
                }
                b2 && this.empty().append(a3)
            }, null, a2, arguments.length)
        },
        replaceWith: function() {
            var a2 = [];
            return Ha(this, arguments, function(b2) {
                var c2 = this.parentNode;
                n.inArray(this, a2) < 0 && (n.cleanData(ea(this)), c2 && c2.replaceChild(b2, this))
            }, a2)
        }
    }), n.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(a2, b2) {
        n.fn[a2] = function(a3) {
            for (var c2, d2 = 0, e2 = [], f2 = n(a3), h2 = f2.length - 1; h2 >= d2; d2++) c2 = d2 === h2 ? this : this.clone(!0), n(f2[d2])[b2](c2), g.apply(e2, c2.get());
            return this.pushStack(e2)
        }
    });
    var Ja, Ka = {
        HTML: "block",
        BODY: "block"
    };

    function La(a2, b2) {
        var c2 = n(b2.createElement(a2)).appendTo(b2.body),
            d2 = n.css(c2[0], "display");
        return c2.detach(), d2
    }

    function Ma(a2) {
        var b2 = d,
            c2 = Ka[a2];
        return c2 || (c2 = La(a2, b2), c2 !== "none" && c2 || (Ja = (Ja || n("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b2.documentElement), b2 = (Ja[0].contentWindow || Ja[0].contentDocument).document, b2.write(), b2.close(), c2 = La(a2, b2), Ja.detach()), Ka[a2] = c2), c2
    }
    var Na = /^margin/,
        Oa = new RegExp("^(" + T + ")(?!px)[a-z%]+$", "i"),
        Pa = function(a2, b2, c2, d2) {
            var e2, f2, g2 = {};
            for (f2 in b2) g2[f2] = a2.style[f2], a2.style[f2] = b2[f2];
            e2 = c2.apply(a2, d2 || []);
            for (f2 in b2) a2.style[f2] = g2[f2];
            return e2
        },
        Qa = d.documentElement;
    (function() {
        var b2, c2, e2, f2, g2, h2, i2 = d.createElement("div"),
            j2 = d.createElement("div");
        if (j2.style) {
            let k3 = function() {
                var k4, l2, m2 = d.documentElement;
                m2.appendChild(i2), j2.style.cssText = "-webkit-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%", b2 = e2 = h2 = !1, c2 = g2 = !0, a.getComputedStyle && (l2 = a.getComputedStyle(j2), b2 = (l2 || {}).top !== "1%", h2 = (l2 || {}).marginLeft === "2px", e2 = (l2 || {
                    width: "4px"
                }).width === "4px", j2.style.marginRight = "50%", c2 = (l2 || {
                    marginRight: "4px"
                }).marginRight === "4px", k4 = j2.appendChild(d.createElement("div")), k4.style.cssText = j2.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0", k4.style.marginRight = k4.style.width = "0", j2.style.width = "1px", g2 = !parseFloat((a.getComputedStyle(k4) || {}).marginRight), j2.removeChild(k4)), j2.style.display = "none", f2 = j2.getClientRects().length === 0, f2 && (j2.style.display = "", j2.innerHTML = "<table><tr><td></td><td>t</td></tr></table>", j2.childNodes[0].style.borderCollapse = "separate", k4 = j2.getElementsByTagName("td"), k4[0].style.cssText = "margin:0;border:0;padding:0;display:none", f2 = k4[0].offsetHeight === 0, f2 && (k4[0].style.display = "", k4[1].style.display = "none", f2 = k4[0].offsetHeight === 0)), m2.removeChild(i2)
            };
            var k2 = k3;
            j2.style.cssText = "float:left;opacity:.5", l.opacity = j2.style.opacity === "0.5", l.cssFloat = !!j2.style.cssFloat, j2.style.backgroundClip = "content-box", j2.cloneNode(!0).style.backgroundClip = "", l.clearCloneStyle = j2.style.backgroundClip === "content-box", i2 = d.createElement("div"), i2.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute", j2.innerHTML = "", i2.appendChild(j2), l.boxSizing = j2.style.boxSizing === "" || j2.style.MozBoxSizing === "" || j2.style.WebkitBoxSizing === "", n.extend(l, {
                reliableHiddenOffsets: function() {
                    return b2 == null && k3(), f2
                },
                boxSizingReliable: function() {
                    return b2 == null && k3(), e2
                },
                pixelMarginRight: function() {
                    return b2 == null && k3(), c2
                },
                pixelPosition: function() {
                    return b2 == null && k3(), b2
                },
                reliableMarginRight: function() {
                    return b2 == null && k3(), g2
                },
                reliableMarginLeft: function() {
                    return b2 == null && k3(), h2
                }
            })
        }
    })();
    var Ra, Sa, Ta = /^(top|right|bottom|left)$/;
    a.getComputedStyle ? (Ra = function(b2) {
        var c2 = b2.ownerDocument.defaultView;
        return c2 && c2.opener || (c2 = a), c2.getComputedStyle(b2)
    }, Sa = function(a2, b2, c2) {
        var d2, e2, f2, g2, h2 = a2.style;
        return c2 = c2 || Ra(a2), g2 = c2 ? c2.getPropertyValue(b2) || c2[b2] : void 0, g2 !== "" && g2 !== void 0 || n.contains(a2.ownerDocument, a2) || (g2 = n.style(a2, b2)), c2 && !l.pixelMarginRight() && Oa.test(g2) && Na.test(b2) && (d2 = h2.width, e2 = h2.minWidth, f2 = h2.maxWidth, h2.minWidth = h2.maxWidth = h2.width = g2, g2 = c2.width, h2.width = d2, h2.minWidth = e2, h2.maxWidth = f2), g2 === void 0 ? g2 : g2 + ""
    }) : Qa.currentStyle && (Ra = function(a2) {
        return a2.currentStyle
    }, Sa = function(a2, b2, c2) {
        var d2, e2, f2, g2, h2 = a2.style;
        return c2 = c2 || Ra(a2), g2 = c2 ? c2[b2] : void 0, g2 == null && h2 && h2[b2] && (g2 = h2[b2]), Oa.test(g2) && !Ta.test(b2) && (d2 = h2.left, e2 = a2.runtimeStyle, f2 = e2 && e2.left, f2 && (e2.left = a2.currentStyle.left), h2.left = b2 === "fontSize" ? "1em" : g2, g2 = h2.pixelLeft + "px", h2.left = d2, f2 && (e2.left = f2)), g2 === void 0 ? g2 : g2 + "" || "auto"
    });

    function Ua(a2, b2) {
        return {
            get: function() {
                return a2() ? void delete this.get : (this.get = b2).apply(this, arguments)
            }
        }
    }
    var Va = /alpha\([^)]*\)/i,
        Wa = /opacity\s*=\s*([^)]*)/i,
        Xa = /^(none|table(?!-c[ea]).+)/,
        Ya = new RegExp("^(" + T + ")(.*)$", "i"),
        Za = {
            position: "absolute",
            visibility: "hidden",
            display: "block"
        },
        $a = {
            letterSpacing: "0",
            fontWeight: "400"
        },
        _a = ["Webkit", "O", "Moz", "ms"],
        ab = d.createElement("div").style;

    function bb(a2) {
        if (a2 in ab) return a2;
        for (var b2 = a2.charAt(0).toUpperCase() + a2.slice(1), c2 = _a.length; c2--;)
            if (a2 = _a[c2] + b2, a2 in ab) return a2
    }

    function cb(a2, b2) {
        for (var c2, d2, e2, f2 = [], g2 = 0, h2 = a2.length; h2 > g2; g2++) d2 = a2[g2], d2.style && (f2[g2] = n._data(d2, "olddisplay"), c2 = d2.style.display, b2 ? (f2[g2] || c2 !== "none" || (d2.style.display = ""), d2.style.display === "" && W(d2) && (f2[g2] = n._data(d2, "olddisplay", Ma(d2.nodeName)))) : (e2 = W(d2), (c2 && c2 !== "none" || !e2) && n._data(d2, "olddisplay", e2 ? c2 : n.css(d2, "display"))));
        for (g2 = 0; h2 > g2; g2++) d2 = a2[g2], d2.style && (b2 && d2.style.display !== "none" && d2.style.display !== "" || (d2.style.display = b2 ? f2[g2] || "" : "none"));
        return a2
    }

    function db(a2, b2, c2) {
        var d2 = Ya.exec(b2);
        return d2 ? Math.max(0, d2[1] - (c2 || 0)) + (d2[2] || "px") : b2
    }

    function eb(a2, b2, c2, d2, e2) {
        for (var f2 = c2 === (d2 ? "border" : "content") ? 4 : b2 === "width" ? 1 : 0, g2 = 0; 4 > f2; f2 += 2) c2 === "margin" && (g2 += n.css(a2, c2 + V[f2], !0, e2)), d2 ? (c2 === "content" && (g2 -= n.css(a2, "padding" + V[f2], !0, e2)), c2 !== "margin" && (g2 -= n.css(a2, "border" + V[f2] + "Width", !0, e2))) : (g2 += n.css(a2, "padding" + V[f2], !0, e2), c2 !== "padding" && (g2 += n.css(a2, "border" + V[f2] + "Width", !0, e2)));
        return g2
    }

    function fb(a2, b2, c2) {
        var d2 = !0,
            e2 = b2 === "width" ? a2.offsetWidth : a2.offsetHeight,
            f2 = Ra(a2),
            g2 = l.boxSizing && n.css(a2, "boxSizing", !1, f2) === "border-box";
        if (0 >= e2 || e2 == null) {
            if (e2 = Sa(a2, b2, f2), (0 > e2 || e2 == null) && (e2 = a2.style[b2]), Oa.test(e2)) return e2;
            d2 = g2 && (l.boxSizingReliable() || e2 === a2.style[b2]), e2 = parseFloat(e2) || 0
        }
        return e2 + eb(a2, b2, c2 || (g2 ? "border" : "content"), d2, f2) + "px"
    }
    n.extend({
        cssHooks: {
            opacity: {
                get: function(a2, b2) {
                    if (b2) {
                        var c2 = Sa(a2, "opacity");
                        return c2 === "" ? "1" : c2
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {
            float: l.cssFloat ? "cssFloat" : "styleFloat"
        },
        style: function(a2, b2, c2, d2) {
            if (a2 && a2.nodeType !== 3 && a2.nodeType !== 8 && a2.style) {
                var e2, f2, g2, h2 = n.camelCase(b2),
                    i2 = a2.style;
                if (b2 = n.cssProps[h2] || (n.cssProps[h2] = bb(h2) || h2), g2 = n.cssHooks[b2] || n.cssHooks[h2], c2 === void 0) return g2 && "get" in g2 && (e2 = g2.get(a2, !1, d2)) !== void 0 ? e2 : i2[b2];
                if (f2 = typeof c2, f2 === "string" && (e2 = U.exec(c2)) && e2[1] && (c2 = X(a2, b2, e2), f2 = "number"), c2 != null && c2 === c2 && (f2 === "number" && (c2 += e2 && e2[3] || (n.cssNumber[h2] ? "" : "px")), l.clearCloneStyle || c2 !== "" || b2.indexOf("background") !== 0 || (i2[b2] = "inherit"), !(g2 && "set" in g2 && (c2 = g2.set(a2, c2, d2)) === void 0))) try {
                    i2[b2] = c2
                } catch {}
            }
        },
        css: function(a2, b2, c2, d2) {
            var e2, f2, g2, h2 = n.camelCase(b2);
            return b2 = n.cssProps[h2] || (n.cssProps[h2] = bb(h2) || h2), g2 = n.cssHooks[b2] || n.cssHooks[h2], g2 && "get" in g2 && (f2 = g2.get(a2, !0, c2)), f2 === void 0 && (f2 = Sa(a2, b2, d2)), f2 === "normal" && b2 in $a && (f2 = $a[b2]), c2 === "" || c2 ? (e2 = parseFloat(f2), c2 === !0 || isFinite(e2) ? e2 || 0 : f2) : f2
        }
    }), n.each(["height", "width"], function(a2, b2) {
        n.cssHooks[b2] = {
            get: function(a3, c2, d2) {
                return c2 ? Xa.test(n.css(a3, "display")) && a3.offsetWidth === 0 ? Pa(a3, Za, function() {
                    return fb(a3, b2, d2)
                }) : fb(a3, b2, d2) : void 0
            },
            set: function(a3, c2, d2) {
                var e2 = d2 && Ra(a3);
                return db(a3, c2, d2 ? eb(a3, b2, d2, l.boxSizing && n.css(a3, "boxSizing", !1, e2) === "border-box", e2) : 0)
            }
        }
    }), l.opacity || (n.cssHooks.opacity = {
        get: function(a2, b2) {
            return Wa.test((b2 && a2.currentStyle ? a2.currentStyle.filter : a2.style.filter) || "") ? .01 * parseFloat(RegExp.$1) + "" : b2 ? "1" : ""
        },
        set: function(a2, b2) {
            var c2 = a2.style,
                d2 = a2.currentStyle,
                e2 = n.isNumeric(b2) ? "alpha(opacity=" + 100 * b2 + ")" : "",
                f2 = d2 && d2.filter || c2.filter || "";
            c2.zoom = 1, (b2 >= 1 || b2 === "") && n.trim(f2.replace(Va, "")) === "" && c2.removeAttribute && (c2.removeAttribute("filter"), b2 === "" || d2 && !d2.filter) || (c2.filter = Va.test(f2) ? f2.replace(Va, e2) : f2 + " " + e2)
        }
    }), n.cssHooks.marginRight = Ua(l.reliableMarginRight, function(a2, b2) {
        return b2 ? Pa(a2, {
            display: "inline-block"
        }, Sa, [a2, "marginRight"]) : void 0
    }), n.cssHooks.marginLeft = Ua(l.reliableMarginLeft, function(a2, b2) {
        return b2 ? (parseFloat(Sa(a2, "marginLeft")) || (n.contains(a2.ownerDocument, a2) ? a2.getBoundingClientRect().left - Pa(a2, {
            marginLeft: 0
        }, function() {
            return a2.getBoundingClientRect().left
        }) : 0)) + "px" : void 0
    }), n.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(a2, b2) {
        n.cssHooks[a2 + b2] = {
            expand: function(c2) {
                for (var d2 = 0, e2 = {}, f2 = typeof c2 == "string" ? c2.split(" ") : [c2]; 4 > d2; d2++) e2[a2 + V[d2] + b2] = f2[d2] || f2[d2 - 2] || f2[0];
                return e2
            }
        }, Na.test(a2) || (n.cssHooks[a2 + b2].set = db)
    }), n.fn.extend({
        css: function(a2, b2) {
            return Y(this, function(a3, b3, c2) {
                var d2, e2, f2 = {},
                    g2 = 0;
                if (n.isArray(b3)) {
                    for (d2 = Ra(a3), e2 = b3.length; e2 > g2; g2++) f2[b3[g2]] = n.css(a3, b3[g2], !1, d2);
                    return f2
                }
                return c2 !== void 0 ? n.style(a3, b3, c2) : n.css(a3, b3)
            }, a2, b2, arguments.length > 1)
        },
        show: function() {
            return cb(this, !0)
        },
        hide: function() {
            return cb(this)
        },
        toggle: function(a2) {
            return typeof a2 == "boolean" ? a2 ? this.show() : this.hide() : this.each(function() {
                W(this) ? n(this).show() : n(this).hide()
            })
        }
    });

    function gb(a2, b2, c2, d2, e2) {
        return new gb.prototype.init(a2, b2, c2, d2, e2)
    }
    n.Tween = gb, gb.prototype = {
        constructor: gb,
        init: function(a2, b2, c2, d2, e2, f2) {
            this.elem = a2, this.prop = c2, this.easing = e2 || n.easing._default, this.options = b2, this.start = this.now = this.cur(), this.end = d2, this.unit = f2 || (n.cssNumber[c2] ? "" : "px")
        },
        cur: function() {
            var a2 = gb.propHooks[this.prop];
            return a2 && a2.get ? a2.get(this) : gb.propHooks._default.get(this)
        },
        run: function(a2) {
            var b2, c2 = gb.propHooks[this.prop];
            return this.options.duration ? this.pos = b2 = n.easing[this.easing](a2, this.options.duration * a2, 0, 1, this.options.duration) : this.pos = b2 = a2, this.now = (this.end - this.start) * b2 + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), c2 && c2.set ? c2.set(this) : gb.propHooks._default.set(this), this
        }
    }, gb.prototype.init.prototype = gb.prototype, gb.propHooks = {
        _default: {
            get: function(a2) {
                var b2;
                return a2.elem.nodeType !== 1 || a2.elem[a2.prop] != null && a2.elem.style[a2.prop] == null ? a2.elem[a2.prop] : (b2 = n.css(a2.elem, a2.prop, ""), b2 && b2 !== "auto" ? b2 : 0)
            },
            set: function(a2) {
                n.fx.step[a2.prop] ? n.fx.step[a2.prop](a2) : a2.elem.nodeType !== 1 || a2.elem.style[n.cssProps[a2.prop]] == null && !n.cssHooks[a2.prop] ? a2.elem[a2.prop] = a2.now : n.style(a2.elem, a2.prop, a2.now + a2.unit)
            }
        }
    }, gb.propHooks.scrollTop = gb.propHooks.scrollLeft = {
        set: function(a2) {
            a2.elem.nodeType && a2.elem.parentNode && (a2.elem[a2.prop] = a2.now)
        }
    }, n.easing = {
        linear: function(a2) {
            return a2
        },
        swing: function(a2) {
            return .5 - Math.cos(a2 * Math.PI) / 2
        },
        _default: "swing"
    }, n.fx = gb.prototype.init, n.fx.step = {};
    var hb, ib, jb = /^(?:toggle|show|hide)$/,
        kb = /queueHooks$/;

    function lb() {
        return a.setTimeout(function() {
            hb = void 0
        }), hb = n.now()
    }

    function mb(a2, b2) {
        var c2, d2 = {
                height: a2
            },
            e2 = 0;
        for (b2 = b2 ? 1 : 0; 4 > e2; e2 += 2 - b2) c2 = V[e2], d2["margin" + c2] = d2["padding" + c2] = a2;
        return b2 && (d2.opacity = d2.width = a2), d2
    }

    function nb(a2, b2, c2) {
        for (var d2, e2 = (qb.tweeners[b2] || []).concat(qb.tweeners["*"]), f2 = 0, g2 = e2.length; g2 > f2; f2++)
            if (d2 = e2[f2].call(c2, b2, a2)) return d2
    }

    function ob(a2, b2, c2) {
        var d2, e2, f2, g2, h2, i2, j2, k2, m2 = this,
            o2 = {},
            p2 = a2.style,
            q2 = a2.nodeType && W(a2),
            r2 = n._data(a2, "fxshow");
        c2.queue || (h2 = n._queueHooks(a2, "fx"), h2.unqueued == null && (h2.unqueued = 0, i2 = h2.empty.fire, h2.empty.fire = function() {
            h2.unqueued || i2()
        }), h2.unqueued++, m2.always(function() {
            m2.always(function() {
                h2.unqueued--, n.queue(a2, "fx").length || h2.empty.fire()
            })
        })), a2.nodeType === 1 && ("height" in b2 || "width" in b2) && (c2.overflow = [p2.overflow, p2.overflowX, p2.overflowY], j2 = n.css(a2, "display"), k2 = j2 === "none" ? n._data(a2, "olddisplay") || Ma(a2.nodeName) : j2, k2 === "inline" && n.css(a2, "float") === "none" && (l.inlineBlockNeedsLayout && Ma(a2.nodeName) !== "inline" ? p2.zoom = 1 : p2.display = "inline-block")), c2.overflow && (p2.overflow = "hidden", l.shrinkWrapBlocks() || m2.always(function() {
            p2.overflow = c2.overflow[0], p2.overflowX = c2.overflow[1], p2.overflowY = c2.overflow[2]
        }));
        for (d2 in b2)
            if (e2 = b2[d2], jb.exec(e2)) {
                if (delete b2[d2], f2 = f2 || e2 === "toggle", e2 === (q2 ? "hide" : "show")) {
                    if (e2 !== "show" || !r2 || r2[d2] === void 0) continue;
                    q2 = !0
                }
                o2[d2] = r2 && r2[d2] || n.style(a2, d2)
            } else j2 = void 0;
        if (n.isEmptyObject(o2))(j2 === "none" ? Ma(a2.nodeName) : j2) === "inline" && (p2.display = j2);
        else {
            r2 ? "hidden" in r2 && (q2 = r2.hidden) : r2 = n._data(a2, "fxshow", {}), f2 && (r2.hidden = !q2), q2 ? n(a2).show() : m2.done(function() {
                n(a2).hide()
            }), m2.done(function() {
                var b3;
                n._removeData(a2, "fxshow");
                for (b3 in o2) n.style(a2, b3, o2[b3])
            });
            for (d2 in o2) g2 = nb(q2 ? r2[d2] : 0, d2, m2), d2 in r2 || (r2[d2] = g2.start, q2 && (g2.end = g2.start, g2.start = d2 === "width" || d2 === "height" ? 1 : 0))
        }
    }

    function pb(a2, b2) {
        var c2, d2, e2, f2, g2;
        for (c2 in a2)
            if (d2 = n.camelCase(c2), e2 = b2[d2], f2 = a2[c2], n.isArray(f2) && (e2 = f2[1], f2 = a2[c2] = f2[0]), c2 !== d2 && (a2[d2] = f2, delete a2[c2]), g2 = n.cssHooks[d2], g2 && "expand" in g2) {
                f2 = g2.expand(f2), delete a2[d2];
                for (c2 in f2) c2 in a2 || (a2[c2] = f2[c2], b2[c2] = e2)
            } else b2[d2] = e2
    }

    function qb(a2, b2, c2) {
        var d2, e2, f2 = 0,
            g2 = qb.prefilters.length,
            h2 = n.Deferred().always(function() {
                delete i2.elem
            }),
            i2 = function() {
                if (e2) return !1;
                for (var b3 = hb || lb(), c3 = Math.max(0, j2.startTime + j2.duration - b3), d3 = c3 / j2.duration || 0, f3 = 1 - d3, g3 = 0, i3 = j2.tweens.length; i3 > g3; g3++) j2.tweens[g3].run(f3);
                return h2.notifyWith(a2, [j2, f3, c3]), 1 > f3 && i3 ? c3 : (h2.resolveWith(a2, [j2]), !1)
            },
            j2 = h2.promise({
                elem: a2,
                props: n.extend({}, b2),
                opts: n.extend(!0, {
                    specialEasing: {},
                    easing: n.easing._default
                }, c2),
                originalProperties: b2,
                originalOptions: c2,
                startTime: hb || lb(),
                duration: c2.duration,
                tweens: [],
                createTween: function(b3, c3) {
                    var d3 = n.Tween(a2, j2.opts, b3, c3, j2.opts.specialEasing[b3] || j2.opts.easing);
                    return j2.tweens.push(d3), d3
                },
                stop: function(b3) {
                    var c3 = 0,
                        d3 = b3 ? j2.tweens.length : 0;
                    if (e2) return this;
                    for (e2 = !0; d3 > c3; c3++) j2.tweens[c3].run(1);
                    return b3 ? (h2.notifyWith(a2, [j2, 1, 0]), h2.resolveWith(a2, [j2, b3])) : h2.rejectWith(a2, [j2, b3]), this
                }
            }),
            k2 = j2.props;
        for (pb(k2, j2.opts.specialEasing); g2 > f2; f2++)
            if (d2 = qb.prefilters[f2].call(j2, a2, k2, j2.opts)) return n.isFunction(d2.stop) && (n._queueHooks(j2.elem, j2.opts.queue).stop = n.proxy(d2.stop, d2)), d2;
        return n.map(k2, nb, j2), n.isFunction(j2.opts.start) && j2.opts.start.call(a2, j2), n.fx.timer(n.extend(i2, {
            elem: a2,
            anim: j2,
            queue: j2.opts.queue
        })), j2.progress(j2.opts.progress).done(j2.opts.done, j2.opts.complete).fail(j2.opts.fail).always(j2.opts.always)
    }
    n.Animation = n.extend(qb, {
            tweeners: {
                "*": [function(a2, b2) {
                    var c2 = this.createTween(a2, b2);
                    return X(c2.elem, a2, U.exec(b2), c2), c2
                }]
            },
            tweener: function(a2, b2) {
                n.isFunction(a2) ? (b2 = a2, a2 = ["*"]) : a2 = a2.match(G);
                for (var c2, d2 = 0, e2 = a2.length; e2 > d2; d2++) c2 = a2[d2], qb.tweeners[c2] = qb.tweeners[c2] || [], qb.tweeners[c2].unshift(b2)
            },
            prefilters: [ob],
            prefilter: function(a2, b2) {
                b2 ? qb.prefilters.unshift(a2) : qb.prefilters.push(a2)
            }
        }), n.speed = function(a2, b2, c2) {
            var d2 = a2 && typeof a2 == "object" ? n.extend({}, a2) : {
                complete: c2 || !c2 && b2 || n.isFunction(a2) && a2,
                duration: a2,
                easing: c2 && b2 || b2 && !n.isFunction(b2) && b2
            };
            return d2.duration = n.fx.off ? 0 : typeof d2.duration == "number" ? d2.duration : d2.duration in n.fx.speeds ? n.fx.speeds[d2.duration] : n.fx.speeds._default, d2.queue != null && d2.queue !== !0 || (d2.queue = "fx"), d2.old = d2.complete, d2.complete = function() {
                n.isFunction(d2.old) && d2.old.call(this), d2.queue && n.dequeue(this, d2.queue)
            }, d2
        }, n.fn.extend({
            fadeTo: function(a2, b2, c2, d2) {
                return this.filter(W).css("opacity", 0).show().end().animate({
                    opacity: b2
                }, a2, c2, d2)
            },
            animate: function(a2, b2, c2, d2) {
                var e2 = n.isEmptyObject(a2),
                    f2 = n.speed(b2, c2, d2),
                    g2 = function() {
                        var b3 = qb(this, n.extend({}, a2), f2);
                        (e2 || n._data(this, "finish")) && b3.stop(!0)
                    };
                return g2.finish = g2, e2 || f2.queue === !1 ? this.each(g2) : this.queue(f2.queue, g2)
            },
            stop: function(a2, b2, c2) {
                var d2 = function(a3) {
                    var b3 = a3.stop;
                    delete a3.stop, b3(c2)
                };
                return typeof a2 != "string" && (c2 = b2, b2 = a2, a2 = void 0), b2 && a2 !== !1 && this.queue(a2 || "fx", []), this.each(function() {
                    var b3 = !0,
                        e2 = a2 != null && a2 + "queueHooks",
                        f2 = n.timers,
                        g2 = n._data(this);
                    if (e2) g2[e2] && g2[e2].stop && d2(g2[e2]);
                    else
                        for (e2 in g2) g2[e2] && g2[e2].stop && kb.test(e2) && d2(g2[e2]);
                    for (e2 = f2.length; e2--;) f2[e2].elem !== this || a2 != null && f2[e2].queue !== a2 || (f2[e2].anim.stop(c2), b3 = !1, f2.splice(e2, 1));
                    !b3 && c2 || n.dequeue(this, a2)
                })
            },
            finish: function(a2) {
                return a2 !== !1 && (a2 = a2 || "fx"), this.each(function() {
                    var b2, c2 = n._data(this),
                        d2 = c2[a2 + "queue"],
                        e2 = c2[a2 + "queueHooks"],
                        f2 = n.timers,
                        g2 = d2 ? d2.length : 0;
                    for (c2.finish = !0, n.queue(this, a2, []), e2 && e2.stop && e2.stop.call(this, !0), b2 = f2.length; b2--;) f2[b2].elem === this && f2[b2].queue === a2 && (f2[b2].anim.stop(!0), f2.splice(b2, 1));
                    for (b2 = 0; g2 > b2; b2++) d2[b2] && d2[b2].finish && d2[b2].finish.call(this);
                    delete c2.finish
                })
            }
        }), n.each(["toggle", "show", "hide"], function(a2, b2) {
            var c2 = n.fn[b2];
            n.fn[b2] = function(a3, d2, e2) {
                return a3 == null || typeof a3 == "boolean" ? c2.apply(this, arguments) : this.animate(mb(b2, !0), a3, d2, e2)
            }
        }), n.each({
            slideDown: mb("show"),
            slideUp: mb("hide"),
            slideToggle: mb("toggle"),
            fadeIn: {
                opacity: "show"
            },
            fadeOut: {
                opacity: "hide"
            },
            fadeToggle: {
                opacity: "toggle"
            }
        }, function(a2, b2) {
            n.fn[a2] = function(a3, c2, d2) {
                return this.animate(b2, a3, c2, d2)
            }
        }), n.timers = [], n.fx.tick = function() {
            var a2, b2 = n.timers,
                c2 = 0;
            for (hb = n.now(); c2 < b2.length; c2++) a2 = b2[c2], a2() || b2[c2] !== a2 || b2.splice(c2--, 1);
            b2.length || n.fx.stop(), hb = void 0
        }, n.fx.timer = function(a2) {
            n.timers.push(a2), a2() ? n.fx.start() : n.timers.pop()
        }, n.fx.interval = 13, n.fx.start = function() {
            ib || (ib = a.setInterval(n.fx.tick, n.fx.interval))
        }, n.fx.stop = function() {
            a.clearInterval(ib), ib = null
        }, n.fx.speeds = {
            slow: 600,
            fast: 200,
            _default: 400
        }, n.fn.delay = function(b2, c2) {
            return b2 = n.fx && n.fx.speeds[b2] || b2, c2 = c2 || "fx", this.queue(c2, function(c3, d2) {
                var e2 = a.setTimeout(c3, b2);
                d2.stop = function() {
                    a.clearTimeout(e2)
                }
            })
        },
        function() {
            var a2, b2 = d.createElement("input"),
                c2 = d.createElement("div"),
                e2 = d.createElement("select"),
                f2 = e2.appendChild(d.createElement("option"));
            c2 = d.createElement("div"), c2.setAttribute("className", "t"), c2.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", a2 = c2.getElementsByTagName("a")[0], b2.setAttribute("type", "checkbox"), c2.appendChild(b2), a2 = c2.getElementsByTagName("a")[0], a2.style.cssText = "top:1px", l.getSetAttribute = c2.className !== "t", l.style = /top/.test(a2.getAttribute("style")), l.hrefNormalized = a2.getAttribute("href") === "/a", l.checkOn = !!b2.value, l.optSelected = f2.selected, l.enctype = !!d.createElement("form").enctype, e2.disabled = !0, l.optDisabled = !f2.disabled, b2 = d.createElement("input"), b2.setAttribute("value", ""), l.input = b2.getAttribute("value") === "", b2.value = "t", b2.setAttribute("type", "radio"), l.radioValue = b2.value === "t"
        }();
    var rb = /\r/g,
        sb = /[\x20\t\r\n\f]+/g;
    n.fn.extend({
        val: function(a2) {
            var b2, c2, d2, e2 = this[0];
            {
                if (arguments.length) return d2 = n.isFunction(a2), this.each(function(c3) {
                    var e3;
                    this.nodeType === 1 && (e3 = d2 ? a2.call(this, c3, n(this).val()) : a2, e3 == null ? e3 = "" : typeof e3 == "number" ? e3 += "" : n.isArray(e3) && (e3 = n.map(e3, function(a3) {
                        return a3 == null ? "" : a3 + ""
                    })), b2 = n.valHooks[this.type] || n.valHooks[this.nodeName.toLowerCase()], b2 && "set" in b2 && b2.set(this, e3, "value") !== void 0 || (this.value = e3))
                });
                if (e2) return b2 = n.valHooks[e2.type] || n.valHooks[e2.nodeName.toLowerCase()], b2 && "get" in b2 && (c2 = b2.get(e2, "value")) !== void 0 ? c2 : (c2 = e2.value, typeof c2 == "string" ? c2.replace(rb, "") : c2 ?? "")
            }
        }
    }), n.extend({
        valHooks: {
            option: {
                get: function(a2) {
                    var b2 = n.find.attr(a2, "value");
                    return b2 ?? n.trim(n.text(a2)).replace(sb, " ")
                }
            },
            select: {
                get: function(a2) {
                    for (var b2, c2, d2 = a2.options, e2 = a2.selectedIndex, f2 = a2.type === "select-one" || 0 > e2, g2 = f2 ? null : [], h2 = f2 ? e2 + 1 : d2.length, i2 = 0 > e2 ? h2 : f2 ? e2 : 0; h2 > i2; i2++)
                        if (c2 = d2[i2], (c2.selected || i2 === e2) && (l.optDisabled ? !c2.disabled : c2.getAttribute("disabled") === null) && (!c2.parentNode.disabled || !n.nodeName(c2.parentNode, "optgroup"))) {
                            if (b2 = n(c2).val(), f2) return b2;
                            g2.push(b2)
                        } return g2
                },
                set: function(a2, b2) {
                    for (var c2, d2, e2 = a2.options, f2 = n.makeArray(b2), g2 = e2.length; g2--;)
                        if (d2 = e2[g2], n.inArray(n.valHooks.option.get(d2), f2) > -1) try {
                            d2.selected = c2 = !0
                        } catch {
                            d2.scrollHeight
                        } else d2.selected = !1;
                    return c2 || (a2.selectedIndex = -1), e2
                }
            }
        }
    }), n.each(["radio", "checkbox"], function() {
        n.valHooks[this] = {
            set: function(a2, b2) {
                return n.isArray(b2) ? a2.checked = n.inArray(n(a2).val(), b2) > -1 : void 0
            }
        }, l.checkOn || (n.valHooks[this].get = function(a2) {
            return a2.getAttribute("value") === null ? "on" : a2.value
        })
    });
    var tb, ub, vb = n.expr.attrHandle,
        wb = /^(?:checked|selected)$/i,
        xb = l.getSetAttribute,
        yb = l.input;
    n.fn.extend({
        attr: function(a2, b2) {
            return Y(this, n.attr, a2, b2, arguments.length > 1)
        },
        removeAttr: function(a2) {
            return this.each(function() {
                n.removeAttr(this, a2)
            })
        }
    }), n.extend({
        attr: function(a2, b2, c2) {
            var d2, e2, f2 = a2.nodeType;
            if (f2 !== 3 && f2 !== 8 && f2 !== 2) return typeof a2.getAttribute > "u" ? n.prop(a2, b2, c2) : (f2 === 1 && n.isXMLDoc(a2) || (b2 = b2.toLowerCase(), e2 = n.attrHooks[b2] || (n.expr.match.bool.test(b2) ? ub : tb)), c2 !== void 0 ? c2 === null ? void n.removeAttr(a2, b2) : e2 && "set" in e2 && (d2 = e2.set(a2, c2, b2)) !== void 0 ? d2 : (a2.setAttribute(b2, c2 + ""), c2) : e2 && "get" in e2 && (d2 = e2.get(a2, b2)) !== null ? d2 : (d2 = n.find.attr(a2, b2), d2 ?? void 0))
        },
        attrHooks: {
            type: {
                set: function(a2, b2) {
                    if (!l.radioValue && b2 === "radio" && n.nodeName(a2, "input")) {
                        var c2 = a2.value;
                        return a2.setAttribute("type", b2), c2 && (a2.value = c2), b2
                    }
                }
            }
        },
        removeAttr: function(a2, b2) {
            var c2, d2, e2 = 0,
                f2 = b2 && b2.match(G);
            if (f2 && a2.nodeType === 1)
                for (; c2 = f2[e2++];) d2 = n.propFix[c2] || c2, n.expr.match.bool.test(c2) ? yb && xb || !wb.test(c2) ? a2[d2] = !1 : a2[n.camelCase("default-" + c2)] = a2[d2] = !1 : n.attr(a2, c2, ""), a2.removeAttribute(xb ? c2 : d2)
        }
    }), ub = {
        set: function(a2, b2, c2) {
            return b2 === !1 ? n.removeAttr(a2, c2) : yb && xb || !wb.test(c2) ? a2.setAttribute(!xb && n.propFix[c2] || c2, c2) : a2[n.camelCase("default-" + c2)] = a2[c2] = !0, c2
        }
    }, n.each(n.expr.match.bool.source.match(/\w+/g), function(a2, b2) {
        var c2 = vb[b2] || n.find.attr;
        yb && xb || !wb.test(b2) ? vb[b2] = function(a3, b3, d2) {
            var e2, f2;
            return d2 || (f2 = vb[b3], vb[b3] = e2, e2 = c2(a3, b3, d2) != null ? b3.toLowerCase() : null, vb[b3] = f2), e2
        } : vb[b2] = function(a3, b3, c3) {
            return c3 ? void 0 : a3[n.camelCase("default-" + b3)] ? b3.toLowerCase() : null
        }
    }), yb && xb || (n.attrHooks.value = {
        set: function(a2, b2, c2) {
            return n.nodeName(a2, "input") ? void(a2.defaultValue = b2) : tb && tb.set(a2, b2, c2)
        }
    }), xb || (tb = {
        set: function(a2, b2, c2) {
            var d2 = a2.getAttributeNode(c2);
            return d2 || a2.setAttributeNode(d2 = a2.ownerDocument.createAttribute(c2)), d2.value = b2 += "", c2 === "value" || b2 === a2.getAttribute(c2) ? b2 : void 0
        }
    }, vb.id = vb.name = vb.coords = function(a2, b2, c2) {
        var d2;
        return c2 ? void 0 : (d2 = a2.getAttributeNode(b2)) && d2.value !== "" ? d2.value : null
    }, n.valHooks.button = {
        get: function(a2, b2) {
            var c2 = a2.getAttributeNode(b2);
            return c2 && c2.specified ? c2.value : void 0
        },
        set: tb.set
    }, n.attrHooks.contenteditable = {
        set: function(a2, b2, c2) {
            tb.set(a2, b2 === "" ? !1 : b2, c2)
        }
    }, n.each(["width", "height"], function(a2, b2) {
        n.attrHooks[b2] = {
            set: function(a3, c2) {
                return c2 === "" ? (a3.setAttribute(b2, "auto"), c2) : void 0
            }
        }
    })), l.style || (n.attrHooks.style = {
        get: function(a2) {
            return a2.style.cssText || void 0
        },
        set: function(a2, b2) {
            return a2.style.cssText = b2 + ""
        }
    });
    var zb = /^(?:input|select|textarea|button|object)$/i,
        Ab = /^(?:a|area)$/i;
    n.fn.extend({
        prop: function(a2, b2) {
            return Y(this, n.prop, a2, b2, arguments.length > 1)
        },
        removeProp: function(a2) {
            return a2 = n.propFix[a2] || a2, this.each(function() {
                try {
                    this[a2] = void 0, delete this[a2]
                } catch {}
            })
        }
    }), n.extend({
        prop: function(a2, b2, c2) {
            var d2, e2, f2 = a2.nodeType;
            if (f2 !== 3 && f2 !== 8 && f2 !== 2) return f2 === 1 && n.isXMLDoc(a2) || (b2 = n.propFix[b2] || b2, e2 = n.propHooks[b2]), c2 !== void 0 ? e2 && "set" in e2 && (d2 = e2.set(a2, c2, b2)) !== void 0 ? d2 : a2[b2] = c2 : e2 && "get" in e2 && (d2 = e2.get(a2, b2)) !== null ? d2 : a2[b2]
        },
        propHooks: {
            tabIndex: {
                get: function(a2) {
                    var b2 = n.find.attr(a2, "tabindex");
                    return b2 ? parseInt(b2, 10) : zb.test(a2.nodeName) || Ab.test(a2.nodeName) && a2.href ? 0 : -1
                }
            }
        },
        propFix: {
            for: "htmlFor",
            class: "className"
        }
    }), l.hrefNormalized || n.each(["href", "src"], function(a2, b2) {
        n.propHooks[b2] = {
            get: function(a3) {
                return a3.getAttribute(b2, 4)
            }
        }
    }), l.optSelected || (n.propHooks.selected = {
        get: function(a2) {
            var b2 = a2.parentNode;
            return b2 && (b2.selectedIndex, b2.parentNode && b2.parentNode.selectedIndex), null
        },
        set: function(a2) {
            var b2 = a2.parentNode;
            b2 && (b2.selectedIndex, b2.parentNode && b2.parentNode.selectedIndex)
        }
    }), n.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
        n.propFix[this.toLowerCase()] = this
    }), l.enctype || (n.propFix.enctype = "encoding");
    var Bb = /[\t\r\n\f]/g;

    function Cb(a2) {
        return n.attr(a2, "class") || ""
    }
    n.fn.extend({
        addClass: function(a2) {
            var b2, c2, d2, e2, f2, g2, h2, i2 = 0;
            if (n.isFunction(a2)) return this.each(function(b3) {
                n(this).addClass(a2.call(this, b3, Cb(this)))
            });
            if (typeof a2 == "string" && a2) {
                for (b2 = a2.match(G) || []; c2 = this[i2++];)
                    if (e2 = Cb(c2), d2 = c2.nodeType === 1 && (" " + e2 + " ").replace(Bb, " ")) {
                        for (g2 = 0; f2 = b2[g2++];) d2.indexOf(" " + f2 + " ") < 0 && (d2 += f2 + " ");
                        h2 = n.trim(d2), e2 !== h2 && n.attr(c2, "class", h2)
                    }
            }
            return this
        },
        removeClass: function(a2) {
            var b2, c2, d2, e2, f2, g2, h2, i2 = 0;
            if (n.isFunction(a2)) return this.each(function(b3) {
                n(this).removeClass(a2.call(this, b3, Cb(this)))
            });
            if (!arguments.length) return this.attr("class", "");
            if (typeof a2 == "string" && a2) {
                for (b2 = a2.match(G) || []; c2 = this[i2++];)
                    if (e2 = Cb(c2), d2 = c2.nodeType === 1 && (" " + e2 + " ").replace(Bb, " ")) {
                        for (g2 = 0; f2 = b2[g2++];)
                            for (; d2.indexOf(" " + f2 + " ") > -1;) d2 = d2.replace(" " + f2 + " ", " ");
                        h2 = n.trim(d2), e2 !== h2 && n.attr(c2, "class", h2)
                    }
            }
            return this
        },
        toggleClass: function(a2, b2) {
            var c2 = typeof a2;
            return typeof b2 == "boolean" && c2 === "string" ? b2 ? this.addClass(a2) : this.removeClass(a2) : n.isFunction(a2) ? this.each(function(c3) {
                n(this).toggleClass(a2.call(this, c3, Cb(this), b2), b2)
            }) : this.each(function() {
                var b3, d2, e2, f2;
                if (c2 === "string")
                    for (d2 = 0, e2 = n(this), f2 = a2.match(G) || []; b3 = f2[d2++];) e2.hasClass(b3) ? e2.removeClass(b3) : e2.addClass(b3);
                else a2 !== void 0 && c2 !== "boolean" || (b3 = Cb(this), b3 && n._data(this, "__className__", b3), n.attr(this, "class", b3 || a2 === !1 ? "" : n._data(this, "__className__") || ""))
            })
        },
        hasClass: function(a2) {
            var b2, c2, d2 = 0;
            for (b2 = " " + a2 + " "; c2 = this[d2++];)
                if (c2.nodeType === 1 && (" " + Cb(c2) + " ").replace(Bb, " ").indexOf(b2) > -1) return !0;
            return !1
        }
    }), n.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function(a2, b2) {
        n.fn[b2] = function(a3, c2) {
            return arguments.length > 0 ? this.on(b2, null, a3, c2) : this.trigger(b2)
        }
    }), n.fn.extend({
        hover: function(a2, b2) {
            return this.mouseenter(a2).mouseleave(b2 || a2)
        }
    });
    var Db = a.location,
        Eb = n.now(),
        Fb = /\?/,
        Gb = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
    n.parseJSON = function(b2) {
        if (a.JSON && a.JSON.parse) return a.JSON.parse(b2 + "");
        var c2, d2 = null,
            e2 = n.trim(b2 + "");
        return e2 && !n.trim(e2.replace(Gb, function(a2, b3, e3, f2) {
            return c2 && b3 && (d2 = 0), d2 === 0 ? a2 : (c2 = e3 || b3, d2 += !f2 - !e3, "")
        })) ? Function("return " + e2)() : n.error("Invalid JSON: " + b2)
    }, n.parseXML = function(b2) {
        var c2, d2;
        if (!b2 || typeof b2 != "string") return null;
        try {
            a.DOMParser ? (d2 = new a.DOMParser, c2 = d2.parseFromString(b2, "text/xml")) : (c2 = new a.ActiveXObject("Microsoft.XMLDOM"), c2.async = "false", c2.loadXML(b2))
        } catch {
            c2 = void 0
        }
        return c2 && c2.documentElement && !c2.getElementsByTagName("parsererror").length || n.error("Invalid XML: " + b2), c2
    };
    var Hb = /#.*$/,
        Ib = /([?&])_=[^&]*/,
        Jb = /^(.*?):[ \t]*([^\r\n]*)\r?$/gm,
        Kb = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
        Lb = /^(?:GET|HEAD)$/,
        Mb = /^\/\//,
        Nb = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
        Ob = {},
        Pb = {},
        Qb = "*/".concat("*"),
        Rb = Db.href,
        Sb = Nb.exec(Rb.toLowerCase()) || [];

    function Tb(a2) {
        return function(b2, c2) {
            typeof b2 != "string" && (c2 = b2, b2 = "*");
            var d2, e2 = 0,
                f2 = b2.toLowerCase().match(G) || [];
            if (n.isFunction(c2))
                for (; d2 = f2[e2++];) d2.charAt(0) === "+" ? (d2 = d2.slice(1) || "*", (a2[d2] = a2[d2] || []).unshift(c2)) : (a2[d2] = a2[d2] || []).push(c2)
        }
    }

    function Ub(a2, b2, c2, d2) {
        var e2 = {},
            f2 = a2 === Pb;

        function g2(h2) {
            var i2;
            return e2[h2] = !0, n.each(a2[h2] || [], function(a3, h3) {
                var j2 = h3(b2, c2, d2);
                return typeof j2 != "string" || f2 || e2[j2] ? f2 ? !(i2 = j2) : void 0 : (b2.dataTypes.unshift(j2), g2(j2), !1)
            }), i2
        }
        return g2(b2.dataTypes[0]) || !e2["*"] && g2("*")
    }

    function Vb(a2, b2) {
        var c2, d2, e2 = n.ajaxSettings.flatOptions || {};
        for (d2 in b2) b2[d2] !== void 0 && ((e2[d2] ? a2 : c2 || (c2 = {}))[d2] = b2[d2]);
        return c2 && n.extend(!0, a2, c2), a2
    }

    function Wb(a2, b2, c2) {
        for (var d2, e2, f2, g2, h2 = a2.contents, i2 = a2.dataTypes; i2[0] === "*";) i2.shift(), e2 === void 0 && (e2 = a2.mimeType || b2.getResponseHeader("Content-Type"));
        if (e2) {
            for (g2 in h2)
                if (h2[g2] && h2[g2].test(e2)) {
                    i2.unshift(g2);
                    break
                }
        }
        if (i2[0] in c2) f2 = i2[0];
        else {
            for (g2 in c2) {
                if (!i2[0] || a2.converters[g2 + " " + i2[0]]) {
                    f2 = g2;
                    break
                }
                d2 || (d2 = g2)
            }
            f2 = f2 || d2
        }
        return f2 ? (f2 !== i2[0] && i2.unshift(f2), c2[f2]) : void 0
    }

    function Xb(a2, b2, c2, d2) {
        var e2, f2, g2, h2, i2, j2 = {},
            k2 = a2.dataTypes.slice();
        if (k2[1])
            for (g2 in a2.converters) j2[g2.toLowerCase()] = a2.converters[g2];
        for (f2 = k2.shift(); f2;)
            if (a2.responseFields[f2] && (c2[a2.responseFields[f2]] = b2), !i2 && d2 && a2.dataFilter && (b2 = a2.dataFilter(b2, a2.dataType)), i2 = f2, f2 = k2.shift()) {
                if (f2 === "*") f2 = i2;
                else if (i2 !== "*" && i2 !== f2) {
                    if (g2 = j2[i2 + " " + f2] || j2["* " + f2], !g2) {
                        for (e2 in j2)
                            if (h2 = e2.split(" "), h2[1] === f2 && (g2 = j2[i2 + " " + h2[0]] || j2["* " + h2[0]])) {
                                g2 === !0 ? g2 = j2[e2] : j2[e2] !== !0 && (f2 = h2[0], k2.unshift(h2[1]));
                                break
                            }
                    }
                    if (g2 !== !0)
                        if (g2 && a2.throws) b2 = g2(b2);
                        else try {
                            b2 = g2(b2)
                        } catch (l2) {
                            return {
                                state: "parsererror",
                                error: g2 ? l2 : "No conversion from " + i2 + " to " + f2
                            }
                        }
                }
            } return {
            state: "success",
            data: b2
        }
    }
    n.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: Rb,
            type: "GET",
            isLocal: Kb.test(Sb[1]),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": Qb,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": n.parseJSON,
                "text xml": n.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(a2, b2) {
            return b2 ? Vb(Vb(a2, n.ajaxSettings), b2) : Vb(n.ajaxSettings, a2)
        },
        ajaxPrefilter: Tb(Ob),
        ajaxTransport: Tb(Pb),
        ajax: function(b2, c2) {
            typeof b2 == "object" && (c2 = b2, b2 = void 0), c2 = c2 || {};
            var d2, e2, f2, g2, h2, i2, j2, k2, l2 = n.ajaxSetup({}, c2),
                m2 = l2.context || l2,
                o2 = l2.context && (m2.nodeType || m2.jquery) ? n(m2) : n.event,
                p2 = n.Deferred(),
                q2 = n.Callbacks("once memory"),
                r2 = l2.statusCode || {},
                s2 = {},
                t2 = {},
                u2 = 0,
                v2 = "canceled",
                w2 = {
                    readyState: 0,
                    getResponseHeader: function(a2) {
                        var b3;
                        if (u2 === 2) {
                            if (!k2)
                                for (k2 = {}; b3 = Jb.exec(g2);) k2[b3[1].toLowerCase()] = b3[2];
                            b3 = k2[a2.toLowerCase()]
                        }
                        return b3 ?? null
                    },
                    getAllResponseHeaders: function() {
                        return u2 === 2 ? g2 : null
                    },
                    setRequestHeader: function(a2, b3) {
                        var c3 = a2.toLowerCase();
                        return u2 || (a2 = t2[c3] = t2[c3] || a2, s2[a2] = b3), this
                    },
                    overrideMimeType: function(a2) {
                        return u2 || (l2.mimeType = a2), this
                    },
                    statusCode: function(a2) {
                        var b3;
                        if (a2)
                            if (2 > u2)
                                for (b3 in a2) r2[b3] = [r2[b3], a2[b3]];
                            else w2.always(a2[w2.status]);
                        return this
                    },
                    abort: function(a2) {
                        var b3 = a2 || v2;
                        return j2 && j2.abort(b3), y2(0, b3), this
                    }
                };
            if (p2.promise(w2).complete = q2.add, w2.success = w2.done, w2.error = w2.fail, l2.url = ((b2 || l2.url || Rb) + "").replace(Hb, "").replace(Mb, Sb[1] + "//"), l2.type = c2.method || c2.type || l2.method || l2.type, l2.dataTypes = n.trim(l2.dataType || "*").toLowerCase().match(G) || [""], l2.crossDomain == null && (d2 = Nb.exec(l2.url.toLowerCase()), l2.crossDomain = !(!d2 || d2[1] === Sb[1] && d2[2] === Sb[2] && (d2[3] || (d2[1] === "http:" ? "80" : "443")) === (Sb[3] || (Sb[1] === "http:" ? "80" : "443")))), l2.data && l2.processData && typeof l2.data != "string" && (l2.data = n.param(l2.data, l2.traditional)), Ub(Ob, l2, c2, w2), u2 === 2) return w2;
            i2 = n.event && l2.global, i2 && n.active++ === 0 && n.event.trigger("ajaxStart"), l2.type = l2.type.toUpperCase(), l2.hasContent = !Lb.test(l2.type), f2 = l2.url, l2.hasContent || (l2.data && (f2 = l2.url += (Fb.test(f2) ? "&" : "?") + l2.data, delete l2.data), l2.cache === !1 && (l2.url = Ib.test(f2) ? f2.replace(Ib, "$1_=" + Eb++) : f2 + (Fb.test(f2) ? "&" : "?") + "_=" + Eb++)), l2.ifModified && (n.lastModified[f2] && w2.setRequestHeader("If-Modified-Since", n.lastModified[f2]), n.etag[f2] && w2.setRequestHeader("If-None-Match", n.etag[f2])), (l2.data && l2.hasContent && l2.contentType !== !1 || c2.contentType) && w2.setRequestHeader("Content-Type", l2.contentType), w2.setRequestHeader("Accept", l2.dataTypes[0] && l2.accepts[l2.dataTypes[0]] ? l2.accepts[l2.dataTypes[0]] + (l2.dataTypes[0] !== "*" ? ", " + Qb + "; q=0.01" : "") : l2.accepts["*"]);
            for (e2 in l2.headers) w2.setRequestHeader(e2, l2.headers[e2]);
            if (l2.beforeSend && (l2.beforeSend.call(m2, w2, l2) === !1 || u2 === 2)) return w2.abort();
            v2 = "abort";
            for (e2 in {
                    success: 1,
                    error: 1,
                    complete: 1
                }) w2[e2](l2[e2]);
            if (j2 = Ub(Pb, l2, c2, w2)) {
                if (w2.readyState = 1, i2 && o2.trigger("ajaxSend", [w2, l2]), u2 === 2) return w2;
                l2.async && l2.timeout > 0 && (h2 = a.setTimeout(function() {
                    w2.abort("timeout")
                }, l2.timeout));
                try {
                    u2 = 1, j2.send(s2, y2)
                } catch (x2) {
                    if (!(2 > u2)) throw x2;
                    y2(-1, x2)
                }
            } else y2(-1, "No Transport");

            function y2(b3, c3, d3, e3) {
                var k3, s3, t3, v3, x2, y3 = c3;
                u2 !== 2 && (u2 = 2, h2 && a.clearTimeout(h2), j2 = void 0, g2 = e3 || "", w2.readyState = b3 > 0 ? 4 : 0, k3 = b3 >= 200 && 300 > b3 || b3 === 304, d3 && (v3 = Wb(l2, w2, d3)), v3 = Xb(l2, v3, w2, k3), k3 ? (l2.ifModified && (x2 = w2.getResponseHeader("Last-Modified"), x2 && (n.lastModified[f2] = x2), x2 = w2.getResponseHeader("etag"), x2 && (n.etag[f2] = x2)), b3 === 204 || l2.type === "HEAD" ? y3 = "nocontent" : b3 === 304 ? y3 = "notmodified" : (y3 = v3.state, s3 = v3.data, t3 = v3.error, k3 = !t3)) : (t3 = y3, !b3 && y3 || (y3 = "error", 0 > b3 && (b3 = 0))), w2.status = b3, w2.statusText = (c3 || y3) + "", k3 ? p2.resolveWith(m2, [s3, y3, w2]) : p2.rejectWith(m2, [w2, y3, t3]), w2.statusCode(r2), r2 = void 0, i2 && o2.trigger(k3 ? "ajaxSuccess" : "ajaxError", [w2, l2, k3 ? s3 : t3]), q2.fireWith(m2, [w2, y3]), i2 && (o2.trigger("ajaxComplete", [w2, l2]), --n.active || n.event.trigger("ajaxStop")))
            }
            return w2
        },
        getJSON: function(a2, b2, c2) {
            return n.get(a2, b2, c2, "json")
        },
        getScript: function(a2, b2) {
            return n.get(a2, void 0, b2, "script")
        }
    }), n.each(["get", "post"], function(a2, b2) {
        n[b2] = function(a3, c2, d2, e2) {
            return n.isFunction(c2) && (e2 = e2 || d2, d2 = c2, c2 = void 0), n.ajax(n.extend({
                url: a3,
                type: b2,
                dataType: e2,
                data: c2,
                success: d2
            }, n.isPlainObject(a3) && a3))
        }
    }), n._evalUrl = function(a2) {
        return n.ajax({
            url: a2,
            type: "GET",
            dataType: "script",
            cache: !0,
            async: !1,
            global: !1,
            throws: !0
        })
    }, n.fn.extend({
        wrapAll: function(a2) {
            if (n.isFunction(a2)) return this.each(function(b3) {
                n(this).wrapAll(a2.call(this, b3))
            });
            if (this[0]) {
                var b2 = n(a2, this[0].ownerDocument).eq(0).clone(!0);
                this[0].parentNode && b2.insertBefore(this[0]), b2.map(function() {
                    for (var a3 = this; a3.firstChild && a3.firstChild.nodeType === 1;) a3 = a3.firstChild;
                    return a3
                }).append(this)
            }
            return this
        },
        wrapInner: function(a2) {
            return n.isFunction(a2) ? this.each(function(b2) {
                n(this).wrapInner(a2.call(this, b2))
            }) : this.each(function() {
                var b2 = n(this),
                    c2 = b2.contents();
                c2.length ? c2.wrapAll(a2) : b2.append(a2)
            })
        },
        wrap: function(a2) {
            var b2 = n.isFunction(a2);
            return this.each(function(c2) {
                n(this).wrapAll(b2 ? a2.call(this, c2) : a2)
            })
        },
        unwrap: function() {
            return this.parent().each(function() {
                n.nodeName(this, "body") || n(this).replaceWith(this.childNodes)
            }).end()
        }
    });

    function Yb(a2) {
        return a2.style && a2.style.display || n.css(a2, "display")
    }

    function Zb(a2) {
        if (!n.contains(a2.ownerDocument || d, a2)) return !0;
        for (; a2 && a2.nodeType === 1;) {
            if (Yb(a2) === "none" || a2.type === "hidden") return !0;
            a2 = a2.parentNode
        }
        return !1
    }
    n.expr.filters.hidden = function(a2) {
        return l.reliableHiddenOffsets() ? a2.offsetWidth <= 0 && a2.offsetHeight <= 0 && !a2.getClientRects().length : Zb(a2)
    }, n.expr.filters.visible = function(a2) {
        return !n.expr.filters.hidden(a2)
    };
    var $b = /%20/g,
        _b = /\[\]$/,
        ac = /\r?\n/g,
        bc = /^(?:submit|button|image|reset|file)$/i,
        cc = /^(?:input|select|textarea|keygen)/i;

    function dc(a2, b2, c2, d2) {
        var e2;
        if (n.isArray(b2)) n.each(b2, function(b3, e3) {
            c2 || _b.test(a2) ? d2(a2, e3) : dc(a2 + "[" + (typeof e3 == "object" && e3 != null ? b3 : "") + "]", e3, c2, d2)
        });
        else if (c2 || n.type(b2) !== "object") d2(a2, b2);
        else
            for (e2 in b2) dc(a2 + "[" + e2 + "]", b2[e2], c2, d2)
    }
    n.param = function(a2, b2) {
        var c2, d2 = [],
            e2 = function(a3, b3) {
                b3 = n.isFunction(b3) ? b3() : b3 ?? "", d2[d2.length] = encodeURIComponent(a3) + "=" + encodeURIComponent(b3)
            };
        if (b2 === void 0 && (b2 = n.ajaxSettings && n.ajaxSettings.traditional), n.isArray(a2) || a2.jquery && !n.isPlainObject(a2)) n.each(a2, function() {
            e2(this.name, this.value)
        });
        else
            for (c2 in a2) dc(c2, a2[c2], b2, e2);
        return d2.join("&").replace($b, "+")
    }, n.fn.extend({
        serialize: function() {
            return n.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map(function() {
                var a2 = n.prop(this, "elements");
                return a2 ? n.makeArray(a2) : this
            }).filter(function() {
                var a2 = this.type;
                return this.name && !n(this).is(":disabled") && cc.test(this.nodeName) && !bc.test(a2) && (this.checked || !Z.test(a2))
            }).map(function(a2, b2) {
                var c2 = n(this).val();
                return c2 == null ? null : n.isArray(c2) ? n.map(c2, function(a3) {
                    return {
                        name: b2.name,
                        value: a3.replace(ac, `\r
`)
                    }
                }) : {
                    name: b2.name,
                    value: c2.replace(ac, `\r
`)
                }
            }).get()
        }
    }), n.ajaxSettings.xhr = a.ActiveXObject !== void 0 ? function() {
        return this.isLocal ? ic() : d.documentMode > 8 ? hc() : /^(get|post|head|put|delete|options)$/i.test(this.type) && hc() || ic()
    } : hc;
    var ec = 0,
        fc = {},
        gc = n.ajaxSettings.xhr();
    a.attachEvent && a.attachEvent("onunload", function() {
        for (var a2 in fc) fc[a2](void 0, !0)
    }), l.cors = !!gc && "withCredentials" in gc, gc = l.ajax = !!gc, gc && n.ajaxTransport(function(b2) {
        if (!b2.crossDomain || l.cors) {
            var c2;
            return {
                send: function(d2, e2) {
                    var f2, g2 = b2.xhr(),
                        h2 = ++ec;
                    if (g2.open(b2.type, b2.url, b2.async, b2.username, b2.password), b2.xhrFields)
                        for (f2 in b2.xhrFields) g2[f2] = b2.xhrFields[f2];
                    b2.mimeType && g2.overrideMimeType && g2.overrideMimeType(b2.mimeType), b2.crossDomain || d2["X-Requested-With"] || (d2["X-Requested-With"] = "XMLHttpRequest");
                    for (f2 in d2) d2[f2] !== void 0 && g2.setRequestHeader(f2, d2[f2] + "");
                    g2.send(b2.hasContent && b2.data || null), c2 = function(a2, d3) {
                        var f3, i2, j2;
                        if (c2 && (d3 || g2.readyState === 4))
                            if (delete fc[h2], c2 = void 0, g2.onreadystatechange = n.noop, d3) g2.readyState !== 4 && g2.abort();
                            else {
                                j2 = {}, f3 = g2.status, typeof g2.responseText == "string" && (j2.text = g2.responseText);
                                try {
                                    i2 = g2.statusText
                                } catch {
                                    i2 = ""
                                }
                                f3 || !b2.isLocal || b2.crossDomain ? f3 === 1223 && (f3 = 204) : f3 = j2.text ? 200 : 404
                            } j2 && e2(f3, i2, j2, g2.getAllResponseHeaders())
                    }, b2.async ? g2.readyState === 4 ? a.setTimeout(c2) : g2.onreadystatechange = fc[h2] = c2 : c2()
                },
                abort: function() {
                    c2 && c2(void 0, !0)
                }
            }
        }
    });

    function hc() {
        try {
            return new a.XMLHttpRequest
        } catch {}
    }

    function ic() {
        try {
            return new a.ActiveXObject("Microsoft.XMLHTTP")
        } catch {}
    }
    n.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(a2) {
                return n.globalEval(a2), a2
            }
        }
    }), n.ajaxPrefilter("script", function(a2) {
        a2.cache === void 0 && (a2.cache = !1), a2.crossDomain && (a2.type = "GET", a2.global = !1)
    }), n.ajaxTransport("script", function(a2) {
        if (a2.crossDomain) {
            var b2, c2 = d.head || n("head")[0] || d.documentElement;
            return {
                send: function(e2, f2) {
                    b2 = d.createElement("script"), b2.async = !0, a2.scriptCharset && (b2.charset = a2.scriptCharset), b2.src = a2.url, b2.onload = b2.onreadystatechange = function(a3, c3) {
                        (c3 || !b2.readyState || /loaded|complete/.test(b2.readyState)) && (b2.onload = b2.onreadystatechange = null, b2.parentNode && b2.parentNode.removeChild(b2), b2 = null, c3 || f2(200, "success"))
                    }, c2.insertBefore(b2, c2.firstChild)
                },
                abort: function() {
                    b2 && b2.onload(void 0, !0)
                }
            }
        }
    });
    var jc = [],
        kc = /(=)\?(?=&|$)|\?\?/;
    n.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var a2 = jc.pop() || n.expando + "_" + Eb++;
            return this[a2] = !0, a2
        }
    }), n.ajaxPrefilter("json jsonp", function(b2, c2, d2) {
        var e2, f2, g2, h2 = b2.jsonp !== !1 && (kc.test(b2.url) ? "url" : typeof b2.data == "string" && (b2.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && kc.test(b2.data) && "data");
        return h2 || b2.dataTypes[0] === "jsonp" ? (e2 = b2.jsonpCallback = n.isFunction(b2.jsonpCallback) ? b2.jsonpCallback() : b2.jsonpCallback, h2 ? b2[h2] = b2[h2].replace(kc, "$1" + e2) : b2.jsonp !== !1 && (b2.url += (Fb.test(b2.url) ? "&" : "?") + b2.jsonp + "=" + e2), b2.converters["script json"] = function() {
            return g2 || n.error(e2 + " was not called"), g2[0]
        }, b2.dataTypes[0] = "json", f2 = a[e2], a[e2] = function() {
            g2 = arguments
        }, d2.always(function() {
            f2 === void 0 ? n(a).removeProp(e2) : a[e2] = f2, b2[e2] && (b2.jsonpCallback = c2.jsonpCallback, jc.push(e2)), g2 && n.isFunction(f2) && f2(g2[0]), g2 = f2 = void 0
        }), "script") : void 0
    }), n.parseHTML = function(a2, b2, c2) {
        if (!a2 || typeof a2 != "string") return null;
        typeof b2 == "boolean" && (c2 = b2, b2 = !1), b2 = b2 || d;
        var e2 = x.exec(a2),
            f2 = !c2 && [];
        return e2 ? [b2.createElement(e2[1])] : (e2 = ja([a2], b2, f2), f2 && f2.length && n(f2).remove(), n.merge([], e2.childNodes))
    };
    var lc = n.fn.load;
    n.fn.load = function(a2, b2, c2) {
        if (typeof a2 != "string" && lc) return lc.apply(this, arguments);
        var d2, e2, f2, g2 = this,
            h2 = a2.indexOf(" ");
        return h2 > -1 && (d2 = n.trim(a2.slice(h2, a2.length)), a2 = a2.slice(0, h2)), n.isFunction(b2) ? (c2 = b2, b2 = void 0) : b2 && typeof b2 == "object" && (e2 = "POST"), g2.length > 0 && n.ajax({
            url: a2,
            type: e2 || "GET",
            dataType: "html",
            data: b2
        }).done(function(a3) {
            f2 = arguments, g2.html(d2 ? n("<div>").append(n.parseHTML(a3)).find(d2) : a3)
        }).always(c2 && function(a3, b3) {
            g2.each(function() {
                c2.apply(this, f2 || [a3.responseText, b3, a3])
            })
        }), this
    }, n.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(a2, b2) {
        n.fn[b2] = function(a3) {
            return this.on(b2, a3)
        }
    }), n.expr.filters.animated = function(a2) {
        return n.grep(n.timers, function(b2) {
            return a2 === b2.elem
        }).length
    };

    function mc(a2) {
        return n.isWindow(a2) ? a2 : a2.nodeType === 9 ? a2.defaultView || a2.parentWindow : !1
    }
    n.offset = {
        setOffset: function(a2, b2, c2) {
            var d2, e2, f2, g2, h2, i2, j2, k2 = n.css(a2, "position"),
                l2 = n(a2),
                m2 = {};
            k2 === "static" && (a2.style.position = "relative"), h2 = l2.offset(), f2 = n.css(a2, "top"), i2 = n.css(a2, "left"), j2 = (k2 === "absolute" || k2 === "fixed") && n.inArray("auto", [f2, i2]) > -1, j2 ? (d2 = l2.position(), g2 = d2.top, e2 = d2.left) : (g2 = parseFloat(f2) || 0, e2 = parseFloat(i2) || 0), n.isFunction(b2) && (b2 = b2.call(a2, c2, n.extend({}, h2))), b2.top != null && (m2.top = b2.top - h2.top + g2), b2.left != null && (m2.left = b2.left - h2.left + e2), "using" in b2 ? b2.using.call(a2, m2) : l2.css(m2)
        }
    }, n.fn.extend({
        offset: function(a2) {
            if (arguments.length) return a2 === void 0 ? this : this.each(function(b3) {
                n.offset.setOffset(this, a2, b3)
            });
            var b2, c2, d2 = {
                    top: 0,
                    left: 0
                },
                e2 = this[0],
                f2 = e2 && e2.ownerDocument;
            if (f2) return b2 = f2.documentElement, n.contains(b2, e2) ? (typeof e2.getBoundingClientRect < "u" && (d2 = e2.getBoundingClientRect()), c2 = mc(f2), {
                top: d2.top + (c2.pageYOffset || b2.scrollTop) - (b2.clientTop || 0),
                left: d2.left + (c2.pageXOffset || b2.scrollLeft) - (b2.clientLeft || 0)
            }) : d2
        },
        position: function() {
            if (this[0]) {
                var a2, b2, c2 = {
                        top: 0,
                        left: 0
                    },
                    d2 = this[0];
                return n.css(d2, "position") === "fixed" ? b2 = d2.getBoundingClientRect() : (a2 = this.offsetParent(), b2 = this.offset(), n.nodeName(a2[0], "html") || (c2 = a2.offset()), c2.top += n.css(a2[0], "borderTopWidth", !0), c2.left += n.css(a2[0], "borderLeftWidth", !0)), {
                    top: b2.top - c2.top - n.css(d2, "marginTop", !0),
                    left: b2.left - c2.left - n.css(d2, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map(function() {
                for (var a2 = this.offsetParent; a2 && !n.nodeName(a2, "html") && n.css(a2, "position") === "static";) a2 = a2.offsetParent;
                return a2 || Qa
            })
        }
    }), n.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(a2, b2) {
        var c2 = /Y/.test(b2);
        n.fn[a2] = function(d2) {
            return Y(this, function(a3, d3, e2) {
                var f2 = mc(a3);
                return e2 === void 0 ? f2 ? b2 in f2 ? f2[b2] : f2.document.documentElement[d3] : a3[d3] : void(f2 ? f2.scrollTo(c2 ? n(f2).scrollLeft() : e2, c2 ? e2 : n(f2).scrollTop()) : a3[d3] = e2)
            }, a2, d2, arguments.length, null)
        }
    }), n.each(["top", "left"], function(a2, b2) {
        n.cssHooks[b2] = Ua(l.pixelPosition, function(a3, c2) {
            return c2 ? (c2 = Sa(a3, b2), Oa.test(c2) ? n(a3).position()[b2] + "px" : c2) : void 0
        })
    }), n.each({
        Height: "height",
        Width: "width"
    }, function(a2, b2) {
        n.each({
            padding: "inner" + a2,
            content: b2,
            "": "outer" + a2
        }, function(c2, d2) {
            n.fn[d2] = function(d3, e2) {
                var f2 = arguments.length && (c2 || typeof d3 != "boolean"),
                    g2 = c2 || (d3 === !0 || e2 === !0 ? "margin" : "border");
                return Y(this, function(b3, c3, d4) {
                    var e3;
                    return n.isWindow(b3) ? b3.document.documentElement["client" + a2] : b3.nodeType === 9 ? (e3 = b3.documentElement, Math.max(b3.body["scroll" + a2], e3["scroll" + a2], b3.body["offset" + a2], e3["offset" + a2], e3["client" + a2])) : d4 === void 0 ? n.css(b3, c3, g2) : n.style(b3, c3, d4, g2)
                }, b2, f2 ? d3 : void 0, f2, null)
            }
        })
    }), n.fn.extend({
        bind: function(a2, b2, c2) {
            return this.on(a2, null, b2, c2)
        },
        unbind: function(a2, b2) {
            return this.off(a2, null, b2)
        },
        delegate: function(a2, b2, c2, d2) {
            return this.on(b2, a2, c2, d2)
        },
        undelegate: function(a2, b2, c2) {
            return arguments.length === 1 ? this.off(a2, "**") : this.off(b2, a2 || "**", c2)
        }
    }), n.fn.size = function() {
        return this.length
    }, n.fn.andSelf = n.fn.addBack, typeof define == "function" && define.amd && define("jquery", [], function() {
        return n
    });
    var nc = a.jQuery,
        oc = a.$;
    return n.noConflict = function(b2) {
        return a.$ === n && (a.$ = oc), b2 && a.jQuery === n && (a.jQuery = nc), n
    }, b || (a.jQuery = a.$ = n), n
});
/*!
 * jquery.counterup.js 1.0
 */
(function() {
    var t = [].indexOf || function(t2) {
            for (var e2 = 0, n = this.length; e2 < n; e2++)
                if (e2 in this && this[e2] === t2) return e2;
            return -1
        },
        e = [].slice;
    (function(t2, e2) {
        return typeof define == "function" && define.amd ? define("waypoints", ["jquery"], function(n) {
            return e2(n, t2)
        }) : e2(t2.jQuery, t2)
    })(this, function(n, r) {
        var i, o, l, s, f, u, a, c, h, d, p, y, v, w, g, m;
        return i = n(r), c = t.call(r, "ontouchstart") >= 0, s = {
            horizontal: {},
            vertical: {}
        }, f = 1, a = {}, u = "waypoints-context-id", p = "resize.waypoints", y = "scroll.waypoints", v = 1, w = "waypoints-waypoint-ids", g = "waypoint", m = "waypoints", o = function() {
            function t2(t3) {
                var e2 = this;
                this.$element = t3, this.element = t3[0], this.didResize = !1, this.didScroll = !1, this.id = "context" + f++, this.oldScroll = {
                    x: t3.scrollLeft(),
                    y: t3.scrollTop()
                }, this.waypoints = {
                    horizontal: {},
                    vertical: {}
                }, t3.data(u, this.id), a[this.id] = this, t3.bind(y, function() {
                    var t4;
                    if (!(e2.didScroll || c)) return e2.didScroll = !0, t4 = function() {
                        return e2.doScroll(), e2.didScroll = !1
                    }, r.setTimeout(t4, n[m].settings.scrollThrottle)
                }), t3.bind(p, function() {
                    var t4;
                    if (!e2.didResize) return e2.didResize = !0, t4 = function() {
                        return n[m]("refresh"), e2.didResize = !1
                    }, r.setTimeout(t4, n[m].settings.resizeThrottle)
                })
            }
            return t2.prototype.doScroll = function() {
                var t3, e2 = this;
                return t3 = {
                    horizontal: {
                        newScroll: this.$element.scrollLeft(),
                        oldScroll: this.oldScroll.x,
                        forward: "right",
                        backward: "left"
                    },
                    vertical: {
                        newScroll: this.$element.scrollTop(),
                        oldScroll: this.oldScroll.y,
                        forward: "down",
                        backward: "up"
                    }
                }, c && (!t3.vertical.oldScroll || !t3.vertical.newScroll) && n[m]("refresh"), n.each(t3, function(t4, r2) {
                    var i2, o2, l2;
                    return l2 = [], o2 = r2.newScroll > r2.oldScroll, i2 = o2 ? r2.forward : r2.backward, n.each(e2.waypoints[t4], function(t5, e3) {
                        var n2, i3;
                        if (r2.oldScroll < (n2 = e3.offset) && n2 <= r2.newScroll) return l2.push(e3);
                        if (r2.newScroll < (i3 = e3.offset) && i3 <= r2.oldScroll) return l2.push(e3)
                    }), l2.sort(function(t5, e3) {
                        return t5.offset - e3.offset
                    }), o2 || l2.reverse(), n.each(l2, function(t5, e3) {
                        if (e3.options.continuous || t5 === l2.length - 1) return e3.trigger([i2])
                    })
                }), this.oldScroll = {
                    x: t3.horizontal.newScroll,
                    y: t3.vertical.newScroll
                }
            }, t2.prototype.refresh = function() {
                var t3, e2, r2, i2 = this;
                return r2 = n.isWindow(this.element), e2 = this.$element.offset(), this.doScroll(), t3 = {
                    horizontal: {
                        contextOffset: r2 ? 0 : e2.left,
                        contextScroll: r2 ? 0 : this.oldScroll.x,
                        contextDimension: this.$element.width(),
                        oldScroll: this.oldScroll.x,
                        forward: "right",
                        backward: "left",
                        offsetProp: "left"
                    },
                    vertical: {
                        contextOffset: r2 ? 0 : e2.top,
                        contextScroll: r2 ? 0 : this.oldScroll.y,
                        contextDimension: r2 ? n[m]("viewportHeight") : this.$element.height(),
                        oldScroll: this.oldScroll.y,
                        forward: "down",
                        backward: "up",
                        offsetProp: "top"
                    }
                }, n.each(t3, function(t4, e3) {
                    return n.each(i2.waypoints[t4], function(t5, r3) {
                        var i3, o2, l2, s2, f2;
                        if (i3 = r3.options.offset, l2 = r3.offset, o2 = n.isWindow(r3.element) ? 0 : r3.$element.offset()[e3.offsetProp], n.isFunction(i3) ? i3 = i3.apply(r3.element) : typeof i3 == "string" && (i3 = parseFloat(i3), r3.options.offset.indexOf("%") > -1 && (i3 = Math.ceil(e3.contextDimension * i3 / 100))), r3.offset = o2 - e3.contextOffset + e3.contextScroll - i3, !(r3.options.onlyOnScroll && l2 != null || !r3.enabled)) {
                            if (l2 !== null && l2 < (s2 = e3.oldScroll) && s2 <= r3.offset) return r3.trigger([e3.backward]);
                            if (l2 !== null && l2 > (f2 = e3.oldScroll) && f2 >= r3.offset) return r3.trigger([e3.forward]);
                            if (l2 === null && e3.oldScroll >= r3.offset) return r3.trigger([e3.forward])
                        }
                    })
                })
            }, t2.prototype.checkEmpty = function() {
                if (n.isEmptyObject(this.waypoints.horizontal) && n.isEmptyObject(this.waypoints.vertical)) return this.$element.unbind([p, y].join(" ")), delete a[this.id]
            }, t2
        }(), l = function() {
            function t2(t3, e2, r2) {
                var i2, o2;
                r2 = n.extend({}, n.fn[g].defaults, r2), r2.offset === "bottom-in-view" && (r2.offset = function() {
                    var t4;
                    return t4 = n[m]("viewportHeight"), n.isWindow(e2.element) || (t4 = e2.$element.height()), t4 - n(this).outerHeight()
                }), this.$element = t3, this.element = t3[0], this.axis = r2.horizontal ? "horizontal" : "vertical", this.callback = r2.handler, this.context = e2, this.enabled = r2.enabled, this.id = "waypoints" + v++, this.offset = null, this.options = r2, e2.waypoints[this.axis][this.id] = this, s[this.axis][this.id] = this, i2 = (o2 = t3.data(w)) != null ? o2 : [], i2.push(this.id), t3.data(w, i2)
            }
            return t2.prototype.trigger = function(t3) {
                if (this.enabled && (this.callback != null && this.callback.apply(this.element, t3), this.options.triggerOnce)) return this.destroy()
            }, t2.prototype.disable = function() {
                return this.enabled = !1
            }, t2.prototype.enable = function() {
                return this.context.refresh(), this.enabled = !0
            }, t2.prototype.destroy = function() {
                return delete s[this.axis][this.id], delete this.context.waypoints[this.axis][this.id], this.context.checkEmpty()
            }, t2.getWaypointsByElement = function(t3) {
                var e2, r2;
                return r2 = n(t3).data(w), r2 ? (e2 = n.extend({}, s.horizontal, s.vertical), n.map(r2, function(t4) {
                    return e2[t4]
                })) : []
            }, t2
        }(), d = {
            init: function(t2, e2) {
                var r2;
                return e2 == null && (e2 = {}), (r2 = e2.handler) == null && (e2.handler = t2), this.each(function() {
                    var t3, r3, i2, s2;
                    return t3 = n(this), i2 = (s2 = e2.context) != null ? s2 : n.fn[g].defaults.context, n.isWindow(i2) || (i2 = t3.closest(i2)), i2 = n(i2), r3 = a[i2.data(u)], r3 || (r3 = new o(i2)), new l(t3, r3, e2)
                }), n[m]("refresh"), this
            },
            disable: function() {
                return d._invoke(this, "disable")
            },
            enable: function() {
                return d._invoke(this, "enable")
            },
            destroy: function() {
                return d._invoke(this, "destroy")
            },
            prev: function(t2, e2) {
                return d._traverse.call(this, t2, e2, function(t3, e3, n2) {
                    if (e3 > 0) return t3.push(n2[e3 - 1])
                })
            },
            next: function(t2, e2) {
                return d._traverse.call(this, t2, e2, function(t3, e3, n2) {
                    if (e3 < n2.length - 1) return t3.push(n2[e3 + 1])
                })
            },
            _traverse: function(t2, e2, i2) {
                var o2, l2;
                return t2 == null && (t2 = "vertical"), e2 == null && (e2 = r), l2 = h.aggregate(e2), o2 = [], this.each(function() {
                    var e3;
                    return e3 = n.inArray(this, l2[t2]), i2(o2, e3, l2[t2])
                }), this.pushStack(o2)
            },
            _invoke: function(t2, e2) {
                return t2.each(function() {
                    var t3;
                    return t3 = l.getWaypointsByElement(this), n.each(t3, function(t4, n2) {
                        return n2[e2](), !0
                    })
                }), this
            }
        }, n.fn[g] = function() {
            var t2, r2;
            return r2 = arguments[0], t2 = 2 <= arguments.length ? e.call(arguments, 1) : [], d[r2] ? d[r2].apply(this, t2) : n.isFunction(r2) ? d.init.apply(this, arguments) : n.isPlainObject(r2) ? d.init.apply(this, [null, r2]) : r2 ? n.error("The " + r2 + " method does not exist in jQuery Waypoints.") : n.error("jQuery Waypoints needs a callback function or handler option.")
        }, n.fn[g].defaults = {
            context: r,
            continuous: !0,
            enabled: !0,
            horizontal: !1,
            offset: 0,
            triggerOnce: !1
        }, h = {
            refresh: function() {
                return n.each(a, function(t2, e2) {
                    return e2.refresh()
                })
            },
            viewportHeight: function() {
                var t2;
                return (t2 = r.innerHeight) != null ? t2 : i.height()
            },
            aggregate: function(t2) {
                var e2, r2, i2;
                return e2 = s, t2 && (e2 = (i2 = a[n(t2).data(u)]) != null ? i2.waypoints : void 0), e2 ? (r2 = {
                    horizontal: [],
                    vertical: []
                }, n.each(r2, function(t3, i3) {
                    return n.each(e2[t3], function(t4, e3) {
                        return i3.push(e3)
                    }), i3.sort(function(t4, e3) {
                        return t4.offset - e3.offset
                    }), r2[t3] = n.map(i3, function(t4) {
                        return t4.element
                    }), r2[t3] = n.unique(r2[t3])
                }), r2) : []
            },
            above: function(t2) {
                return t2 == null && (t2 = r), h._filter(t2, "vertical", function(t3, e2) {
                    return e2.offset <= t3.oldScroll.y
                })
            },
            below: function(t2) {
                return t2 == null && (t2 = r), h._filter(t2, "vertical", function(t3, e2) {
                    return e2.offset > t3.oldScroll.y
                })
            },
            left: function(t2) {
                return t2 == null && (t2 = r), h._filter(t2, "horizontal", function(t3, e2) {
                    return e2.offset <= t3.oldScroll.x
                })
            },
            right: function(t2) {
                return t2 == null && (t2 = r), h._filter(t2, "horizontal", function(t3, e2) {
                    return e2.offset > t3.oldScroll.x
                })
            },
            enable: function() {
                return h._invoke("enable")
            },
            disable: function() {
                return h._invoke("disable")
            },
            destroy: function() {
                return h._invoke("destroy")
            },
            extendFn: function(t2, e2) {
                return d[t2] = e2
            },
            _invoke: function(t2) {
                var e2;
                return e2 = n.extend({}, s.vertical, s.horizontal), n.each(e2, function(e3, n2) {
                    return n2[t2](), !0
                })
            },
            _filter: function(t2, e2, r2) {
                var i2, o2;
                return i2 = a[n(t2).data(u)], i2 ? (o2 = [], n.each(i2.waypoints[e2], function(t3, e3) {
                    if (r2(i2, e3)) return o2.push(e3)
                }), o2.sort(function(t3, e3) {
                    return t3.offset - e3.offset
                }), n.map(o2, function(t3) {
                    return t3.element
                })) : []
            }
        }, n[m] = function() {
            var t2, n2;
            return n2 = arguments[0], t2 = 2 <= arguments.length ? e.call(arguments, 1) : [], h[n2] ? h[n2].apply(null, t2) : h.aggregate.call(null, n2)
        }, n[m].settings = {
            resizeThrottle: 100,
            scrollThrottle: 30
        }, i.load(function() {
            return n[m]("refresh")
        })
    })
}).call(this),
    function(e) {
        "use strict";
        e.fn.counterUp = function(t) {
            var n = e.extend({
                time: 400,
                delay: 10
            }, t);
            return this.each(function() {
                var t2 = e(this),
                    r = n,
                    i = function() {
                        var e2 = [],
                            n2 = r.time / r.delay,
                            i2 = t2.text(),
                            s = /[0-9]+,[0-9]+/.test(i2);
                        i2 = i2.replace(/,/g, "");
                        for (var o = /^[0-9]+$/.test(i2), u = /^[0-9]+\.[0-9]+$/.test(i2), a = u ? (i2.split(".")[1] || []).length : 0, f = n2; f >= 1; f--) {
                            var l = parseInt(i2 / n2 * f);
                            if (u && (l = parseFloat(i2 / n2 * f).toFixed(a)), s)
                                for (;
                                    /(\d+)(\d{3})/.test(l.toString());) l = l.toString().replace(/(\d+)(\d{3})/, "$1,$2");
                            e2.unshift(l)
                        }
                        t2.data("counterup-nums", e2), t2.text("0");
                        var c = function() {
                            t2.text(t2.data("counterup-nums").shift()), t2.data("counterup-nums").length ? setTimeout(t2.data("counterup-func"), r.delay) : (delete t2.data("counterup-nums"), t2.data("counterup-nums", null), t2.data("counterup-func", null))
                        };
                        t2.data("counterup-func", c), setTimeout(t2.data("counterup-func"), r.delay)
                    };
                t2.waypoint(i, {
                    offset: "100%",
                    triggerOnce: !0
                })
            })
        }
    }(jQuery);
var $el = $(".Index_tab_percent_studies_main_new"),
    window_height = $(window).height();
if ($el.length > 0) {
    var stickyHeaderTop = $el.position().top - window_height + 150,
        flag = 0;
    $(window).scroll(function() {
        flag == 0 && ($(window).scrollTop() > stickyHeaderTop && (flag = 1), flag == 1 && $(document).ready(function($2) {
            $2(".Index_tab_percent_studies_inneroverlay_innersides_innerleft_innerlists_innerloop_innerboxs_title_new h2 span").counterUp({
                delay: 5,
                time: 800
            })
        }))
    });
    var flag_1 = 0;
    $(".tab_studies_2").click(function() {
        flag_1 == 0 && ($(".tab_studies_2_open .Index_tab_percent_studies_inneroverlay_innersides_innerleft_innerlists_innerloop_innerboxs_title_new h2 span").counterUp({
            delay: 5,
            time: 800
        }), flag_1 = 1)
    })
}
var $el_2 = $(".Index_breakdown_lists_main_new"),
    window_height_2 = $(window).height();
if ($el_2.length > 0) {
    var stickyHeaderTop_2 = $el_2.position().top - window_height_2 + 150,
        flag_2 = 0;
    $(window).scroll(function() {
        flag_2 == 0 && $(window).scrollTop() > stickyHeaderTop_2 && (flag_2 = 1)
    })
}(function(factory) {
    "use strict";
    typeof define == "function" && define.amd ? define(["jquery"], factory) : typeof exports < "u" ? module.exports = factory(require("jquery")) : factory(jQuery)
})(function($2) {
    $2.fn.marquee = function(options) {
        return this.each(function() {
            var o = $2.extend({}, $2.fn.marquee.defaults, options),
                $this = $2(this),
                $marqueeWrapper, containerWidth, animationCss, verticalDir, elWidth, loopCount = 3,
                playState = "animation-play-state",
                css3AnimationIsSupported = !1,
                _prefixedEvent = function(element, type, callback) {
                    for (var pfx = ["webkit", "moz", "MS", "o", ""], p = 0; p < pfx.length; p++) pfx[p] || (type = type.toLowerCase()), element.addEventListener(pfx[p] + type, callback, !1)
                },
                _objToString = function(obj) {
                    var tabjson = [];
                    for (var p in obj) obj.hasOwnProperty(p) && tabjson.push(p + ":" + obj[p]);
                    return tabjson.push(), "{" + tabjson.join(",") + "}"
                },
                _startAnimationWithDelay = function() {
                    $this.timer = setTimeout(animate, o.delayBeforeStart)
                },
                methods = {
                    pause: function() {
                        css3AnimationIsSupported && o.allowCss3Support ? $marqueeWrapper.css(playState, "paused") : $2.fn.pause && $marqueeWrapper.pause(), $this.data("runningStatus", "paused"), $this.trigger("paused")
                    },
                    resume: function() {
                        css3AnimationIsSupported && o.allowCss3Support ? $marqueeWrapper.css(playState, "running") : $2.fn.resume && $marqueeWrapper.resume(), $this.data("runningStatus", "resumed"), $this.trigger("resumed")
                    },
                    toggle: function() {
                        methods[$this.data("runningStatus") === "resumed" ? "pause" : "resume"]()
                    },
                    destroy: function() {
                        clearTimeout($this.timer), $this.find("*").addBack().off(), $this.html($this.find(".js-marquee:first").html())
                    }
                };
            if (typeof options == "string") {
                $2.isFunction(methods[options]) && ($marqueeWrapper || ($marqueeWrapper = $this.find(".js-marquee-wrapper")), $this.data("css3AnimationIsSupported") === !0 && (css3AnimationIsSupported = !0), methods[options]());
                return
            }
            var dataAttributes = {},
                attr;
            $2.each(o, function(key) {
                if (attr = $this.attr("data-" + key), typeof attr < "u") {
                    switch (attr) {
                        case "true":
                            attr = !0;
                            break;
                        case "false":
                            attr = !1;
                            break
                    }
                    o[key] = attr
                }
            }), o.speed && (o.duration = parseInt($this.width(), 10) / o.speed * 1e3), verticalDir = o.direction === "up" || o.direction === "down", o.gap = o.duplicated ? parseInt(o.gap) : 0, $this.wrapInner('<div class="js-marquee"></div>');
            var $el2 = $this.find(".js-marquee").css({
                "margin-right": o.gap,
                float: "left"
            });
            if (o.duplicated && $el2.clone(!0).appendTo($this), $this.wrapInner('<div style="width:100000px" class="js-marquee-wrapper"></div>'), $marqueeWrapper = $this.find(".js-marquee-wrapper"), verticalDir) {
                var containerHeight = $this.height();
                $marqueeWrapper.removeAttr("style"), $this.height(containerHeight), $this.find(".js-marquee").css({
                    float: "none",
                    "margin-bottom": o.gap,
                    "margin-right": 0
                }), o.duplicated && $this.find(".js-marquee:last").css({
                    "margin-bottom": 0
                });
                var elHeight = $this.find(".js-marquee:first").height() + o.gap;
                o.startVisible && !o.duplicated ? (o._completeDuration = (parseInt(elHeight, 10) + parseInt(containerHeight, 10)) / parseInt(containerHeight, 10) * o.duration, o.duration = parseInt(elHeight, 10) / parseInt(containerHeight, 10) * o.duration) : o.duration = (parseInt(elHeight, 10) + parseInt(containerHeight, 10)) / parseInt(containerHeight, 10) * o.duration
            } else elWidth = $this.find(".js-marquee:first").width() + o.gap, containerWidth = $this.width(), o.startVisible && !o.duplicated ? (o._completeDuration = (parseInt(elWidth, 10) + parseInt(containerWidth, 10)) / parseInt(containerWidth, 10) * o.duration, o.duration = parseInt(elWidth, 10) / parseInt(containerWidth, 10) * o.duration) : o.duration = (parseInt(elWidth, 10) + parseInt(containerWidth, 10)) / parseInt(containerWidth, 10) * o.duration;
            if (o.duplicated && (o.duration = o.duration / 2), o.allowCss3Support) {
                var elm = document.body || document.createElement("div"),
                    animationName = "marqueeAnimation-" + Math.floor(Math.random() * 1e7),
                    domPrefixes = "Webkit Moz O ms Khtml".split(" "),
                    animationString = "animation",
                    animationCss3Str = "",
                    keyframeString = "";
                if (elm.style.animation !== void 0 && (keyframeString = "@keyframes " + animationName + " ", css3AnimationIsSupported = !0), css3AnimationIsSupported === !1) {
                    for (var i = 0; i < domPrefixes.length; i++)
                        if (elm.style[domPrefixes[i] + "AnimationName"] !== void 0) {
                            var prefix = "-" + domPrefixes[i].toLowerCase() + "-";
                            animationString = prefix + animationString, playState = prefix + playState, keyframeString = "@" + prefix + "keyframes " + animationName + " ", css3AnimationIsSupported = !0;
                            break
                        }
                }
                css3AnimationIsSupported && (animationCss3Str = animationName + " " + o.duration / 1e3 + "s " + o.delayBeforeStart / 1e3 + "s infinite " + o.css3easing, $this.data("css3AnimationIsSupported", !0))
            }
            var _rePositionVertically = function() {
                    $marqueeWrapper.css("transform", "translateY(" + (o.direction === "up" ? containerHeight + "px" : "-" + elHeight + "px") + ")")
                },
                _rePositionHorizontally = function() {
                    $marqueeWrapper.css("transform", "translateX(" + (o.direction === "left" ? containerWidth + "px" : "-" + elWidth + "px") + ")")
                };
            o.duplicated ? (verticalDir ? o.startVisible ? $marqueeWrapper.css("transform", "translateY(0)") : $marqueeWrapper.css("transform", "translateY(" + (o.direction === "up" ? containerHeight + "px" : "-" + (elHeight * 2 - o.gap) + "px") + ")") : o.startVisible ? $marqueeWrapper.css("transform", "translateX(0)") : $marqueeWrapper.css("transform", "translateX(" + (o.direction === "left" ? containerWidth + "px" : "-" + (elWidth * 2 - o.gap) + "px") + ")"), o.startVisible || (loopCount = 1)) : o.startVisible ? loopCount = 2 : verticalDir ? _rePositionVertically() : _rePositionHorizontally();
            var animate = function() {
                if (o.duplicated && (loopCount === 1 ? (o._originalDuration = o.duration, verticalDir ? o.duration = o.direction === "up" ? o.duration + containerHeight / (elHeight / o.duration) : o.duration * 2 : o.duration = o.direction === "left" ? o.duration + containerWidth / (elWidth / o.duration) : o.duration * 2, animationCss3Str && (animationCss3Str = animationName + " " + o.duration / 1e3 + "s " + o.delayBeforeStart / 1e3 + "s " + o.css3easing), loopCount++) : loopCount === 2 && (o.duration = o._originalDuration, animationCss3Str && (animationName = animationName + "0", keyframeString = $2.trim(keyframeString) + "0 ", animationCss3Str = animationName + " " + o.duration / 1e3 + "s 0s infinite " + o.css3easing), loopCount++)), verticalDir ? o.duplicated ? (loopCount > 2 && $marqueeWrapper.css("transform", "translateY(" + (o.direction === "up" ? 0 : "-" + elHeight + "px") + ")"), animationCss = {
                        transform: "translateY(" + (o.direction === "up" ? "-" + elHeight + "px" : 0) + ")"
                    }) : o.startVisible ? loopCount === 2 ? (animationCss3Str && (animationCss3Str = animationName + " " + o.duration / 1e3 + "s " + o.delayBeforeStart / 1e3 + "s " + o.css3easing), animationCss = {
                        transform: "translateY(" + (o.direction === "up" ? "-" + elHeight + "px" : containerHeight + "px") + ")"
                    }, loopCount++) : loopCount === 3 && (o.duration = o._completeDuration, animationCss3Str && (animationName = animationName + "0", keyframeString = $2.trim(keyframeString) + "0 ", animationCss3Str = animationName + " " + o.duration / 1e3 + "s 0s infinite " + o.css3easing), _rePositionVertically()) : (_rePositionVertically(), animationCss = {
                        transform: "translateY(" + (o.direction === "up" ? "-" + $marqueeWrapper.height() + "px" : containerHeight + "px") + ")"
                    }) : o.duplicated ? (loopCount > 2 && $marqueeWrapper.css("transform", "translateX(" + (o.direction === "left" ? 0 : "-" + elWidth + "px") + ")"), animationCss = {
                        transform: "translateX(" + (o.direction === "left" ? "-" + elWidth + "px" : 0) + ")"
                    }) : o.startVisible ? loopCount === 2 ? (animationCss3Str && (animationCss3Str = animationName + " " + o.duration / 1e3 + "s " + o.delayBeforeStart / 1e3 + "s " + o.css3easing), animationCss = {
                        transform: "translateX(" + (o.direction === "left" ? "-" + elWidth + "px" : containerWidth + "px") + ")"
                    }, loopCount++) : loopCount === 3 && (o.duration = o._completeDuration, animationCss3Str && (animationName = animationName + "0", keyframeString = $2.trim(keyframeString) + "0 ", animationCss3Str = animationName + " " + o.duration / 1e3 + "s 0s infinite " + o.css3easing), _rePositionHorizontally()) : (_rePositionHorizontally(), animationCss = {
                        transform: "translateX(" + (o.direction === "left" ? "-" + elWidth + "px" : containerWidth + "px") + ")"
                    }), $this.trigger("beforeStarting"), css3AnimationIsSupported) {
                    $marqueeWrapper.css(animationString, animationCss3Str);
                    var keyframeCss = keyframeString + " { 100%  " + _objToString(animationCss) + "}",
                        $styles = $marqueeWrapper.find("style");
                    $styles.length !== 0 ? $styles.filter(":last").html(keyframeCss) : $2("head").append("<style>" + keyframeCss + "</style>"), _prefixedEvent($marqueeWrapper[0], "AnimationIteration", function() {
                        $this.trigger("finished")
                    }), _prefixedEvent($marqueeWrapper[0], "AnimationEnd", function() {
                        animate(), $this.trigger("finished")
                    })
                } else $marqueeWrapper.animate(animationCss, o.duration, o.easing, function() {
                    $this.trigger("finished"), o.pauseOnCycle ? _startAnimationWithDelay() : animate()
                });
                $this.data("runningStatus", "resumed")
            };
            $this.on("pause", methods.pause), $this.on("resume", methods.resume), o.pauseOnHover && ($this.on("mouseenter", methods.pause), $this.on("mouseleave", methods.resume)), css3AnimationIsSupported && o.allowCss3Support ? animate() : _startAnimationWithDelay()
        })
    }, $2.fn.marquee.defaults = {
        allowCss3Support: !0,
        css3easing: "linear",
        easing: "linear",
        delayBeforeStart: 1e3,
        direction: "left",
        duplicated: !1,
        duration: 5e3,
        speed: 0,
        gap: 20,
        pauseOnCycle: !1,
        pauseOnHover: !1,
        startVisible: !1
    }
});

function allSiteMarquee() {
    var widthMarquee = $(window).width();
    widthMarquee < 750 ? $(".index-marquee").marquee({
        duration: 2e4,
        gap: 0,
        delayBeforeStart: 0,
        direction: "left",
        duplicated: !0,
        startVisible: !0
    }) : $(".index-marquee").marquee({
        duration: 55e3,
        gap: 0,
        delayBeforeStart: 0,
        direction: "left",
        duplicated: !0,
        startVisible: !0
    }), widthMarquee < 750 ? $(".testimonials-marquee").marquee({
        duration: 2e4,
        gap: 0,
        delayBeforeStart: 0,
        direction: "left",
        duplicated: !0,
        startVisible: !0
    }) : $(".testimonials-marquee").marquee({
        duration: 55e3,
        gap: 0,
        delayBeforeStart: 0,
        direction: "left",
        duplicated: !0,
        startVisible: !0
    })
}
allSiteMarquee(), $(".custom_mega_menu_top_only_new").hover(function() {
    $("body").addClass("open_megamenu"), $(this).find(".mega-menu").attr("open", "open"), $(this).find(".icon-caret").css("transform", "rotate(180deg)")
}, function() {
    $("body").removeClass("open_megamenu"), $(this).find(".mega-menu").attr("open", !1), $(this).find(".icon-caret").css("transform", "none")
}), $(window).on("scroll", function() {
    
    var stickyHeaderFromTop =  0;
    positionFromTop = 0;
    scrollTop = $(window).scrollTop();
    
    if ($("sticky-header").length){
        stickyHeaderFromTop = $("sticky-header").offset().top,
        scrollTop = $(window).scrollTop(),
        positionFromTop = stickyHeaderFromTop - scrollTop;
    }
    
        
        
    positionFromTop <= 0 && (scrollTop = 36 + Math.abs(positionFromTop)), $(".custom_mega_menu_top_only_new").find(".mega-menu__content").css("top", 36 - scrollTop + "px"), $(".custom_mega_menu_top_only_new").find(".Header_mega_menu_maindetail_new").css("max-height", "calc(100vh - " + (100 - scrollTop) + "px)"), $(".custom_mega_menu_top_only_new").find(".Header_mega_menu_maindetail_new").css("height", "calc(100vh - " + (100 - scrollTop) + "px)"), $(".sticky-addtocart-button").css("display") == "block" && ($("body").removeClass("open_megamenu"), $(".custom_mega_menu_top_only_new").find(".mega-menu").attr("open", !1), $(".custom_mega_menu_top_only_new").find(".icon-caret").css("transform", "none"))
}), $(".Header_mega_menu_maindetail_new").hover(function() {}, function() {
    $("body").removeClass("open_megamenu"), $(".custom_mega_menu_top_only_new").find(".mega-menu").attr("open", !1)
}), $(".single_menu_top_new").hover(function() {
    $(this).find(".mega-menu").attr("open", "open")
}, function() {
    $(this).find(".mega-menu").removeAttr("open")
}), $(".tab_title_mobile_new").on("click", function() {
    var width2 = $(window).width();
    console.log(width2), width2 < 750 && ($(this).parent().toggleClass("open"), $(this).parent().hasClass("open") == !0 ? ($(".Page_ingredients_mobile_dropdown_new").parent().removeClass("active"), $(".Page_ingredients_mobile_dropdown_new").next(".tab").css("display", "none"), $(this).next(".tab").css("display", "block")) : $(this).next(".tab").css("display", "none"))
}), $(".Tabs_common_inner_new").click(function() {
    var tab_id = $(this).attr("tab_id");
    $(this).hasClass("active") == !1 && ($(this).parents(".Tabs_common_main_new").find(".Tabs_common_inner_new").removeClass("active"), $(this).parents(".Tabs_common_main_new").find(".tabcontent").css("display", "none"), $(this).addClass("active"), $(this).parents(".Tabs_common_main_new").find("." + tab_id + "_open").css("display", "block"));
    var width2 = $(window).width();
    if (width2 < 750) {
        $(this).parent(".tab").css("display", "none"), $(this).parent().parent(".tab_title_main_new").removeClass("open");
        var selected_tab_name = $(this).html();
        $(this).parent().parent().find(".tab_title_mobile_inner_new").html(selected_tab_name)
    }
}), $(".Tabs_common_regular_inner_new").click(function() {
    var tab_id = $(this).attr("tab_id");
    $(this).hasClass("active") == !1 && ($(this).parents(".Tabs_common_regular_main_new").find(".Tabs_common_regular_inner_new").removeClass("active"), $(this).parents(".Tabs_common_regular_main_new").find(".tabcontent").css("display", "none"), $(this).addClass("active"), $(this).parents(".Tabs_common_regular_main_new").find("." + tab_id + "_open").css("display", "block"))
});

function initAccordion() {
    $(".accordion .question").click(function() {
        var $this = $(this),
            $parentLi = $this.parent("li"),
            $accordion = $this.parents(".accordion"),
            $currentAnswer = $this.next(".answer");
        if ($parentLi.hasClass("open")) {
            var currentHeight = $currentAnswer.outerHeight();
            $currentAnswer.css("height", currentHeight).stop().animate({
                height: 0,
                opacity: 0
            }, 300, function() {
                $(this).css({
                    display: "none",
                    height: "",
                    opacity: ""
                })
            }), $parentLi.removeClass("open")
        } else {
            $accordion.find(".answer").stop().animate({
                height: 0,
                opacity: 0
            }, 300, function() {
                $(this).css({
                    display: "none",
                    height: "",
                    opacity: ""
                })
            }), $accordion.find("li").removeClass("open"), $currentAnswer.css({
                display: "block",
                height: 0,
                opacity: 0
            });
            var naturalHeight = $currentAnswer[0].scrollHeight;
            $currentAnswer.stop().animate({
                height: naturalHeight,
                opacity: 1
            }, 300, function() {
                $(this).css("height", "auto")
            }), $parentLi.addClass("open")
        }
    })
}

function initACCAccordion() {
    if (console.log("Setting up ACC accordion event delegation for injected content"), $(document).on("click", ".ACC_IM8_Homepage_22-accordion summary.ACC_IM8_Homepage_22-question", function(e) {
            e.preventDefault(), console.log("ACC accordion clicked via delegation!");
            var $summary = $(this),
                $details = $summary.closest("details"),
                $accordion = $summary.closest(".ACC_IM8_Homepage_22-accordion"),
                $answer = $details.find("div.ACC_IM8_Homepage_22-answer");
            if (console.log("Elements found:", {
                    summary: $summary.length,
                    details: $details.length,
                    accordion: $accordion.length,
                    answer: $answer.length
                }), $answer.length === 0) {
                console.log("No answer div found, skipping");
                return
            }
            var isOpen = $details.attr("open") !== void 0;
            if (console.log("Currently open:", isOpen), isOpen) {
                console.log("Closing accordion");
                var currentHeight = $answer.outerHeight();
                $answer.css("height", currentHeight + "px").stop().animate({
                    height: "0px",
                    opacity: "0"
                }, 300, function() {
                    $details.removeAttr("open"), console.log("Close animation complete")
                })
            } else {
                console.log("Opening accordion"), $answer.data("initialized") || $answer.css({
                    overflow: "hidden"
                }).data("initialized", !0), $details.attr("open", "open"), $answer.css({
                    height: "auto",
                    opacity: "0"
                });
                var naturalHeight = $answer[0].scrollHeight;
                console.log("Natural height:", naturalHeight), $answer.css("height", "0px").stop().animate({
                    height: naturalHeight + "px",
                    opacity: "1"
                }, 300, function() {
                    $answer.css("height", "auto"), console.log("Open animation complete")
                })
            }
        }), typeof MutationObserver < "u") {
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                mutation.type === "childList" && mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) {
                        var $node = $(node),
                            $newAccordions = $node.find(".ACC_IM8_Homepage_22-accordion");
                        if ($newAccordions.length > 0 && (console.log("New ACC accordions detected:", $newAccordions.length), $newAccordions.each(function() {
                                var $answer2 = $(this).find("div.ACC_IM8_Homepage_22-answer");
                                $answer2.length > 0 && !$answer2.data("initialized") && ($answer2.css({
                                    height: "0px",
                                    overflow: "hidden",
                                    opacity: "0"
                                }).data("initialized", !0), console.log("Initialized new ACC accordion answer div"))
                            })), $node.hasClass("ACC_IM8_Homepage_22-accordion")) {
                            console.log("Direct ACC accordion node added");
                            var $answer = $node.find("div.ACC_IM8_Homepage_22-answer");
                            $answer.length > 0 && !$answer.data("initialized") && ($answer.css({
                                height: "0px",
                                overflow: "hidden",
                                opacity: "0"
                            }).data("initialized", !0), console.log("Initialized direct ACC accordion answer div"))
                        }
                    }
                })
            })
        });
        observer.observe(document.body, {
            childList: !0,
            subtree: !0
        }), console.log("Mutation observer set up for ACC accordions")
    }
}
$(document).ready(function() {
    initAccordion(), initACCAccordion(), console.log("ACC accordions found:", $('details[class*="ACC_IM8_Homepage_22"]').length), console.log("ACC accordion elements:", $('details[class*="ACC_IM8_Homepage_22"]'))
}), $('a[href^="#"]').on("click", function(event) {
    var target2 = $($(this).attr("href"));
    target2.length && (event.preventDefault(), $("html, body").stop().animate({
        scrollTop: target2.offset().top
    }, 500))
});
var target = window.location.hash,
    hash = target.substring(target.indexOf("#") + 1);
hash && $("#" + hash).offset() && ($("html, body").stop().animate({
    scrollTop: $("#" + hash).offset().top - 200
}, 500), $("#" + hash).hasClass("open") == !1 && setTimeout(function() {
    $("#" + hash + " .question").trigger("click")
}, 700)), $(".footer-block__details-content .list-unstyled a").on("click", function(event) {
    var target2 = $(this).attr("href"),
        hash2 = target2.substring(target2.indexOf("#") + 1);
    hash2 && ($("html, body").stop().animate({
        scrollTop: $("#" + hash2).offset().top - 200
    }, 500), $("#" + hash2).hasClass("open") == !1 && setTimeout(function() {
        $("#" + hash2 + " .question").trigger("click")
    }, 700))
}), $(".footer-block__heading").click(function() {
    var width2 = $(window).width();
    width2 < 750 && ($(this).toggleClass("active"), $(this).next(".footer-block__details-content").slideToggle())
}), $(".Index_object_tab_wellness_inneranswers_innerdesktop_innerboxs_mainplus_new").click(function() {
    $(this).parents(".Index_object_tab_wellness_inneranswers_innerdesktop_mainboxs_new").find(".Index_card_object_new").addClass("active")
}), $(".Index_object_tab_wellness_inneranswers_innerdesktop_innerboxs_mainclose_new").click(function() {
    $(this).parents(".Index_object_tab_wellness_inneranswers_innerdesktop_mainboxs_new").find(".Index_card_object_new").removeClass("active")
}), $(".Index_object_advisor_list_detail_2_loops_innerboxs_mainsides_new").click(function() {
    $(this).parents(".Index_object_advisor_list_detail_2_loops_innerboxs_new").find(".Index_object_advisor_list_detail_2_loops_innerboxs_mainpopup_new").fadeIn(), $(".Index_object_advisor_list_detail_2_loops_innerboxs_innerpopup_mainoverlay_new").fadeIn(), $("body").addClass("overflow-hidden")
}), $(".Index_object_advisor_list_detail_2_loops_innerboxs_innerpopup_innerrows_mainclose_new").click(function() {
    $(this).parents(".Index_object_advisor_list_detail_2_loops_innerboxs_new").find(".Index_object_advisor_list_detail_2_loops_innerboxs_mainpopup_new").fadeOut(), $(".Index_object_advisor_list_detail_2_loops_innerboxs_innerpopup_mainoverlay_new").fadeOut(), $("body").removeClass("overflow-hidden"), $(this).parents(".video_play_list_new").find(".video_play_icon_new").removeClass("active"), $(this).parents(".video_play_list_new").find("video").trigger("pause"), $(this).parents(".video_play_list_new").find("svg.play_icon").css("display", "block")
}), $(".Index_object_advisor_list_detail_2_loops_innerboxs_innerpopup_mainoverlay_new").click(function() {
    $(".Index_object_advisor_list_detail_2_loops_innerboxs_mainpopup_new").fadeOut(), $(".Index_object_advisor_list_detail_2_loops_innerboxs_innerpopup_mainoverlay_new").fadeOut(), $("body").removeClass("overflow-hidden"), $(this).parents(".video_play_list_new").find(".video_play_icon_new").removeClass("active"), $(this).parents(".video_play_list_new").find("video").trigger("pause"), $(this).parents(".video_play_list_new").find("svg.play_icon").css("display", "block")
}), $(".view_more_item").click(function() {
    var item_id = $(this).attr("item_id");
    $("." + item_id + " .hide_this_item").css("display", "block"), $("." + item_id + " .view_more_item").css("display", "none")
});

function welcomeHeight() {
    var window_height2 = $(window).outerHeight(!0);
    $(".LP_Welcome_innersides_new").height(window_height2)
}
welcomeHeight(), $(window).resize(function() {
    welcomeHeight()
}), $(".unmute_video").click(function() {
    var mute_id = $(this).attr("mute_id");
    mute_id && ($(this).removeClass("active"), $("[mute_id=" + mute_id + "].mute_video").addClass("active"), $("#" + mute_id + "_play").find("video").prop("muted", 0))
}), $(".mute_video").click(function() {
    var mute_id = $(this).attr("mute_id");
    mute_id && ($(this).removeClass("active"), $("[mute_id=" + mute_id + "].unmute_video").addClass("active"), $("#" + mute_id + "_play").find("video").prop("muted", 1))
}), $(".reload_video").click(function() {
    var mute_id = $(this).attr("mute_id");
    mute_id && ($("#" + mute_id + "_play").find("video").get(0).play(), $("[mute_id=" + mute_id + "].reload_video").removeClass("active"))
}), $(".play_icon_new").click(function() {
    var mute_id = $(this).attr("mute_id");
    mute_id && ($("#" + mute_id + "_play").find("video").get(0).play(), $("[mute_id=" + mute_id + "].reload_video").removeClass("active"), $(this).fadeOut(), $(".mute_video_main_new").fadeIn())
}), $(".expand_video").click(function() {
    console.log("expand_video"), $(this).removeClass("active"), $(".shrink_video").addClass("active"), $(".influencer_video").addClass("expanded");
    const videoContainer = $(".influencer_video")[0],
        video = $(".influencer_video video")[0],
        youtubeWrapper = $(".influencer_video .youtube-video-wrapper")[0];
    if (window.innerWidth <= 768 && ($(".influencer_video").addClass("mobile-fullscreen"), $("body").addClass("video-fullscreen"), startFullscreenPolling(), videoContainer && videoContainer.requestFullscreen ? videoContainer.requestFullscreen().catch(function(err) {
            console.log("Fullscreen request failed, using custom fullscreen:", err)
        }) : videoContainer && videoContainer.webkitRequestFullscreen ? videoContainer.webkitRequestFullscreen() : videoContainer && videoContainer.mozRequestFullScreen ? videoContainer.mozRequestFullScreen() : videoContainer && videoContainer.msRequestFullscreen && videoContainer.msRequestFullscreen(), video && video.webkitEnterFullscreen && /iPad|iPhone|iPod/.test(navigator.userAgent))) try {
        video.webkitEnterFullscreen()
    } catch {
        console.log("Fullscreen not supported on this device")
    }
}), $(".shrink_video").click(function() {
    console.log("shrink_video"), $(this).removeClass("active"), $(".expand_video").addClass("active"), $(".influencer_video").removeClass("expanded"), (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) && (document.exitFullscreen ? document.exitFullscreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.msExitFullscreen && document.msExitFullscreen()), stopFullscreenPolling(), $(".influencer_video").removeClass("mobile-fullscreen"), $("body").removeClass("video-fullscreen")
});

function cleanupFullscreenState() {
    $(".shrink_video").removeClass("active"), $(".expand_video").addClass("active"), $(".influencer_video").removeClass("expanded mobile-fullscreen"), $("body").removeClass("video-fullscreen"), console.log("Fullscreen state cleaned up")
}
$(document).on("fullscreenchange webkitfullscreenchange mozfullscreenchange MSFullscreenChange", function() {
    !document.fullscreenElement && !document.webkitFullscreenElement && !document.mozFullScreenElement && !document.msFullscreenElement && (cleanupFullscreenState(), console.log("Standard fullscreen exit detected"))
}), $(document).on("webkitendfullscreen", ".influencer_video video", function() {
    cleanupFullscreenState(), console.log("iOS Safari webkitendfullscreen event detected")
}), $(document).on("visibilitychange", function() {
    document.hidden || setTimeout(function() {
        !document.fullscreenElement && !document.webkitFullscreenElement && !document.mozFullScreenElement && !document.msFullscreenElement && ($(".influencer_video").hasClass("mobile-fullscreen") || $(".influencer_video").hasClass("expanded")) && (cleanupFullscreenState(), console.log("Visibility change detected - cleaned up fullscreen state"))
    }, 300)
}), $(window).on("focus", function() {
    setTimeout(function() {
        !document.fullscreenElement && !document.webkitFullscreenElement && !document.mozFullScreenElement && !document.msFullscreenElement && ($(".influencer_video").hasClass("mobile-fullscreen") || $(".influencer_video").hasClass("expanded")) && (cleanupFullscreenState(), console.log("Window focus detected - cleaned up fullscreen state"))
    }, 300)
}), $(window).on("orientationchange resize", function() {
    setTimeout(function() {
        !document.fullscreenElement && !document.webkitFullscreenElement && !document.mozFullScreenElement && !document.msFullscreenElement && ($(".influencer_video").hasClass("mobile-fullscreen") || $(".influencer_video").hasClass("expanded")) && (cleanupFullscreenState(), console.log("Orientation/resize change detected - cleaned up fullscreen state"))
    }, 500)
});
var fullscreenCheckInterval;

function startFullscreenPolling() {
    fullscreenCheckInterval = setInterval(function() {
        if ($(".influencer_video").hasClass("mobile-fullscreen") || $(".influencer_video").hasClass("expanded")) {
            var inFullscreen = !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement),
                isMobileSafari = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
                windowIsFullHeight = window.innerHeight >= screen.height * .9;
            !inFullscreen && (!isMobileSafari || !windowIsFullHeight) && (cleanupFullscreenState(), console.log("Polling detected fullscreen exit - cleaned up state"), clearInterval(fullscreenCheckInterval))
        } else clearInterval(fullscreenCheckInterval)
    }, 2e3)
}

function stopFullscreenPolling() {
    fullscreenCheckInterval && (clearInterval(fullscreenCheckInterval), fullscreenCheckInterval = null)
}

function initKlavioFormHandler() {
    const intervalId = setInterval(isKlavioLoaded, 1e3);

    function isKlavioLoaded() {
        if (document.querySelector(".Footer_1_newsletter_main_new .newsletter-form__field-wrapper .field__input")) {
            clearInterval(intervalId);
            const emailInput2 = document.querySelector(".Footer_1_newsletter_main_new .newsletter-form__field-wrapper .field__input");
            listenKlavioFormInput(emailInput2)
        }
    }

    function listenKlavioFormInput(emailInput2) {
        const emailFormContainer = emailInput2?.closest(".Footer_1_newsletter_main_new .newsletter-form__field-wrapper");
        emailInput2?.addEventListener("input", e => {
            e.target.value ? emailFormContainer.classList.add("input-filled") : emailFormContainer.classList.remove("input-filled")
        })
    }
}
initKlavioFormHandler();

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date;
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1e3), expires = "; expires=" + date.toUTCString()
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/"
}

function getCookie(name) {
    for (var nameEQ = name + "=", ca = document.cookie.split(";"), i = 0; i < ca.length; i++) {
        for (var c = ca[i]; c.charAt(0) === " ";) c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
    }
    return null
}

function storeEmail(email) {
    window.sessionStorage ? sessionStorage.setItem("customerEmail", email) : setCookie("customerEmail", email, 1)
}

function retrieveEmail() {
    return window.sessionStorage ? sessionStorage.getItem("customerEmail") : getCookie("customerEmail")
}
var REDIRECT_PATH = "/pages/register-success?view=register-success&utm_email=",
    selector = '#create_customer, form[action$="/account"][method="post"]',
    $form = document.querySelectorAll(selector)[0];
if ($form) {
    var emailInput = $form.querySelector('input[type="email"]');
    emailInput && $form.addEventListener("submit", function() {
        var customerEmail = emailInput.value,
            emailEncoded2 = encodeURIComponent(customerEmail);
        storeEmail(customerEmail), $redirect.value = REDIRECT_PATH + emailEncoded2
    });
    var $redirect = document.createElement("input");
    $redirect.setAttribute("name", "return_to"), $redirect.setAttribute("type", "hidden");
    var storedEmail = retrieveEmail();
    if (storedEmail) {
        var emailEncoded = encodeURIComponent(storedEmail);
        $redirect.value = REDIRECT_PATH + emailEncoded
    } else $redirect.value = REDIRECT_PATH;
    $form.appendChild($redirect)
}
$(".video_play_icon_new").click(function() {
    if ($(this).hasClass("active") == !1) {
        $(this).parents(".video_play_list_new").find(".video_play_icon_new").removeClass("active"), $(this).parents(".video_play_list_new").find("video").trigger("pause"), $(this).parents(".video_play_list_new").find("svg.play_icon").css("display", "block"), $(this).addClass("active");
        var URL = $(this).find("video").attr("video_url");
        $(this).find("video").attr("src") == null && $(this).find("video").attr("src", URL), $(this).find("video").trigger("play"), $(this).find("svg.play_icon").css("display", "none")
    } else $(this).removeClass("active"), $(this).find("video").trigger("pause"), $(this).find("svg.play_icon").css("display", "block")
}), $(".Card_product_main_new").hover(function() {
    var URL = $(this).find("video").attr("video_url");
    $(this).find("video").attr("src") == null && $(this).find("video").attr("src", URL), $(this).find("video").trigger("play")
}, function() {
    $(this).find("video").trigger("pause")
}), $(".open_Meta_supplement_popup").click(function() {
    $("body").addClass("open_supplement"), $(".Meta_supplement_popup_mainpopup_new").fadeIn()
}), $(".close_Meta_supplement_popup").click(function() {
    $("body").removeClass("open_supplement"), $(".Meta_supplement_popup_mainpopup_new").fadeOut()
}), $(".people_popup_open").click(function() {
    var video_id = $(this).attr("video_id");
    if (video_id) {
        $("." + video_id + "_open").fadeIn(), $(".people_popup_overlay_new").fadeIn(), $("body").addClass("overflow-hidden");
        var URL = $("." + video_id + "_open").find("video").attr("video_url");
        $("." + video_id + "_open").find("video").attr("src") == null && $("." + video_id + "_open").find("video").attr("src", URL), $("." + video_id + "_open").find("video").trigger("play"), $("." + video_id + "_open").find(".video_play_icon_new").addClass("active"), $("." + video_id + "_open").find("svg.play_icon").css("display", "none")
    }
}), $(".mute_video_popup").click(function() {
    $(this).removeClass("active"), $(this).parents(".meta_real_reviews_mainpopup_new").find(".unmute_video_popup").addClass("active"), $(this).parents(".meta_real_reviews_mainpopup_new").find("video").prop("muted", 1)
}), $(".unmute_video_popup").click(function() {
    $(this).removeClass("active"), $(this).parents(".meta_real_reviews_mainpopup_new").find(".mute_video_popup").addClass("active"), $(this).parents(".meta_real_reviews_mainpopup_new").find("video").prop("muted", 0)
}), $(".meta_real_reviews_mainclose_new").click(function() {
    $(".meta_real_reviews_mainpopup_new").fadeOut(), $(".people_popup_overlay_new").fadeOut(), $("body").removeClass("overflow-hidden"), $(this).parents(".video_play_list_new").find(".video_play_icon_new").removeClass("active"), $(this).parents(".video_play_list_new").find("video").trigger("pause"), $(this).parents(".video_play_list_new").find("svg.play_icon").css("display", "block")
}), $(".people_popup_overlay_new").click(function() {
    $(".meta_real_reviews_mainpopup_new").fadeOut(), $(".people_popup_overlay_new").fadeOut(), $("body").removeClass("overflow-hidden"), $(this).parents(".video_play_list_new").find(".video_play_icon_new").removeClass("active"), $(this).parents(".video_play_list_new").find("video").trigger("pause"), $(this).parents(".video_play_list_new").find("svg.play_icon").css("display", "block")
}), $(".view_more_product").click(function() {
    var product_id = $(this).attr("product_id");
    $("." + product_id + " .hide_this_product").css("display", "block"), $("." + product_id + " .see_full_ingerdient").css("display", "block"), $("." + product_id + " .view_more_product").css("display", "none")
}), $(document).ready(function() {
    var width2 = $(window).width();
    width2 < 750 && $(".ingredients_tab_box_new").each(function(index) {
        $(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find(".box_click_all").css("display", "none"), $(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find(".box_click_all:nth-child(1)").css("display", "block"), $(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find(".box_click_all:nth-child(2)").css("display", "block"), $(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find(".box_click_all:nth-child(3)").css("display", "block"), $(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find(".box_click_all:nth-child(4)").css("display", "block");
        var mobile_count = $(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find(".box_click_all").length;
        mobile_count > 4 ? $(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find(".ingredients_view_more_item").css("display", "block") : $(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find(".ingredients_view_more_item").css("display", "none")
    })
}), $(".ingredients_tab_new").click(function() {
    var inner_tab_id = $(this).attr("inner_tab_id");
    if (inner_tab_id == "tab1_all" || inner_tab_id == "tab2_all") {
        $(this).parents(".ingredients_tab_box_main_new").find(".ingredients_tab_new").removeClass("active"), $(this).parents(".ingredients_tab_box_main_new").find(".ingredients_tab_box_new").css("display", "block"), $(this).addClass("active");
        var width2 = $(window).width();
        if ($(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find(".box_click").removeClass("active"), width2 >= 750) $(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find(".box_click_all").css("display", "block");
        else {
            $(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find(".box_click_all").css("display", "none"), $(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find(".box_click_all:nth-child(1)").css("display", "block"), $(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find(".box_click_all:nth-child(2)").css("display", "block"), $(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find(".box_click_all:nth-child(3)").css("display", "block"), $(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find(".box_click_all:nth-child(4)").css("display", "block");
            var mobile_count = $(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find(".box_click_all").length;
            mobile_count > 4 ? $(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find(".ingredients_view_more_item").css("display", "block") : $(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find(".ingredients_view_more_item").css("display", "none")
        }
    } else $(this).parents(".ingredients_tab_box_main_new").find(".ingredients_tab_new").removeClass("active"), $(this).parents(".ingredients_tab_box_main_new").find(".ingredients_tab_box_new").css("display", "none"), $(this).addClass("active"), $(this).parents(".ingredients_tab_box_main_new").find("." + inner_tab_id + "_open").css("display", "block");
    $("." + inner_tab_id + "_open").css("display", "block");
    var ingredients_tab_new_active = $(this).attr("inner_tab_id"),
        box_id = $(".box_click.active").attr("box_id"),
        count = $("." + ingredients_tab_new_active + "_open").find("." + box_id + "_open").length;
    ingredients_tab_new_active == "tab1_all" || ingredients_tab_new_active == "tab2_all" || (count == 0 && box_id ? $("." + ingredients_tab_new_active + "_open").css("display", "none") : $("." + ingredients_tab_new_active + "_open").css("display", "block"));
    var width2 = $(window).width();
    if (width2 < 750) {
        $(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_innerboths_mainlist_new").removeClass("active");
        var selected_tab_name = $(this).html();
        $(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_innerboths_mainlist_new").find(".Page_ingredients_mobile_dropdown_new").html(selected_tab_name)
    }
}), $(".box_click").click(function() {
    if ($(this).hasClass("active") == !1) {
        var box_id = $(this).attr("box_id");
        $(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find(".box_click").removeClass("active"), $(this).addClass("active"), $(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find(".box_click_all").css("display", "none"), $(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find("." + box_id + "_open").css("display", "block");
        var ingredients_tab_new_active = $(".ingredients_tab_new.active").attr("inner_tab_id"),
            count_other = $("." + ingredients_tab_new_active + "_open").find("." + box_id + "_open").length;
        if (ingredients_tab_new_active == "tab1_all" || ingredients_tab_new_active == "tab2_all") $('[inner_tab_id="' + ingredients_tab_new_active + '"]').parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find(".ingredients_tab_box_new").each(function(index) {
            var count = $(this).find("." + box_id + "_open").length,
                ingredients_tab_new_active2 = $(".ingredients_tab_new.active").attr("inner_tab_id");
            count == 0 ? $(this).css("display", "none") : $(this).css("display", "block");
            var width3 = $(window).width();
            if (width3 < 750)
                if (count > 4) {
                    var counter2 = 0;
                    $($(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find("." + box_id + "_open")).each(function(index2) {
                        counter2++, counter2 <= 4 ? $(this).css("display", "block") : $(this).css("display", "none")
                    }), $(this).find(".ingredients_view_more_item").css("display", "block")
                } else $(this).find(".ingredients_view_more_item").css("display", "none")
        });
        else {
            count_other == 0 ? $("." + ingredients_tab_new_active + "_open").css("display", "none") : $("." + ingredients_tab_new_active + "_open").css("display", "block");
            var width2 = $(window).width();
            if (width2 < 750)
                if (count_other > 4) {
                    var counter = 0;
                    $($("." + ingredients_tab_new_active + "_open").find("." + box_id + "_open")).each(function(index) {
                        counter++, counter <= 4 ? $(this).css("display", "block") : $(this).css("display", "none")
                    }), $("." + ingredients_tab_new_active + "_open").find(".ingredients_view_more_item").css("display", "block")
                } else $("." + ingredients_tab_new_active + "_open").find(".ingredients_view_more_item").css("display", "none");
            var width2 = $(window).width();
            width2 < 750 && (count_other > 4 ? $("." + ingredients_tab_new_active + "_open").find(".ingredients_view_more_item").css("display", "block") : $("." + ingredients_tab_new_active + "_open").find(".ingredients_view_more_item").css("display", "none"))
        }
    } else {
        $(this).removeClass("active"), $(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find(".box_click_all").css("display", "block");
        var ingredients_tab_new_active = $(".ingredients_tab_new.active").attr("inner_tab_id"),
            count_other = $("." + ingredients_tab_new_active + "_open").find(".box_click_all").length;
        if (ingredients_tab_new_active == "tab1_all" || ingredients_tab_new_active == "tab2_all") $('[inner_tab_id="' + ingredients_tab_new_active + '"]').parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find(".ingredients_tab_box_new").each(function(index) {
            var count = $(this).find(".box_click_all").length,
                ingredients_tab_new_active2 = $(".ingredients_tab_new.active").attr("inner_tab_id");
            $(this).css("display", "block");
            var width3 = $(window).width();
            if (width3 < 750)
                if (count > 4) {
                    var counter2 = 0;
                    $($(this).find(".box_click_all")).each(function(index2) {
                        counter2++, console.log(counter2), counter2 <= 4 ? $(this).css("display", "block") : $(this).css("display", "none")
                    }), $(this).find(".ingredients_view_more_item").css("display", "block")
                } else $(this).find(".ingredients_view_more_item").css("display", "none")
        });
        else {
            count_other == 0 ? $("." + ingredients_tab_new_active + "_open").css("display", "none") : $("." + ingredients_tab_new_active + "_open").css("display", "block");
            var width2 = $(window).width();
            if (width2 < 750)
                if (count_other > 4) {
                    var counter = 0;
                    $($("." + ingredients_tab_new_active + "_open").find(".box_click_all")).each(function(index) {
                        counter++, counter <= 4 ? $(this).css("display", "block") : $(this).css("display", "none")
                    }), $("." + ingredients_tab_new_active + "_open").find(".ingredients_view_more_item").css("display", "block")
                } else $("." + ingredients_tab_new_active + "_open").find(".ingredients_view_more_item").css("display", "none");
            var width2 = $(window).width();
            width2 < 750 && (count_other > 4 ? $("." + ingredients_tab_new_active + "_open").find(".ingredients_view_more_item").css("display", "block") : $("." + ingredients_tab_new_active + "_open").find(".ingredients_view_more_item").css("display", "none"))
        }
    }
}), $(".ingredients_view_more_item").click(function() {
    var item_id = $(this).attr("item_id");
    $("." + item_id + " .box_click_all").css("display", "block"), $("." + item_id + " .ingredients_view_more_item").css("display", "none");
    var box_id = $(this).parents(".Page_ingredients_objects_tabs_detail_inneranswer_mainboths_new").find(".box_click.active").attr("box_id");
    if (box_id) {
        var count = $(".box_click.active").find("." + box_id + "_open").length;
        $(this).parents(".ingredients_tab_box_new").find(".box_click_all").css("display", "none"), $(this).parents(".ingredients_tab_box_new").find("." + box_id + "_open").css("display", "block")
    }
}), $(".Page_ingredients_mobile_dropdown_new").on("click", function() {
    var width2 = $(window).width();
    width2 < 750 && ($(this).parent().toggleClass("active"), $(this).parent().hasClass("active") == !0 ? ($(".tab_title_mobile_new").parent().removeClass("open"), $(".tab_title_mobile_new").next(".tab").css("display", "none"), $(this).next(".tab").css("display", "block")) : $(this).next(".tab").css("display", "none"))
}), $(".Page_ingredients_objects_tabs_detail_inneranswer_innerboths_innerloop_innerboxs_innerlists_innerboxs_inner_new").click(function() {
    $(this).parents(".box_click_all").addClass("active")
}), $(".Page_ingredients_objects_tabs_detail_inneranswer_innerboths_innerloop_innerboxs_innerlists_innerboxs_mainclose_new").click(function() {
    $(this).parents(".box_click_all").removeClass("active")
});

function productPageScript() {
    if ($(".Product_template_latest_main_new").length > 0) {
        var stickyHeaderTopSticky = $(".Product_template_latest_main_new").offset().top + $(".Product_template_latest_main_new").outerHeight(!0);
        $(window).scroll(function() {
            $(window).scrollTop() > stickyHeaderTopSticky ? $("body").hasClass("scrolled-past-header-body") == !1 && ($("body").addClass("scrolled-past-header-body"), $("body").addClass("display_header_new")) : ($("body").removeClass("scrolled-past-header-body"), $("body").removeClass("display_header_new"))
        })
    }
    $(".open_size_popup").click(function() {
        $(".Product_size_guide_popup_main_new").addClass("active"), $(".Product_size_guide_popup_overlay_new").fadeIn(), $("body").addClass("popup_open")
    }), $(".close_size_popup, .Product_size_guide_popup_overlay_new").click(function() {
        $(".Product_size_guide_popup_main_new").removeClass("active"), $(".Product_size_guide_popup_overlay_new").fadeOut(), $("body").removeClass("popup_open")
    })
}
productPageScript();
var $el = $(".Page_FAQs_left_side_detail_inner_new");
if ($el.length > 0) {
    var stickyHeaderTop = $(".Page_FAQs_left_side_detail_in_new").offset().top,
        width = $(document).width();
    if (width < 989) var spacingFromTop = -104,
        Index_object_instagram_main_new = $(".Index_object_instagram_main_new").offset().top - $(".Page_FAQs_left_side_detail_static_new").outerHeight(!0) - 0;
    else var spacingFromTop = 0,
        Index_object_instagram_main_new = $(".Index_object_instagram_main_new").offset().top - $(".Page_FAQs_left_side_detail_static_new").outerHeight(!0) - 170;
    $(window).scroll(function() {
        var Page_FAQs_left_side_detail_static_new = $(".Page_FAQs_left_side_detail_static_new").offset().top;
        $(window).scrollTop() > stickyHeaderTop - spacingFromTop && $(window).scrollTop() < Index_object_instagram_main_new ? $("body").hasClass("faq_box_fixed") == !1 && $("body").addClass("faq_box_fixed") : $("body").removeClass("faq_box_fixed"), $(window).scrollTop() > Index_object_instagram_main_new ? $("body").hasClass("faq_box_fixed_bottom") == !1 && ($("body").addClass("faq_box_fixed_bottom"), $(".Page_FAQs_left_side_detail_inner_new").css("top", Page_FAQs_left_side_detail_static_new + "px")) : ($("body").removeClass("faq_box_fixed_bottom"), $(".Page_FAQs_left_side_detail_inner_new").css("top", ""))
    })
}
$('a[href^="#"].Page_FAQs_left_side_detail_static_innerloop_innerboxs_new').click(function(event) {
        var width2 = $(document).width();
        if (width2 < 989) {
            var target2 = $($(this).attr("href")),
                targetHash = this.hash;
            target2.length && (event.preventDefault(), $("html, body").stop().animate({
                scrollTop: target2.offset().top - 100
            }, 500))
        } else {
            var target2 = $($(this).attr("href")),
                targetHash = this.hash;
            target2.length && (event.preventDefault(), $("html, body").stop().animate({
                scrollTop: target2.offset().top - 120
            }, 500))
        }
    }), $(".tabs_collection_new").click(function() {
        var tab_id = $(this).attr("tab_id");
        $(this).hasClass("active") == !1 && ($(this).parents(".tabs_collection_main_new").find(".tabs_collection_new").removeClass("active"), $(this).parents(".tabs_collection_main_new").find(".tabcontent").css("display", "none"), $(this).addClass("active"), $(this).parents(".tabs_collection_main_new").find("." + tab_id + "_open").css("display", "block"));
        var width2 = $(window).width();
        $(this).parent(".tab").css("display", "none"), $(this).parent().parent(".Page_FAQs_left_side_detail_static_innerloop_new .tab_title_main_new").removeClass("open");
        var selected_tab_name = $(this).html();
        $(this).parent().parent().find(".tab_title_mobile_inner_new").html(selected_tab_name)
    }), $(".FAQs_tab_title_new").on("click", function() {
        var width2 = $(window).width();
        console.log(width2), $(this).parent().toggleClass("open"), $(this).parent().hasClass("open") == !0 ? $(this).next(".tab").css("display", "block") : $(this).next(".tab").css("display", "none")
    }), $(document).ready(function() {
        $(".Page_video_topic_sticky_tab_text").eq(1).addClass("active"), $(".Page_video_topic_sticky_tab_text").on("click", function() {
            $("html, body").animate({
                scrollTop: $(".Page_video_card_popup_tab_main").offset().top
            }, 500), $(this).addClass("active").siblings().removeClass("active");
            var data_tab = $(this).attr("data-tab");
            $(".Page_video_card").each(function() {
                var data_video_topic = $(this).attr("data-video-topic");
                data_tab === "all_videos" ? $(".Page_video_card").show() : data_tab == data_video_topic ? $(this).show() : $(this).hide()
            })
        }), $(".Page_video_card").on("click", function() {
            var video_card_id = $(this).attr("id");
            $(".Page_video_popup").each(function() {
                var video_popup_id = $(this).attr("id");
                if (video_card_id == video_popup_id) {
                    var $popupMain = $(".Page_video_popup_main");
                    $(window).width() >= 768 && ($popupMain.data("original-parent") || $popupMain.data("original-parent", $popupMain.parent()), $popupMain.appendTo("body").css({
                        "z-index": "999999",
                        position: "fixed"
                    })), $popupMain.show(), setTimeout(function() {
                        $popupMain.addClass("popup-visible")
                    }, 10);
                    var video = $(this).find("video").get(0);
                    window.pauseAllMedia(), video.play(), $(this).show().siblings().hide(), $("body").addClass("overflow_hidden"), setTimeout(function() {
                        $("body").addClass("overlay-visible")
                    }, 10), $(window).width() < 749 ? $(".responsive_close_popup").show() : $(".responsive_close_popup").hide(), $(window).width() <= 480 ? $(".Rotate_phone").addClass("show") : $(".Rotate_phone").removeClass("show")
                }
            }), $(".Rotate_phone").on("click", function() {
                $(this).removeClass("show"), $(".Page_video_popup").css("rotate", "90deg")
            })
        }), $(".close_popup, .responsive_close_popup").on("click", function() {
            var $popupMain = $(".Page_video_popup_main");
            $(".responsive_close_popup").hide(), $(".Page_video_popup").css("rotate", "0deg"), $(".Rotate_phone").removeClass("show"), $("body").removeClass("overlay-visible"), $popupMain.removeClass("popup-visible"), setTimeout(function() {
                $("body").removeClass("overflow_hidden"), $popupMain.hide()
            }, 300), $(window).width() >= 768 && $popupMain.data("original-parent") && $popupMain.appendTo($popupMain.data("original-parent")).css({
                "z-index": "",
                position: ""
            }), $(".Page_video_popup video").each(function() {
                this.pause(), this.currentTime = 0
            })
        }), $(".responsive_sticky_tab").on("click", function() {
            $(this).siblings(".Page_video_topic_sticky_tab").show()
        }), toggleStickyTab(), $(".Page_video_topic_sticky_tab_text").on("click", function() {
            var selected_topic = $(this).find("p").text();
            $(".responsive_sticky_tab").find("p").text(selected_topic), $(window).width() <= 749 && $(this).closest(".Page_video_topic_sticky_tab").hide()
        }), $(window).on("resize", function() {
            toggleStickyTab()
        });

        function toggleStickyTab() {
            $(window).width() > 749 ? $(".Page_video_topic_sticky_tab").show() : $(".Page_video_topic_sticky_tab").hide()
        }
    }),
    function(E, y, C, o) {
        "use strict";
        var i = function t2(e2, i2) {
                return new t2.Instance(e2, i2 || {})
            },
            c = i.globalSettings = {
                scrollMinUpdateInterval: 25,
                checkFrequency: 1e3,
                pauseCheck: !1
            };
        i.defaults = {
            preventParentScroll: !1,
            forceScrollbars: !1,
            scrollStopDelay: 300,
            maxTrackSize: 95,
            minTrackSize: 5,
            draggableTracks: !0,
            autoUpdate: !0,
            classPrefix: "optiscroll-",
            wrapContent: !0,
            rtl: !1
        }, (i.Instance = function(t2, e2) {
            this.element = t2, this.settings = S(S({}, i.defaults), e2 || {}), typeof e2.rtl != "boolean" && (this.settings.rtl = E.getComputedStyle(t2).direction === "rtl"), this.cache = {}, this.init()
        }).prototype = {
            init: function() {
                var t2 = this.element,
                    e2 = this.settings,
                    i2 = !1,
                    l2 = this.scrollEl = e2.wrapContent ? u.createWrapper(t2) : t2.firstElementChild;
                T(l2, e2.classPrefix + "content", !0), T(t2, "is-enabled" + (e2.rtl ? " is-rtl" : ""), !0), this.scrollbars = {
                    v: s("v", this),
                    h: s("h", this)
                }, (w.scrollbarSpec.width || e2.forceScrollbars) && (i2 = u.hideNativeScrollbars(l2, e2.rtl)), i2 && h(this.scrollbars, "create"), w.isTouch && e2.preventParentScroll && T(t2, e2.classPrefix + "prevent", !0), this.update(), this.bind(), e2.autoUpdate && w.instances.push(this), e2.autoUpdate && !w.checkTimer && u.checkLoop()
            },
            bind: function() {
                var l2, s2, n, r, t2 = this.listeners = {},
                    e2 = this.scrollEl;
                for (var i2 in t2.scroll = (l2 = a.scroll.bind(this), s2 = c.scrollMinUpdateInterval, function() {
                        var t3 = this,
                            e3 = Date.now(),
                            i3 = arguments;
                        n && e3 < n + s2 ? (clearTimeout(r), r = setTimeout(function() {
                            n = e3, l2.apply(t3, i3)
                        }, s2)) : (n = e3, l2.apply(t3, i3))
                    }), w.isTouch && (t2.touchstart = a.touchstart.bind(this), t2.touchend = a.touchend.bind(this)), t2.mousewheel = t2.wheel = a.wheel.bind(this), t2) e2.addEventListener(i2, t2[i2], w.passiveEvent)
            },
            update: function() {
                var t2 = this.scrollEl,
                    e2 = this.cache,
                    i2 = e2.clientH,
                    l2 = t2.scrollHeight,
                    s2 = t2.clientHeight,
                    n = t2.scrollWidth,
                    r = t2.clientWidth;
                if (l2 !== e2.scrollH || s2 !== e2.clientH || n !== e2.scrollW || r !== e2.clientW) {
                    if (e2.scrollH = l2, e2.clientH = s2, e2.scrollW = n, e2.clientW = r, i2 !== o) {
                        if (l2 === 0 && s2 === 0 && !y.body.contains(this.element)) return this.destroy(), !1;
                        this.fireCustomEvent("sizechange")
                    }
                    h(this.scrollbars, "update")
                }
            },
            scrollTo: function(t2, e2, i2) {
                var l2, s2, n, r, o2 = this.cache;
                w.pauseCheck = !0, this.update(), l2 = this.scrollEl.scrollLeft, s2 = this.scrollEl.scrollTop, n = +t2, t2 === "left" && (n = 0), t2 === "right" && (n = o2.scrollW - o2.clientW), t2 === !1 && (n = l2), r = +e2, e2 === "top" && (r = 0), e2 === "bottom" && (r = o2.scrollH - o2.clientH), e2 === !1 && (r = s2), this.animateScroll(l2, n, s2, r, +i2)
            },
            scrollIntoView: function(t2, e2, i2) {
                var l2, s2, n, r, o2, c2, a2, h2, u2, p, d, f, v = this.scrollEl;
                w.pauseCheck = !0, this.update(), typeof t2 == "string" ? t2 = v.querySelector(t2) : t2.length && t2.jquery && (t2 = t2[0]), typeof i2 == "number" && (i2 = {
                    top: i2,
                    right: i2,
                    bottom: i2,
                    left: i2
                }), i2 = i2 || {}, l2 = t2.getBoundingClientRect(), s2 = v.getBoundingClientRect(), u2 = d = v.scrollLeft, p = f = v.scrollTop, a2 = u2 + l2.left - s2.left, h2 = p + l2.top - s2.top, n = a2 - (i2.left || 0), r = h2 - (i2.top || 0), n < u2 && (d = n), u2 < (o2 = a2 + l2.width - this.cache.clientW + (i2.right || 0)) && (d = o2), r < p && (f = r), p < (c2 = h2 + l2.height - this.cache.clientH + (i2.bottom || 0)) && (f = c2), this.animateScroll(u2, d, p, f, +e2)
            },
            animateScroll: function(l2, s2, n, r, o2) {
                var c2 = this,
                    a2 = this.scrollEl,
                    h2 = Date.now();
                if (s2 !== l2 || r !== n) {
                    if (o2 === 0) return a2.scrollLeft = s2, void(a2.scrollTop = r);
                    isNaN(o2) && (o2 = 15 * C.pow(C.max(C.abs(s2 - l2), C.abs(r - n)), .54)),
                        function t2() {
                            var e2 = C.min(1, (Date.now() - h2) / o2),
                                i2 = u.easingFunction(e2);
                            r !== n && (a2.scrollTop = ~~(i2 * (r - n)) + n), s2 !== l2 && (a2.scrollLeft = ~~(i2 * (s2 - l2)) + l2), c2.scrollAnimation = e2 < 1 ? E.requestAnimationFrame(t2) : null
                        }()
                }
            },
            destroy: function() {
                var t2, e2 = this,
                    i2 = this.element,
                    l2 = this.scrollEl,
                    s2 = this.listeners;
                if (this.scrollEl) {
                    for (var n in s2) l2.removeEventListener(n, s2[n]);
                    if (h(this.scrollbars, "remove"), !this.settings.contentElement) {
                        for (; t2 = l2.childNodes[0];) i2.insertBefore(t2, l2);
                        i2.removeChild(l2), this.scrollEl = null
                    }
                    T(i2, this.settings.classPrefix + "prevent", !1), T(i2, "is-enabled", !1), E.requestAnimationFrame(function() {
                        var t3 = w.instances.indexOf(e2); - 1 < t3 && w.instances.splice(t3, 1)
                    })
                }
            },
            fireCustomEvent: function(t2) {
                var e2, i2, l2 = this.cache,
                    s2 = l2.scrollH,
                    n = l2.scrollW;
                e2 = {
                    scrollbarV: S({}, l2.v),
                    scrollbarH: S({}, l2.h),
                    scrollTop: l2.v.position * s2,
                    scrollLeft: l2.h.position * n,
                    scrollBottom: (1 - l2.v.position - l2.v.size) * s2,
                    scrollRight: (1 - l2.h.position - l2.h.size) * n,
                    scrollWidth: n,
                    scrollHeight: s2,
                    clientWidth: l2.clientW,
                    clientHeight: l2.clientH
                }, typeof CustomEvent == "function" ? i2 = new CustomEvent(t2, {
                    detail: e2
                }) : (i2 = y.createEvent("CustomEvent")).initCustomEvent(t2, !1, !1, e2), this.element.dispatchEvent(i2)
            }
        };
        var t, e, a = {
                scroll: function(t2) {
                    w.pauseCheck || this.fireCustomEvent("scrollstart"), w.pauseCheck = !0, this.scrollbars.v.update(), this.scrollbars.h.update(), this.fireCustomEvent("scroll"), clearTimeout(this.cache.timerStop), this.cache.timerStop = setTimeout(a.scrollStop.bind(this), this.settings.scrollStopDelay)
                },
                touchstart: function(t2) {
                    w.pauseCheck = !1, this.scrollbars.v.update(), this.scrollbars.h.update(), a.wheel.call(this, t2)
                },
                touchend: function(t2) {
                    clearTimeout(this.cache.timerStop)
                },
                scrollStop: function() {
                    this.fireCustomEvent("scrollstop"), w.pauseCheck = !1
                },
                wheel: function(t2) {
                    var e2 = this.cache,
                        i2 = e2.v,
                        l2 = e2.h,
                        s2 = this.settings.preventParentScroll && w.isTouch;
                    E.cancelAnimationFrame(this.scrollAnimation), s2 && i2.enabled && i2.percent % 100 == 0 && (this.scrollEl.scrollTop = i2.percent ? e2.scrollH - e2.clientH - 1 : 1), s2 && l2.enabled && l2.percent % 100 == 0 && (this.scrollEl.scrollLeft = l2.percent ? e2.scrollW - e2.clientW - 1 : 1)
                }
            },
            s = function(e2, i2) {
                var r = e2 === "v",
                    l2 = i2.element,
                    o2 = i2.scrollEl,
                    c2 = i2.settings,
                    a2 = i2.cache,
                    n = a2[e2] = {},
                    t2 = r ? "H" : "W",
                    h2 = "client" + t2,
                    u2 = "scroll" + t2,
                    p = r ? "scrollTop" : "scrollLeft",
                    s2 = r ? ["top", "bottom"] : ["left", "right"],
                    d = /^(mouse|touch|pointer)/,
                    f = w.scrollbarSpec.rtl,
                    v = !1,
                    m = null,
                    g = null,
                    b = {
                        dragData: null,
                        dragStart: function(t3) {
                            t3.preventDefault();
                            var e3 = t3.touches ? t3.touches[0] : t3;
                            b.dragData = {
                                x: e3.pageX,
                                y: e3.pageY,
                                scroll: o2[p]
                            }, b.bind(!0, t3.type.match(d)[1])
                        },
                        dragMove: function(t3) {
                            var e3, i3 = t3.touches ? t3.touches[0] : t3,
                                l3 = c2.rtl && f === 1 && !r ? -1 : 1;
                            t3.preventDefault(), e3 = (r ? i3.pageY - b.dragData.y : i3.pageX - b.dragData.x) / a2[h2], o2[p] = b.dragData.scroll + e3 * a2[u2] * l3
                        },
                        dragEnd: function(t3) {
                            b.dragData = null, b.bind(!1, t3.type.match(d)[1])
                        },
                        bind: function(t3, e3) {
                            var i3 = (t3 ? "add" : "remove") + "EventListener",
                                l3 = e3 + "move",
                                s3 = e3 + (e3 === "touch" ? "end" : "up");
                            y[i3](l3, b.dragMove), y[i3](s3, b.dragEnd), y[i3](e3 + "cancel", b.dragEnd)
                        }
                    };
                return {
                    toggle: function(t3) {
                        v = t3, g && T(l2, "has-" + e2 + "track", v), n.enabled = v
                    },
                    create: function() {
                        m = y.createElement("div"), g = y.createElement("b"), m.className = c2.classPrefix + e2, g.className = c2.classPrefix + e2 + "track", m.appendChild(g), l2.appendChild(m), c2.draggableTracks && (E.PointerEvent ? ["pointerdown"] : ["touchstart", "mousedown"]).forEach(function(t3) {
                            g.addEventListener(t3, b.dragStart)
                        })
                    },
                    update: function() {
                        var t3, e3, i3, l3, s3;
                        (v || a2[h2] !== a2[u2]) && (t3 = (i3 = this.calc()).size, e3 = n.size, l3 = 1 / t3 * i3.position * 100, s3 = C.abs(i3.position - (n.position || 0)) * a2[h2], t3 === 1 && v && this.toggle(!1), t3 < 1 && !v && this.toggle(!0), g && v && this.style(l3, s3, t3, e3), n = S(n, i3), v && this.fireEdgeEv())
                    },
                    style: function(t3, e3, i3, l3) {
                        i3 !== l3 && (g.style[r ? "height" : "width"] = 100 * i3 + "%", c2.rtl && !r && (g.style.marginRight = 100 * (1 - i3) + "%")), g.style[w.cssTransform] = "translate(" + (r ? "0%," + t3 + "%" : t3 + "%,0%") + ")"
                    },
                    calc: function() {
                        var t3, e3 = o2[p],
                            i3 = a2[h2],
                            l3 = a2[u2],
                            s3 = i3 / l3,
                            n2 = l3 - i3;
                        return 1 <= s3 || !l3 ? {
                            position: 0,
                            size: 1,
                            percent: 0
                        } : (!r && c2.rtl && f && (e3 = n2 - e3 * f), t3 = 100 * e3 / n2, e3 <= 1 && (t3 = 0), n2 - 1 <= e3 && (t3 = 100), s3 = C.max(s3, c2.minTrackSize / 100), {
                            position: t3 / 100 * (1 - (s3 = C.min(s3, c2.maxTrackSize / 100))),
                            size: s3,
                            percent: t3
                        })
                    },
                    fireEdgeEv: function() {
                        var t3 = n.percent;
                        n.was !== t3 && t3 % 100 == 0 && (i2.fireCustomEvent("scrollreachedge"), i2.fireCustomEvent("scrollreach" + s2[t3 / 100])), n.was = t3
                    },
                    remove: function() {
                        this.toggle(!1), m && (m.parentNode.removeChild(m), m = null)
                    }
                }
            },
            u = {
                hideNativeScrollbars: function(t2, e2) {
                    var i2 = w.scrollbarSpec.width,
                        l2 = t2.style;
                    if (i2 === 0) {
                        var s2 = Date.now();
                        return t2.setAttribute("data-scroll", s2), u.addCssRule('[data-scroll="' + s2 + '"]::-webkit-scrollbar', "display:none;width:0;height:0;")
                    }
                    return l2[e2 ? "left" : "right"] = -i2 + "px", l2.bottom = -i2 + "px", !0
                },
                addCssRule: function(t2, e2) {
                    var i2 = y.getElementById("scroll-sheet");
                    i2 || ((i2 = y.createElement("style")).id = "scroll-sheet", i2.appendChild(y.createTextNode("")), y.head.appendChild(i2));
                    try {
                        return i2.sheet.insertRule(t2 + " {" + e2 + "}", 0), !0
                    } catch {
                        return
                    }
                },
                createWrapper: function(t2, e2) {
                    for (var i2, l2 = y.createElement("div"); i2 = t2.childNodes[0];) l2.appendChild(i2);
                    return t2.appendChild(l2)
                },
                checkLoop: function() {
                    w.instances.length ? (w.pauseCheck || h(w.instances, "update"), c.checkFrequency && (w.checkTimer = setTimeout(function() {
                        u.checkLoop()
                    }, c.checkFrequency))) : w.checkTimer = null
                },
                easingFunction: function(t2) {
                    return --t2 * t2 * t2 + 1
                }
            },
            w = i.G = {
                isTouch: "ontouchstart" in E,
                cssTransition: l("transition"),
                cssTransform: l("transform"),
                scrollbarSpec: function() {
                    var t2, e2, i2 = y.documentElement,
                        l2 = 0,
                        s2 = 1;
                    return (t2 = y.createElement("div")).style.cssText = "overflow:scroll;width:50px;height:50px;position:absolute;left:-100px;direction:rtl", (e2 = y.createElement("div")).style.cssText = "width:100px;height:100px", t2.appendChild(e2), i2.appendChild(t2), l2 = t2.offsetWidth - t2.clientWidth, 0 < t2.scrollLeft ? s2 = 0 : (t2.scrollLeft = 1, t2.scrollLeft === 0 && (s2 = -1)), i2.removeChild(t2), {
                        width: l2,
                        rtl: s2
                    }
                }(),
                passiveEvent: (t = !1, e = Object.defineProperty({}, "passive", {
                    get: function() {
                        t = !0
                    }
                }), E.addEventListener("test", null, e), !!t && {
                    capture: !1,
                    passive: !0
                }),
                instances: [],
                checkTimer: null,
                pauseCheck: !1
            };

        function l(t2) {
            var e2 = t2.charAt(0).toUpperCase() + t2.slice(1),
                i2 = y.createElement("test"),
                l2 = [t2, "Webkit" + e2];
            for (var s2 in l2)
                if (i2.style[l2[s2]] !== o) return l2[s2];
            return ""
        }

        function T(t2, e2, i2) {
            var l2 = t2.className.split(/\s+/),
                s2 = l2.indexOf(e2);
            i2 ? ~s2 || l2.push(e2) : ~s2 && l2.splice(s2, 1), t2.className = l2.join(" ")
        }

        function S(t2, e2, i2) {
            for (var l2 in e2) !e2.hasOwnProperty(l2) || t2[l2] !== o && i2 || (t2[l2] = e2[l2]);
            return t2
        }

        function h(t2, e2, i2) {
            var l2, s2;
            if (t2.length)
                for (l2 = 0, s2 = t2.length; l2 < s2; l2++) t2[l2][e2].apply(t2[l2], i2);
            else
                for (l2 in t2) t2[l2][e2].apply(t2[l2], i2)
        }
        typeof define == "function" && define.amd && define(function() {
            return i
        }), typeof module < "u" && module.exports && (module.exports = i), E.Optiscroll = i
    }(window, document, Math),
    function(n) {
        var r = "optiscroll";
        n.fn[r] = function(i) {
            var l, s;
            return typeof i == "string" && (s = Array.prototype.slice.call(arguments), l = s.shift()), this.each(function() {
                var t = n(this),
                    e = t.data(r);
                e ? e && typeof l == "string" && (e[l].apply(e, s), l === "destroy" && t.removeData(r)) : (e = new window.Optiscroll(this, i || {}), t.data(r, e))
            })
        }
    }(jQuery || Zepto), $(".optiscroll").optiscroll({
        forceScrollbars: !0
    }), $(".flip_column_section_colbtn").click(function() {
        $(this).parents(".flip_column_section_image_wrap").addClass("active")
    }), $(".flip_column_section_back_colcontent_btn_label").click(function() {
        $(this).parents(".flip_column_section_image_wrap").removeClass("active")
    }), equalheight = function(container) {
        var currentTallest = 0,
            currentRowStart = 0,
            rowDivs = new Array,
            $el2, topPosition = 0;
        $(container).each(function() {
            if ($el2 = $(this), $($el2).height("auto"), topPostion = $el2.position().top, currentRowStart != topPostion) {
                for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) rowDivs[currentDiv].height(currentTallest);
                rowDivs.length = 0, currentRowStart = topPostion, currentTallest = $el2.outerHeight(), rowDivs.push($el2)
            } else rowDivs.push($el2), currentTallest = currentTallest < $el2.outerHeight() ? $el2.outerHeight() : currentTallest;
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) rowDivs[currentDiv].height(currentTallest)
        })
    }, $(window).on("load resize", function() {
        equalheight(".Review_object_real_results_main_new .metafield-rich_text_field p")
    });
//# sourceMappingURL=/cdn/shop/t/121/assets/custom.js.map?v=80075477180356627961749731588